// This file is the source of truth for translations.
// Use `yarn workspace @mirage/main gen-i18n` to update the JSON file.
// Do not manually modify any of the `[locale].json` files.

import type { TransObjShape } from "@mirage/translations/types";

export default {
  app_name: {
    message: "Dropbox Dash",
    description: "App name",
  },
  show_dash: {
    message: "Show Dash",
    description: "menu item to show Dash",
  },
  hide_dash: {
    message: "Hide Dash",
    description: "menu item to hide Dash",
  },
  quit_dash: {
    message: "Quit Dash",
    description: "menu item to quit Dash",
  },
  open_launcher: {
    message: "Open launcher",
    description: "menu item to show Dash",
  },
  close_launcher: {
    message: "Close launcher",
    description: "menu item to show Dash",
  },
  check_for_updates: {
    message: "Check for updates",
    description: "menu item to check for updates",
  },
  get_app_subtitle: {
    message: "Get the Dropbox Dash app",
    description: "subtitle for downloading dash app",
  },
  get_app_cta: {
    message: "Use app",
    description: "button cta for downloading dash app",
  },
  company_logo_alt: {
    message: "Company Logo",
    description: "Alt text for custom company logo if it exists",
  },
  guest_label: {
    message: "Guest",
    description: "Label used to identify attendee guests for a calendar event",
  },
  host_label: {
    message: "Host",
    description: "Label used to identify the creator of a calendar event",
  },
  relative_time_label: {
    message: "When",
    description:
      "Label used to identify the relative time of a calendar event, (ex. in 3 hours)",
  },
  navigate_to_settings: {
    message: "Settings",
    description: "Menu takes user to in app settings page",
  },
  features: {
    message: "Features",
    description: "menu item for the dev submenu",
  },
  developer: {
    message: "Developer",
    description: "menu item for the dev submenu",
  },
  toggle_product_analytics_log: {
    message: "Toggle Product Analytics Log",
    description: "menu item to toggle product analytics log",
  },
  package_log_files: {
    message: "Export Log Files",
    description: "menu item to export log files",
  },
  update_not_available_title: {
    message: "Application up to date",
    description: "toast message when no updates are available",
  },
  update_not_available_body: {
    message: "No updates available",
    description: "toast message when no updates are available",
  },
  update_available_title: {
    message: "Update available",
    description: "toast message when updates are available",
  },
  update_available_body: {
    message: "Updating to latest version",
    description: "toast message when updates are available",
  },
  login_authenticating_error: {
    message: "Unfortunately, we ran into an error with authentication",
    description: "Status displayed to user after error authenticating",
  },
  login_networking_error: {
    message: "Unfortunately, we ran into an error with networking",
    description: "Status displayed to user after having a networking error",
  },
  local_file_settings_preferences_section: {
    message: "Preferences",
    description: "Local file settings preferences section header",
  },
  local_file_settings_system_section: {
    message: "System folders",
    description: "Local file settings system folders section header",
  },
  local_file_settings_user_section: {
    message: "User folders",
    description: "Local file settings user folders section header",
  },
  local_file_add_user_folder: {
    message: "Add folder",
    description: "Remove button text for local file user folders",
  },
  local_file_remove_user_folder: {
    message: "Remove",
    description: "Remove button text for local file user folders",
  },
  local_file_permission_denied: {
    message:
      "Permission to access {{directory}} denied. Please go to ‘System Preferences > Security & Privacy > Files and Folders’ to enable access.",
    description: "Toast message when a user doesn't have access to a directory",
  },
  enable_node_inspector: {
    message: "Node Inspector",
    description: "the menu item that toggles the node inspector for debugging",
  },
  search_prompt: {
    message: "Search your content",
    description: "Placeholder text for the search input text box",
  },
  search_placeholder_default_with_tab: {
    message:
      "Search your content<tabTag><arrowTag>⇥</arrowTag>{{tab}}</tabTag>",
    description: "Default text for placeholder with tab hint",
  },
  suggested_result_cta: {
    message: "See all results",
    description: "CTA for the suggested query results row",
  },
  suggested_result_cta_content_type_files: {
    message: "See all {{contentType}} files",
    description:
      "CTA for the suggested query results row, alternative content-type partial",
  },
  suggested_result_cta_content_type: {
    message: "See all {{contentType}}s",
    description:
      "CTA for the suggested query results row, content-type partial",
  },
  suggested_result_cta_connectors: {
    message: "in {{joinedConnectors}}",
    description: "CTA for the suggested query results row, connectors partial",
  },
  suggested_result_cta_connectors_end: {
    message: ", and {{singularConnector}}",
    description:
      "CTA for the suggested query results row, ending connectors translation",
  },
  suggested_result_cta_person: {
    message: "updated by {{person}}",
    description: "CTA for the suggested query results row, person partial",
  },
  suggested_result_cta_last_updated: {
    message: "from the {{lastUpdated}}",
    description:
      "CTA for the suggested query results row, last-updated partial",
  },
  search_dash_byline: {
    message: "Search Dash",
    description: "Placeholder text for the search input text box",
  },
  math_calculation_byline: {
    message: "Calculator",
    description: "subtitle text for math result in typeahead",
  },
  search_filter_result_byline: {
    message: "Search filter",
    description: "Subtitle text for search filters results in typeahead",
  },
  connected_apps_indicator_tooltip: {
    message: "Explore all apps you can search",
    description:
      "Tooltip when hovering over the connected apps indicator in the search field",
  },
  loading: {
    message: "Loading...",
    description: "Generic text for when something is loading",
  },
  search_timed_out: {
    message: "Couldn’t reach Dash",
    description: "Error message shown when a search times out",
  },
  no_search_results_title: {
    message: "We didn’t find any matches",
    description:
      "User message to indicate that search did not return any results",
  },
  no_connector_search_results_text: {
    message: "We didn’t find any apps",
    description: "User message to indicate that there were no apps found",
  },
  no_search_results_subtitle: {
    message: "Try different keywords.",
    description:
      "User message to indicate that a keyword search without any filters did not return any results",
  },
  no_search_results_with_filters_subtitle: {
    message: "Try different keywords or clear filters.",
    description:
      "User message to indicate that a search with filters did not return any results",
  },
  no_stacks_search_results_subtitle: {
    message: "Try changing keywords to get better results",
    description:
      "User message to indicate that search did not return any results",
  },
  clear_all_filters: {
    message: "Clear all filters",
    description: "Button text to clear all filters",
  },
  calendar_empty_text: {
    message: "Your day is clear",
    description:
      "Text indicating that the user has no more meetings for the day",
  },
  home: {
    message: "Home",
    description: "Label for the homepage",
  },
  ask: {
    message: "Ask",
    description: "Label for ask",
  },
  stacks: {
    message: "Stacks",
    description: "Label for stacks",
  },
  pinned: {
    message: "Pinned",
    description: "Label for pinned stacks",
  },
  pinned_stacks: {
    message: "Pinned stacks",
    description: "Label for pinned stacks",
  },
  unpin: {
    message: "Unpin",
    description: "Button tooltip for unpinning a stack",
  },
  sections: {
    message: "Sections",
    description: "Title for stack sections card",
  },
  sections_subtitle: {
    message: "Create sections to organize your stacks",
    description: "Subtitle description for sections card",
  },
  add_section: {
    message: "Add section",
    description: "Label to create a new section",
  },
  stack_item_already_exists: {
    message: "Item already exists in stack",
    description:
      "Notification message for item already existing in a stack when trying to add an item",
  },
  stack_item_already_exists_warning_modal_body: {
    message:
      "The link <strong>{{url}}</strong> already exists in this stack, would you still like to add to the stack?",
    description:
      "Body for the modal that appears when trying to add an item that already exists in the stack",
  },
  adding_stack_item: {
    message: "Adding item to stack",
    description: "Notification message for adding new item to a stack",
  },
  stack_item_added: {
    message: "Item added to stack",
    description: "Notification message for new item added to a stack",
  },
  failed_to_add_stack_item: {
    message: "Failed to add item to stack",
    description:
      "Notification message for failing to add a new item added to a stack",
  },
  failed_to_action_stack: {
    message: "Failed to {{action}} stack",
    description:
      "Notification message for failing to perform an action on a stack",
  },
  add_a_section: {
    message: "Add a section",
    description: "Tooltip to create a new section",
  },
  create: {
    message: "Create",
    description: "Label to create a new entity",
  },
  new_stack_item_added: {
    message: "New stack item added.",
    description: "Snackbar text showing new stack item has been added",
  },
  open_in_new_tab: {
    message: "Open link in new tab",
    description: "Tooltip text to open the link in a new tab",
  },
  paste_a_link: {
    message: "Paste a link",
    description:
      "Placeholder text to ask user to paste a link into the text input",
  },
  search_link_placeholder: {
    message: "Search for a file, doc, or link",
    description:
      "Placeholder text to ask user to enter search text to find links to add",
  },
  search_item_placeholder: {
    message: "Search or paste a link",
    description:
      "Placeholder text to ask user to enter search text to find items to add",
  },
  icon_for_item: {
    message: "Icon for item",
    description: "Tooltip for a stack item’s icon",
  },
  icon_for_dropbox: {
    message: "Icon for Dropbox",
    description: "Tooltip for Dropbox icon",
  },
  icon_for_search: {
    message: "Icon for Search",
    description: "Tooltip for Search icon",
  },
  recent: {
    message: "Recent",
    description: "Label for recent stacks",
  },
  page_not_found: {
    message: "Hmmm, that page does not exist…",
    description: "Message to show user when a requested page does not exist",
  },
  signin_cta: {
    message: "Sign in with Dropbox",
    description: "Label for the sign in button",
  },
  sign_out: {
    message: "Sign out",
    description: "Label for the sign out button",
  },
  sign_in: {
    message: "Sign in",
    description: "Label for the sign in page",
  },
  no_meetings_syncing: {
    message: "Syncing... Just a few seconds left",
    description:
      "Message when we have no meetings and are waiting for the calendar connectors to sync",
  },
  no_meetings_loading: {
    message: "Loading... Just a moment",
    description:
      "Message when we have no meetings and are waiting for the app to retrieve the data",
  },
  no_meetings_all_done: {
    message: "All done!",
    description: "Message when no more meetings are present in the day",
  },
  no_meetings_breaktime: {
    message: "Time for a break.",
    description: "Message when no more meetings are present in the day",
  },
  all_day_events_one: {
    message: "{{count}} all day event",
    description: "The number of all day events to view",
  },
  all_day_events_few: {
    message: "{{count}} all day events",
    description: "The number of all day events to view",
  },
  all_day_events_many: {
    message: "{{count}} all day events",
    description: "The number of all day events to view",
  },
  all_day_events_other: {
    message: "{{count}} all day events",
    description: "The number of all day events to view",
  },
  show_all_day_events: {
    message: "Show all day events",
    description: "Button tooltip text to show the user's all day events",
  },
  hide_all_day_events: {
    message: "Hide all day events",
    description: "Button tooltip text to show the user's all day events",
  },
  up_next: {
    message: "Up next",
    description: "Title for the calendar module",
  },
  upcoming_meetings: {
    message: "Upcoming Meetings",
    description: "Text for upcoming meetings on the meeting module",
  },
  upcoming_events: {
    message: "Upcoming events",
    description: "Text for upcoming events on the calendar module",
  },
  open_calendar: {
    message: "Open calendar",
    description:
      "Button text for viewing a calendar or calendar event in the calendar app",
  },
  join_meeting: {
    message: "Join meeting",
    description: "Button text for opening a meeting link",
  },
  join_meeting_short: {
    message: "Join",
    description: "Button text for opening a meeting link",
  },
  morning: {
    message: "morning",
    description: "Label for the morning time of day",
  },
  afternoon: {
    message: "afternoon",
    description: "Label for the afternoon time of day",
  },
  evening: {
    message: "evening",
    description: "Label for the evening time of day",
  },
  now: {
    message: "Now",
    description: "Label for the current time",
  },
  today: {
    message: "Today",
    description: "Label for the current day",
  },
  yesterday: {
    message: "Yesterday",
    description: "Label for the previous day",
  },
  previous_30_days: {
    message: "Previous 30 Days",
    description: "Label for the previous 30 days",
  },
  older_than_30_days: {
    message: "Older sessions",
    description: "Label for the previous 30 days",
  },
  hour_until: {
    message: "in {{hours}} hour",
    description: "One hour until a meeting",
  },
  hours_until: {
    message: "in {{hours}} hours",
    description: "Hours until a meeting",
  },
  hour_and_minutes_until: {
    message: "in {{hours}} hour {{minutes}} min",
    description: "One hour and minutes until a meeting",
  },
  hours_and_minutes_until: {
    message: "in {{hours}} hours {{minutes}} min",
    description: "Hours and minutes until a meeting",
  },
  minutes_until: {
    message: "in {{minutes}} min",
    description: "Minutes until a meeting",
  },
  hour_ago: {
    message: "{{hours}} hour ago",
    description: "One hour since a meeting started",
  },
  hours_ago: {
    message: "{{hours}} hours ago",
    description: "Hours since a meeting started",
  },
  hour_and_minutes_ago: {
    message: "{{hours}} hour {{minutes}} min ago",
    description: "One hours and minutes since a meeting started",
  },
  hours_and_minutes_ago: {
    message: "{{hours}} hours {{minutes}} min ago",
    description: "Hours and minutes since a meeting started",
  },
  minutes_ago: {
    message: "{{minutes}} min ago",
    description: "Minutes since a meeting started",
  },
  all_day: {
    message: "All day, {{day}}",
    description: "Text for an all day event",
  },
  all_day_multi_day: {
    message: "All day, {{start}} - {{end}}",
    description: "Text for an all day event that spans multiple days",
  },
  meeting_times: {
    message: "{{startTime}} - {{endTime}}",
    description: "Button text for opening a meeting link",
  },
  updated_less_than_one_minute: {
    message: "Updated less than one minute ago",
    description: "Message for time elapsed",
  },
  updated_minutes_ago_one: {
    message: "Updated {{count}} minute ago",
    description: "Message for time elapsed",
  },
  updated_minutes_ago_other: {
    message: "Updated {{count}} minutes ago",
    description: "Message for time elapsed",
  },
  updated_hours_ago_one: {
    message: "Updated {{count}} hour ago",
    description: "Message for time elapsed",
  },
  updated_hours_ago_few: {
    message: "Updated {{count}} hours ago",
    description: "Message for time elapsed",
  },
  updated_hours_ago_many: {
    message: "Updated {{count}} hours ago",
    description: "Message for time elapsed",
  },
  updated_hours_ago_other: {
    message: "Updated {{count}} hours ago",
    description: "Message for time elapsed",
  },
  updated_days_ago_one: {
    message: "Updated {{count}} day ago",
    description: "Message for time elapsed",
  },
  updated_days_ago_few: {
    message: "Updated {{count}} days ago",
    description: "Message for time elapsed",
  },
  updated_days_ago_many: {
    message: "Updated {{count}} days ago",
    description: "Message for time elapsed",
  },
  updated_days_ago_other: {
    message: "Updated {{count}} days ago",
    description: "Message for time elapsed",
  },
  updated_ago: {
    message: "Updated {{timeAgo}}",
    description: "Message for time elapsed",
  },
  accessed_ago: {
    message: "Accessed {{timeAgo}}",
    description: "Message for time elapsed",
  },
  time_label: {
    message: "Time",
    description: "Label for meeting time",
  },
  only_you: {
    message: "Only you",
    description:
      "Text indicating that the user is the only person with access to this stack.",
  },
  shared_with_you_two_people: {
    message: "Shared with you & {{otherMemberName}}",
    description: "Text enumerating two members on a stack.",
  },
  shared_with_you_one_person: {
    message: "Shared with {{otherMemberName}} & one other",
    description: "Text enumerating all of the members on a stack.",
  },
  shared_with_you_n_people: {
    message: "Shared with {{otherMemberName}} & {{numOthers}} others",
    description: "Text enumerating all of the members on a stack.",
  },
  shared_with: {
    message: "Shared with {{name}}",
    description: "Text indicating who a stack was just shared with",
  },
  undo: {
    message: "Undo",
    description: "Button text for undoing an action.",
  },
  all_stacks: {
    message: "All stacks",
    description: "text for the filter chip allowing the user to filter stacks",
  },
  shared_with_me: {
    message: "Shared with me",
    description: "text for the filter chip allowing the user to filter stacks",
  },
  my_stacks: {
    message: "My stacks",
    description: "text for the filter chip allowing the user to filter stacks",
  },
  archived: {
    message: "Archived",
    description:
      "Text for the filter chip allowing the user to filter stacks and only show the archived ones",
  },
  created_by: {
    message: "Created by {{name}}",
    description:
      "Text label shown before the owner chip in a stack header subtitle",
  },
  created_by_with_avatar: {
    message: "Created by <avatar>{{initials}}</avatar>{{name}}",
    description:
      "Text label shown before the owner chip in a stack header subtitle",
  },
  avatar_alt_text: {
    message: "Profile image for {{name}}",
    description: "Alt text for an avatar",
  },
  created_by_dropbox_dash: {
    message: "Created for you by Dropbox Dash",
    description:
      "Text label shown in a stack header subtitle when the stack is a welcome stack",
  },
  back: {
    message: "Back",
    description:
      "Button shown on top of a full screen view of a stack allowing the user to th return to the list of stacks",
  },
  change_stack_icon: {
    message: "Change stack icon",
    description:
      "Tooltip text for trigger to change the stack icon to an emoji",
  },
  copy_link: {
    message: "Copy link",
    description: "Text for copying a sharing link of a stack or stack item.",
  },
  add_result_to_cart: {
    message: "Select search result",
    description: "Text for adding a stack item to sources for chat",
  },
  remove_result_from_cart: {
    message: "Remove from cart",
    description: "Text for adding a stack item to sources for chat",
  },
  add_to_sources_for_chat: {
    message: "Add to sources for chat",
    description: "Text for adding a stack item to sources for chat",
  },
  remove_source_for_chat: {
    message: "Remove from sources for chat",
    description: "Text for adding a stack item to sources for chat",
  },
  shopping_cart_results_count_single: {
    message: "{{count}} result added",
    description: "Text for the number of results in the shopping cart",
  },
  shopping_cart_results_count_plural: {
    message: "{{count}} results added",
    description: "Text for the number of results in the shopping cart",
  },
  shopping_cart_clear: {
    message: "Clear",
    description: "Text for clearing the shopping cart",
  },
  shopping_cart_selected: {
    message: "Selected",
    description: "Text for the number of selected items in the shopping cart",
  },
  summarizable_reason_yes_summarizable: {
    message: "Summarize and ask",
    description: "Text for asking Dash to summarize a Summarizable Result",
  },
  summarizable_reason_not_available: {
    message: "Summarize not available",
    description: "Tooltip for disabled summarize button",
  },
  summarizable_reason_not_summarizable_branded_type: {
    message: "We can’t support this type of content yet",
    description: "Tooltip for disabled summarize button",
  },
  summarizable_reason_not_summarizable_mime_type: {
    message: "We can’t support this type of content yet",
    description: "Tooltip for disabled summarize button",
  },
  summarizable_reason_not_summarizable_body_missing_unsupported: {
    message: "We’re still working on processing this, come back soon",
    description: "Tooltip for disabled summarize button",
  },
  summarizable_reason_not_summarizable_body_missing_skipped: {
    message: "We’re still working on processing this, come back soon",
    description: "Tooltip for disabled summarize button",
  },
  summarizable_reason_not_summarizable_body_missing_empty_file: {
    message: "No content to summarize here",
    description: "Tooltip for disabled summarize button",
  },
  summarizable_reason_not_summarizable_body_missing_processing_failure: {
    message: "Sorry we couldn’t summarize this right now",
    description: "Tooltip for disabled summarize button",
  },
  summarizable_reason_not_summarizable_body_missing_other: {
    message: "Sorry we couldn’t summarize this right now",
    description: "Tooltip for disabled summarize button",
  },
  summarizable_reason_not_summarizable_body_missing_file_size: {
    message: "Sorry we couldn’t summarize this right now",
    description: "Tooltip for disabled summarize button",
  },
  no_documents_to_summarize: {
    message: "No documents to summarize",
    description: "Tooltip for disabled summarize button",
  },
  share: {
    message: "Share",
    description: "Tooltip text for sharing a stack.",
  },
  edit: {
    message: "Edit",
    description: "Button label that will edit the pdf file.",
  },
  pin: {
    message: "Pin",
    description: "Menu label for pinning a stack",
  },
  pin_stack: {
    message: "Pin stack",
    description: "Action button for pinning a new stack",
  },
  unpin_stack: {
    message: "Unpin stack",
    description: "Action button for pinning a new stack",
  },
  delete: {
    message: "Delete",
    description: "Button label that will delete a file.",
  },
  show_more: {
    message: "Show more",
    description: "Button label to show more elements",
  },
  search_preview_tagline: {
    message: "See more results in the full app",
    description: "Tagline for search preview",
  },
  answers_preview_tagline: {
    message: "Get answers from Dash in the app",
    description: "Tagline for answers preview",
  },
  answers_input_placeholder: {
    message: "Ask a question",
    description:
      "Placeholder for the input field in answers explicit conversation",
  },
  answers_input_placeholder_attachment: {
    message: "Ask about this content",
    description:
      "Placeholder for the input field in answers explicit conversation with an attachment",
  },
  answers_empty_title: {
    message: "Get answers about your work",
    description:
      "Title shown on the empty state of answers explicit conversation",
  },
  answers_empty_subtitle: {
    message:
      "Dash searches your connected apps to write summarized answers to your questions.",
    description:
      "Subtitle shown on the empty state of answers explicit conversation",
  },
  answers_summarize_query: {
    message: "Please summarize this.",
    description:
      "The prompt that will be shown to user for summarizing document",
  },
  answers_disclaimer_text: {
    message:
      "This experimental feature, powered by third-party AI, returns answers from the documents in your connected applications. Information quality may vary.",
    description: "Disclaimer text shown on answers",
  },
  answers_see_more: {
    message: "See more",
    description: "Label for see more button when an answer is truncated",
  },
  answers_citations_title: {
    message: "Sources",
    description: "Title for citations section",
  },
  answers_see_more_citations: {
    message: "{{count}} more sources",
    description: "Label for seeing more cited sources",
  },
  answers_follow_up_placeholder: {
    message: "Ask Dash a follow up question",
    description: "Placeholder for the follow up question input",
  },
  was_this_helpful: {
    message: "Was this helpful?",
    description: "Notice beside answer feedback buttons",
  },
  learn_more: {
    message: "Learn more",
    description: "Label for learn more",
  },
  beta: {
    message: "Beta",
    description: "Label for beta features",
  },
  network_error_title: {
    message: "Could not connect to the Internet",
    description: "Modal title when Dash is unable to connect to the network",
  },
  network_error_message: {
    message: "Please check your Internet connection and try again.",
    description: "Modal message when Dash is unable to connect to the network",
  },
  user_ineligible_title: {
    message: "Dash not available",
    description: "Modal title when user is ineligible to use Dash",
  },
  user_ineligible_message: {
    message:
      "Sorry, Dash is currently not available due to the following reason:",
    description: "Modal message when user is ineligible to use Dash",
  },
  user_ineligible_button: {
    message: "Leave Dash app",
    description: "Modal button to leave the Dash app",
  },
  answers_header_title: {
    message: "Answers",
    description: "Title shown on the header of answers card",
  },
  answers_feedback_incorrect: {
    message: "Incorrect Answer",
    description: "Option shown on answers feedback modal",
  },
  answers_feedback_incorrect_sources: {
    message: "Irrelevant Sources",
    description: "Option shown on answers feedback modal",
  },
  answers_feedback_misunderstood: {
    message: "Misunderstood My Question",
    description: "Option shown on answers feedback modal",
  },
  answers_source_logo_alt: {
    message: "{{connectorName}} logo",
    description: "Alt text for image for answer source",
  },
  answers_no_answer_title: {
    message: `We didn’t find any answers`,
    description: `Main text to display on SERP when an answer can't be found`,
  },
  answers_no_answer_byline: {
    message: `Try another question.`,
    description: `Secondary text to display on SERP when an answer can't be found`,
  },
  answers_loading_text: {
    message: `Searching {{count}} apps`,
    description: `Text to display on answers card when loading`,
  },
  customize_modal_title: {
    message: "Customize your start page",
    description: "Modal title for customizing the start page",
  },
  on: {
    message: "On",
    description: "Label to indicate some setting is turned on",
  },
  off: {
    message: "Off",
    description: "Label to indicate some setting is turned off",
  },
  toggle_setting: {
    message: "Toggle setting",
    description: "Tooltip text for a control to turn a setting on or off",
  },
  new_stack_suggestions: {
    message: "New stack Suggestions",
    description: "Title for new stack suggestions",
  },
  new_stack_suggestions_tip: {
    message: "Tip: Name your stack for suggested items",
    description:
      "Tip shown in the suggested items module when creating a new stack",
  },
  new_stack_suggestions_customize_description: {
    message:
      "Dynamically generated stacks based on the content you access and search for in Dash.",
    description: "Description for customizing the new stack suggestions",
  },
  get_started: {
    message: "Get started",
    description: "Label for get started",
  },
  ask_dash: {
    message: "Ask Dash",
    description: "Label for ask dash",
  },
  working_on_it: {
    message: "Working on it...",
    description: "Label for working on it loader",
  },
  info: {
    message: "Info",
    description: "Label for info",
  },
  copy: {
    message: "Copy",
    description: "Label for copy",
  },
  copied: {
    message: "Copied!",
    description: "Label for copied",
  },
  helpful: {
    message: "Helpful",
    description: "Label for marking something as helpful",
  },
  not_helpful: {
    message: "Not helpful",
    description: "Label for marking something as not helpful",
  },
  feedback_title: {
    message: "Feedback",
    description: "Title for providing feedback",
  },
  feedback_subtitle: {
    message:
      "Thanks for your feedback. Can you tell us more about why this wasn’t helpful?",
    description: "Subtitle for providing feedback",
  },
  feedback_other_placeholder: {
    message: "What other feedback do you have?",
    description: "Placeholder in 'other' feedback",
  },
  feedback_other_error_max_length_exceeded: {
    message: "Feedback must be less than {{maxLength}} characters",
    description: "Error message when feedback exceeds max length characters",
  },
  enter_query: {
    message: "Enter a query",
    description: "Placeholder for input field",
  },
  related_questions: {
    message: "Related questions",
    description: "Label for related questions",
  },
  cancel: {
    message: "Cancel",
    description: "Label for cancel",
  },
  show_all_sources: {
    message: "Show all sources...",
    description: "Label for show all sources button",
  },
  mention_someone: {
    message: "Mention someone",
    description: "Label for mentionable input trigger",
  },
  mention_event: {
    message: "Mention an event",
    description: "Label for mentionable input trigger",
  },
  answers_error_message: {
    message:
      "Sorry, I wasn’t able to do that for some reason, but I’m learning how to avoid mistakes like this in the future. In the meantime, you can always try again.",
    description: "Error message shown on answers conversation",
  },
  summarize_error_message: {
    message:
      "Sorry, I couldn’t summarize that document for some reason, but I’m learning how to avoid mistakes like this in the future.",
    description: "Error message shown on answers summarization",
  },
  "no_answer_message.part1": {
    message:
      "Sorry, I couldn’t find the answer to your question. I’m either still learning about your content or don’t have access to the apps required to find the answer. Try",
    description: "Part 1 of the message we show when no answer is provided",
  },
  "no_answer_message.part2": {
    message: "connecting more apps",
    description: "Part 2 of the message we show when no answer is provided",
  },
  "no_answer_message.part3": {
    message:
      "and asking again, or using the search bar to find anything I might have missed.",
    description: "Part 3 of the message we show when no answer is provided",
  },
  "no_answer_message.part4": {
    message: " I also tried to find a few items that might be helpful.",
    description: "Part 4 of the message we show when no answer is provided",
  },
  num_items_zero: {
    message: "No items",
    description: "Number of items with plurals",
  },
  num_items_one: {
    message: "{{count}} item",
    description: "Number of items with plurals",
  },
  num_items_few: {
    message: "{{count}} items",
    description: "Number of items with plurals",
  },
  num_items_many: {
    message: "{{count}} items",
    description: "Number of items with plurals",
  },
  num_items_other: {
    message: "{{count}} items",
    description: "Number of items with plurals",
  },
  num_others_one: {
    message: "{{count}} other",
    description: "Number of other items with plurals",
  },
  num_others_few: {
    message: "{{count}} others",
    description: "Number of other items with plurals",
  },
  num_others_many: {
    message: "{{count}} others",
    description: "Number of other items with plurals",
  },
  num_others_other: {
    message: "{{count}} others",
    description: "Number of other items with plurals",
  },
  num_members_zero: {
    message: "No members",
    description: "Number of members with plurals",
  },
  num_members_one: {
    message: "{{count}} member",
    description: "Number of members with plurals",
  },
  num_members_few: {
    message: "{{count}} members",
    description: "Number of members with plurals",
  },
  num_members_many: {
    message: "{{count}} members",
    description: "Number of members with plurals",
  },
  num_members_other: {
    message: "{{count}} members",
    description: "Number of members with plurals",
  },
  apps: {
    message: "Apps",
    description:
      "button user can click to view a page that displays their connected apps",
  },
  close: {
    message: "Close",
    description: "Label and/or arial label for the close button",
  },
  esc: {
    message: "Esc",
    description: "Label and/or arial label for the esc key",
  },
  try_again: {
    message: "Try again",
    description: "Label for trying an action. Again.",
  },
  collapse: {
    message: "Collapse",
    description:
      "Screen reader friendly label to indicate that the button is used to expand or collapse the sidebar",
  },
  expand: {
    message: "Expand",
    description:
      "Screen reader friendly label to indicate that the button is used to expand or collapse the sidebar",
  },
  expand_nav_aria: {
    message: "Expand navigation",
    description: "A11y label for button that expands navigation",
  },
  collapse_nav_aria: {
    message: "Collapse navigation",
    description: "A11y label for button that collapse navigation",
  },
  create_stack_modal_cancel_button: {
    message: "Cancel",
    description: "Cancel button of the create stack button",
  },
  create_stack: {
    message: "Create stack",
    description: "Label to create a new stack",
  },
  add_more: {
    message: "Add more…",
    description: "Label to add more items to a stack",
  },
  add_apps: {
    message: "Add apps",
    description: "Button text that takes the user to the connectors page",
  },
  chat_label: {
    message: "Chat",
    description: "Label for chat button",
  },
  search_label: {
    message: "Search",
    description: "Label for search button to trigger opening of search input",
  },
  search_stacks: {
    message: "Search stacks",
    description: "Placeholder text on an input field for searching stacks",
  },
  search_in_stack: {
    message: "Search for content in this stack",
    description: "Placeholder text on an input field for searching in a stack",
  },
  recent_stacks: {
    message: "Recent stacks",
    description: "Header text for showing recent stacks",
  },
  recents: {
    message: "Recents",
    description: "Header text for showing recent items",
  },
  recent_content: {
    message: "Recent Content",
    description: "Header text for showing recent items",
  },
  recent_content_customize_description: {
    message:
      "Files, docs, links, and stacks that you might find interesting based on your activity.",
    description: "Message text for showing recent items",
  },
  sort_option_label: {
    message: "Sort by",
    description: "Label for sorting menu",
  },
  sort_option_section: {
    message: "Section",
    description: "Label for sorting menu item for sections sort option",
  },
  sort_option_recent: {
    message: "Last modified",
    description:
      "Label for sorting menu item for most recent item first sort option",
  },
  sort_option_alpha: {
    message: "Name (A-Z)",
    description: "Label for sorting menu item for alphabetical sort option",
  },
  sort_option_viewed: {
    message: "Last viewed",
    description: "Label for sorting menu item for last viewed sort option",
  },
  sort_option_sorting_by: {
    message: "Sorting by",
    description:
      "Label for text showing which option is being used to sort content",
  },
  sort_option_toggle_direction: {
    message: "Toggle sort direction",
    description: "Label for button to toggle sort direction",
  },
  sort_option_clear: {
    message: "Clear sorting",
    description: "Label for button to clear sort",
  },
  filter_option_label: {
    message: "Filter by",
    description: "Label for filtering menu",
  },
  section_management_label: {
    message: "Section management - coming soon",
    description:
      "Label for section management icon in stack detail page toolbar",
  },
  density_option_grid_label: {
    message: "Grid view - coming soon",
    description:
      "Label for the grid view option in the stack detail page toolbar",
  },
  density_option_list_label: {
    message: "List view",
    description:
      "Label for the list view option in the stack detail page toolbar",
  },
  multiselect_option_label: {
    message: "Multiselect - coming soon",
    description:
      "Label for the multiselect option in the stack detail page toolbar",
  },
  stack_color_picker_color: {
    message: "{{color}}",
    description: "Label for the '{{color}}' option in stack color picker.",
  },
  stack_color_picker_unknown: {
    message: "Unknown color",
    description: "Label for an unknown color option in stack color picker.",
  },
  modal_title: {
    message: "Share “{{stackName}}”",
    description: "Share modal title",
  },
  share_this_stack: {
    message: "Share this stack",
    description:
      "Title for sharing a stack module on the full page stack screen.",
  },
  invite_someone_via_email: {
    message: "Invite someone via email",
    description: "Placeholder text in the sharing text field.",
  },
  sharing_ellipses: {
    message: "Sharing...",
    description: "Text for sharing on the sharing modal.",
  },
  sharing_typeahead_paste_hint_title: {
    message: "Did you know?",
    description: "Hint for pasting email addresses in the sharing modal.",
  },
  sharing_typeahead_paste_hint_body: {
    message:
      "You can paste multiple email addresses from an email or spreadsheet to share stacks with your team more easily.",
    description: "Hint for pasting email addresses in the sharing modal.",
  },
  suggested_collaborators: {
    message: "Suggested collaborators",
    description: "Text above the list of suggested collaborators.",
  },
  suggested_invites: {
    message: "Suggested invites",
    description: "Text above the list of suggested invites.",
  },
  invite_people: {
    message: "Invite people",
    description: "Placeholder text for the sharing search bar",
  },
  invite_form_entire_team_tooltip: {
    message: "Admins manage Dropbox and Dash\u2014their roles stay the same",
    description:
      "Text for tooltip message in invite form. Appears when users can see invite entire team checkbox.",
  },
  invite_form_entire_team_title: {
    message: "Entire team",
    description:
      "Text for title of checkbox form component that invites entire team in invite form.",
  },
  invite_form_validation_result_malformed: {
    message: "Email isn’t formatted quite right",
    description:
      "Error message for malformed email in invite form typeahead fields",
  },
  invite_form_validation_result_ineligible_for_dash_unspecified: {
    message: "Not eligible for Dash",
    description:
      "Error message for ineligible email in invite form typeahead fields",
  },
  invite_form_validation_result_team_member_already_with_dash: {
    message: "Already on your team",
    description:
      "Error message for emails that are already a Dash member in invite form typeahead fields",
  },
  invite_form_validation_result_team_member_pending_invite: {
    message: "Already invited\u2014they should join soon",
    description:
      "Error message for already invited email in invite form typeahead fields",
  },
  invite_form_validation_result_work_user_from_different_team: {
    message:
      "Already part of another team. They can join with a different email.",
    description:
      "Info message for work users from another team that can be invited in invite form typeahead fields",
  },
  invite_form_validation_result_associated_with_different_team: {
    message: "Already associated with a different team",
    description:
      "Error message for associated with another team in invite form typeahead fields",
  },
  invite_form_validation_result_paid_personal_or_trial: {
    message: "Can’t be invited to a free account",
    description:
      "Error message for paid personal or trial email in invite form typeahead fields",
  },
  invite_form_validation_result_no_invite_permission: {
    message: "You can’t invite current team members. Your admin can help.",
    description:
      "Error message for when inviter has no invite permission in invite form typeahead fields",
  },
  invite_form_validation_result_validation_error: {
    message: "Something went wrong\u2014give it another try?",
    description:
      "Error message for transient errors, like network issues, in invite form typeahead fields",
  },
  invite_form_validation_result_unspecified: {
    message: "That email won’t work here. Try another one for them?",
    description:
      "Error message for unspecified or unknown server errors in invite form typeahead fields",
  },
  invite_form_validation_result_valid_email: {
    message:
      "New members can access your Dropbox team, team folders, and other features. Manage access after they join.",
    description: "Info message for new email in invite form typeahead fields",
  },
  invite_form_validation_result_duplicate_email: {
    message: "Already on your list here",
    description:
      "Error message for duplicate email in invite form typeahead fields",
  },
  invite_form_validation_result_pending_invite: {
    message: "A different team invited them, so they can’t join this one",
    description:
      "Error message for pending invite in invite form typeahead fields",
  },
  invite_form_validation_result_already_on_another_team: {
    message: "Already on a team, so they can’t join this one",
    description:
      "Error message for already on another team in invite form typeahead fields",
  },
  invite_form_validation_result_apple_relay_email: {
    message:
      "They logged in using Apple and hid their email. Ask them to update their email and then try to invite them.",
    description:
      "Error message for apple relay email in invite form typeahead fields",
  },
  invite_form_validation_result_recoverable_user: {
    message: "Recently removed from the team",
    description:
      "Error message for recoverable user in invite form typeahead fields",
  },
  invite_pending_approval: {
    message: "Pending approval",
    description:
      "Label text denoting that an invite sent from invite modal is pending admin approval",
  },
  invite_modal_title: {
    message: "Invite people to Dash",
    description: "Title text for invite modal",
  },
  invite_button_text: {
    message: "Invite",
    description: "Button text for invite modal",
  },
  invites_sent_with_count_one: {
    message: "{{count}} invite sent",
    description:
      "Title text for partial success invite modal when there is only 1 successful invite",
  },
  invites_sent_with_count_other: {
    message: "{{count}} invites sent",
    description:
      "Title text for partial success invite modal when there are multiple successful invites",
  },
  invites_sent_one: {
    message: "Invite sent",
    description:
      "Title text for success invite modal when there is only 1 successful invite",
  },
  invites_sent_other: {
    message: "Invites sent",
    description:
      "Title text for success invite modal when there are multiple successful invites",
  },
  invites_not_sent_with_count_one: {
    message: "{{count}} invite not sent",
    description:
      "Title text for partial success invite modal when there is only 1 failed invite",
  },
  invites_not_sent_with_count_other: {
    message: "{{count}} invites not sent",
    description:
      "Title text for partial success invite modal when there are multiple failed invites",
  },
  invites_failed_error_message: {
    message: `Dash licenses weren’t added for these people. Try inviting them again.`,
    description: "Text in invite modal for failed invites",
  },
  remove_emails_until_you_have_enough_licenses: {
    message:
      "Not enough licenses for entire team and individuals. Remove some individual emails first.",
    description:
      "Text for tooltip message when invite entire team is disabled in invite modal",
  },
  optional_message: {
    message: "Optional message",
    description:
      "Label for text area allowing input of optional invite message in invite modal",
  },
  optional_message_placeholder: {
    message: "Tell everyone about Dash",
    description:
      "Placeholder text for text area allowing input of optional invite message in invite modal",
  },
  optional_message_default: {
    message: `Hey team, Dash is our approved AI-tool to help us find things faster. Accept this invite so we can try it out together.`,
    description: "Default invite message in invite modal",
  },
  members_one_only: {
    message: "<Dropdown>{{member}}</Dropdown>",
    description:
      "Caption text for checkbox in invite modal when team only contains 1 member. Text triggers a pop up menu with list team members",
  },
  members_two_only: {
    message: "<Dropdown>{{member1}} and {{member2}}</Dropdown>",
    description:
      "Caption text for checkbox in invite modal when team only contains 2 members. Text triggers a pop up menu with list team members",
  },
  members_with_remainder_one: {
    message:
      "{{member1}}, {{member2}}, and <Dropdown>{{count}} other</Dropdown>",
    description:
      "Caption text for checkbox in invite modal when team only contains 3 members. Text triggers a pop up menu with list team members",
  },
  members_with_remainder_few: {
    message:
      "{{member1}}, {{member2}}, and <Dropdown>{{count}} others</Dropdown>",
    description:
      "Caption text for checkbox in invite modal when team only contains 4 or more members. Text triggers a pop up menu with list team members",
  },
  members_with_remainder_many: {
    message:
      "{{member1}}, {{member2}}, and <Dropdown>{{count}} others</Dropdown>",
    description:
      "Caption text for checkbox in invite modal when team only contains 4 or more members. Text triggers a pop up menu with list team members",
  },
  members_with_remainder_other: {
    message:
      "{{member1}}, {{member2}}, and <Dropdown>{{count}} others</Dropdown>",
    description:
      "Caption text for checkbox in invite modal when team only contains 4 or more members. Text triggers a pop up menu with list team members",
  },
  remainder_facepile_one: {
    message: "{{count}} other",
    description:
      "Alt text for facepile avatar showing count of 1 remaining member on team",
  },
  remainder_facepile_other: {
    message: "{{count}} others",
    description:
      "Alt text for facepile avatar showing count of 2 or more remaining members on team",
  },
  team_members: {
    message: "Team members ({{count}})",
    description: "Label for dropdown list of team members in invite modal",
  },
  recent_sessions: {
    message: "Recent sessions",
    description: "Label for recent sessions in conversation assistant",
  },
  invite_modal_sending_invites_one: {
    message: "Sending {{count}} invite...",
    description: "Snackbar text for sending one invite in invite modal",
  },
  invite_modal_sending_invites_other: {
    message: "Sending {{count}} invites...",
    description: "Snackbar text for sending multiple invites in invite modal",
  },
  leave: {
    message: "Leave",
    description: "Button text for leaving a stack",
  },
  leave_stack: {
    message: "You left this stack. Returning to your stacks page...",
    description: "Snackbar text for leaving a stack",
  },
  leave_disallowed: {
    message:
      "You cannot leave this stack because you are a member of a group that grants access to it.",
    description:
      "Tooltip hint explaining why a user cannot leave a stack due to group membership",
  },
  remove: {
    message: "Remove",
    description: "Button text for removing an item from a stack",
  },
  add: {
    message: "Add",
    description: "Clickable text that allows the user to add a new item",
  },
  owner: {
    message: "Owner",
    description: "Title for the owner of a stack.",
  },
  can_edit: {
    message: "Can edit",
    description: "Menu option for sharing a stack with edit permissions.",
  },
  can_view: {
    message: "Can view",
    description: "Menu option for sharing a stack with view permissions.",
  },
  who_can_access: {
    message: "Link sharing",
    description: "Text to let users know who can access stacks or stack items.",
  },
  mismatched_permissions_warning_team: {
    message:
      "This person may still be able to edit, because the stack is set to anyone in this team with the link can edit.",
    description:
      "Tooltip text for a warning icon that displays if a shared stack member has more restrictive permissions that the global stack link.",
  },
  mismatched_permissions_warning_public: {
    message:
      "This person can still edit, because the stack is set to anyone with the link can edit.",
    description:
      "Tooltip text for a warning icon that displays if a shared stack member has more restrictive permissions that the global stack link.",
  },
  link_copied2: {
    message: "Link copied",
    description: "A message after a link is copied.",
  },
  send: {
    message: "Send",
    description: "Button text for sharing a stack with specific emails.",
  },
  account: {
    message: "Account",
    description: "Label for the user's account",
  },
  account_settings_description: {
    message: "Edit your profile, work info, language, time zone, and more.",
    description: "Description for account settings section",
  },
  manage_account: {
    message: "Manage account",
    description: "Label on button for managing the user account",
  },
  public_accesslevel: {
    message: "Public",
    description:
      "Access level for a stack or a stack item that everybody with the link can access.",
  },
  public_accesslevel_description: {
    message: "Anyone on the web can access the stack contents",
    description: "Description for the public permission.",
  },
  private_accesslevel: {
    message: "Private",
    description:
      "Access level for a stack or a stack item that only invited members can access.",
  },
  private_accesslevel_multiple_users: {
    message: "Shared",
    description:
      "Access level for a stack or a stack item that only invited members can access when there are 2 or more members on the stack.",
  },
  private_accesslevel_with_shares_description: {
    message: "Only you and people invited can access the stack contents",
    description:
      "Description for the private access level when others have been invited.",
  },
  company_accesslevel: {
    message: "Company",
    description: "Description for the company access level.",
  },
  company_accesslevel_description: {
    message: "Anyone at {{teamName}} can access the stack contents",
    description: "Description for the company access level.",
  },
  company_accesslevel_description_no_team_name: {
    message: "Anyone at your org can access the stack contents",
    description:
      "Description for the company access level with missing team name.",
  },
  failed_to_add_sharing_members: {
    message: "Failed to add one or more emails.",
    description: "Snackbar text after a stack share has one or more failures.",
  },
  failed_to_remove_sharing_member: {
    message: "Failed to remove email.",
    description: "Snackbar text after removing a member from a stack fails.",
  },
  failed_to_change_permissions: {
    message: "Failed to change permissions.",
    description:
      "Snackbar text after changing a link or user’s permissions fails.",
  },
  send_email_notification: {
    message: "Send email notification",
    description:
      "Helper text next to a toggle indicating if the user will send an email notification when sharing a stack.",
  },
  add_a_note: {
    message: "Add a note",
    description:
      "Placeholder text on a text area that will be used to send custom text when sharing a stack.",
  },
  add_a_note_optional: {
    message: "Add a note (optional)",
    description:
      "Placeholder text on a text area that will be used to send custom text when sharing a stack.",
  },
  dismiss: {
    message: "Dismiss",
    description: "Text on button to dismiss something",
  },
  feedback_received: {
    message: "Thanks for your feedback! Your responses help Dash improve.",
    description: "Text shown after user provides feedback",
  },
  feedback_failed: {
    message: "Failed to submit feedback. Please try again later.",
    description: "Text shown after feedback is unable to send",
  },
  for_you: {
    message: "For You",
    description: "Title of the for you module",
  },
  copied_answer: {
    message: "Copied answer to clipboard",
    description: "Text shown after user copies an answer",
  },
  stack_item_typeahead_subtitle_badge: {
    message: "Stacks",
    description: "Text for subtitle badge for stack items in typeahead",
  },
  add_description: {
    message: "Add a description...",
    description: "Placeholder text for adding a description to a stack item",
  },
  add_link_description: {
    message: "Add link description",
    description: "Tooltip text for adding a description to a link",
  },
  expand_link_description: {
    message: "Expand link description",
    description: "Tooltip text for expanding a description to a link",
  },
  collapse_link_description: {
    message: "Collapse link description",
    description: "Tooltip text for collapsing a description to a link",
  },
  edit_link_description: {
    message: "Edit link description",
    description: "Tooltip text for editing a description to a link",
  },
  delete_link_description: {
    message: "Delete link description",
    description: "Tooltip text for deleting a description to a link",
  },
  save_link_description: {
    message: "Save link description",
    description: "Tooltip text for saving a description to a link",
  },
  add_to_stack: {
    message: "Add to stack",
    description: "Button text for adding an item to a stack",
  },
  add_to_section: {
    message: "Add to Section",
    description: "Button text for adding an item to a section",
  },
  confirm_delete_stack_title: {
    message: "Delete this stack?",
    description:
      "Text asking the user if they are sure they want to delete the stack",
  },
  confirm_delete_stack_body: {
    message:
      "This stack, including all items and any comments, will be permanently removed.",
    description:
      "Text letting the user know that confirming the current prompt will delete this stack",
  },
  error_updating_stack_item: {
    message: "Failed to update stack item",
    description:
      "Generic error message for when the user failed to update the stack item",
  },
  error_moving_pinned_stack: {
    message: "Failed to move pinned stack",
    description:
      "Generic error message for when the user failed to move pinned stack",
  },
  stack_title_placeholder: {
    message: "First, name your stack",
    description: "The placeholder at the top of the stackview page",
  },
  new_stack_share_button_tooltip: {
    message: "Enter a stack title",
    description: "Tooltip text for the share button of a new stack",
  },
  stack_description_placeholder: {
    message: "Describe what’s inside...",
    description: "The placeholder at the top of the stackview page",
  },
  add_stack_items_button_text: {
    message: "Add items",
    description: "Button text for adding stack items",
  },
  more: {
    message: "More",
    description: "Label for more actions",
  },
  copied_link_to_clipboard: {
    message: "Link copied to clipboard.",
    description:
      "Snackbar text to indicate that a link has been successfully copied to the clipboard.",
  },
  copied_math_to_clipboard: {
    message: "Result copied to clipboard.",
    description:
      "Snackbar text to indicate that a math answer has been successfully copied to the clipboard.",
  },
  image_preview_error: {
    message: "Can‘t load preview",
    description:
      "Message shown to user when an image preview cannot be loaded.",
  },
  ocr_badge_label: {
    message: "OCR result",
    description: "Label for the OCR badge on an image",
  },
  ocr_badge_tooltip: {
    message: "Text found",
    description: "Tooltip for the OCR badge on an image",
  },
  item_deleted: {
    message: "Stack item deleted.",
    description: "Snackbar message for when a user deletes a stack item.",
  },
  save: {
    message: "Save",
    description: "Button text to save a file to Dropbox.",
  },
  stack_item_updated: {
    message: "Stack item updated.",
    description: "Snackbar shown when the user updates a stack item name.",
  },
  stack_successfully_created: {
    message: "{{stackName}} was successfully created.",
    description: "Snackbar shown when the user created a new stack.",
  },
  stack_successfully_deleted: {
    message: "The stack was successfully deleted.",
    description: "Snackbar shown when the user deletes a stack.",
  },
  stack_successfully_deleted_with_stackname: {
    message: "{{stackName}} was successfully deleted.",
    description: "Snackbar shown when the user deletes a stack.",
  },
  stack_pinned: {
    message: "Stack pinned",
    description: "Tooltip text when a stack is pinned",
  },
  stack_unpinned: {
    message: "Stack unpinned",
    description: "Tooltip text when a stack is unpinned",
  },
  rename_modal_title: {
    message: "Rename stack item",
    description: "Modal title to rename an item",
  },
  rename_stack_item_title: {
    message: "Rename title",
    description: "Menu text to rename an item",
  },
  rename_title_placeholder: {
    message: "Title",
    description: "Placeholder text while renaming a stack",
  },
  stack_query_suggestions_title: {
    message: "Suggested questions",
    description: "Title for the stack query suggestions sidebar",
  },
  stack_query_suggestions_default_query: {
    message: "Ask something...",
    description: "Default query placeholder for open ended question",
  },
  stack_query_suggestions_tooltip_title: {
    message: "Need answers?",
    description: "Title for the stack query suggestions educational tooltip",
  },
  stack_query_suggestions_tooltip_text: {
    message: "Ask anything about this stack.",
    description:
      "Description for the stack query suggestions educational tooltip",
  },
  quick_link_add_title: {
    message: "Add Quick Link",
    description: "Text for modal header for adding quick link",
  },
  quick_link_edit_title: {
    message: "Edit Quick Link",
    description: "Text for modal header for editing quick link",
  },
  quick_link_title_placeholder: {
    message: "Title",
    description: "Placeholder text while labeling a quick link",
  },
  quick_link_url_placeholder: {
    message: "URL",
    description: "Placeholder text while setting a quick link URL",
  },
  quick_link_url_invalid: {
    message: "The URL must begin with https://",
    description: "Error message for invalid URL in quick link",
  },
  untitled_stack: {
    message: "Untitled",
    description: "Default name for a new stack",
  },
  view_button: {
    message: "View",
    description: "Button label for viewing an object",
  },
  open_settings: {
    message: "Settings",
    description: "Button text for opening settings",
  },
  settings_visit_help_center: {
    message: "Help center",
    description: "Button text for visiting help center",
  },
  settings_send_feedback: {
    message: "Send feedback",
    description: "Button text for sending feedback",
  },
  settings_privacy_policy: {
    message: "Privacy policy",
    description: "Button text for visiting help center",
  },
  illegal_characters_warning: {
    message: "Special characters like /, \\, and emojis are not allowed",
    description:
      "A warning when the user enters illegal characters in the stack name",
  },
  input_too_long: {
    message: "Too many characters",
    description:
      "A warning when the user enters too many characters in the input field",
  },
  logout: {
    message: "Log out",
    description: "Button text for logging out",
  },
  logging_in_loading_message: {
    message: "Getting things ready for you…",
    description: "Status message when logging in",
  },
  continue_to_log_in: {
    message: "Continue to log in",
    description: "Continue to log in call to action on login page",
  },
  logging_in_try_again: {
    message: "Try again",
    description: "Try again button displayed to the user after a login error",
  },
  checking_for_updates: {
    message: "Checking for updates...",
    description:
      "Snackbar message when a user opts to check for updates manually",
  },
  read_only_section_tooltip: {
    message: "Only editors can add sections",
    description: "Tooltip when an editor tries to create a section",
  },
  rename_section: {
    message: "Rename section",
    description: "label for renaming a section",
  },
  remove_section: {
    message: "Remove section",
    description: "label for removing a section",
  },
  connectors_section_connected_with_counter: {
    message: "Added ({{count}})",
    description:
      "Header for the list of connections in the settings page where users can connect and disconnect apps",
  },
  connectors_section_connected: {
    message: "Added",
    description:
      "Header for the list of connections in the settings page where users can connect and disconnect apps",
  },
  connectors_section_no_connections_title: {
    message: "No apps added yet",
    description:
      "Title for page informing the user they have not connected any Dash apps yet",
  },
  connectors_section_no_connections_message: {
    message: "Add apps to access their content in Dash",
    description:
      "Message for page informing the user they have not connected any Dash apps yet",
  },
  connectors_section_popular: {
    message: "Popular",
    description:
      "Header for the list of popular connectors in the settings page where users can connect and disconnect apps",
  },
  connectors_section_all: {
    message: "All",
    description:
      "Header for the list of all available connectors in the settings page where users can connect and disconnect apps",
  },
  connected: {
    message: "Connected",
    description: "Label indicating that a connector is connected",
  },
  connect: {
    message: "Connect",
    description: "Label for a button that allows users to connect to a service",
  },
  disconnect: {
    message: "Disconnect",
    description:
      "Label for a button that allows users to disconnect from a service",
  },
  disconnect_private: {
    message: "Disconnect (private)",
    description:
      "Label for a button that allows users to disconnect a private connection from a service",
  },
  connect_app: {
    message: "Connect app",
    description:
      "Tooltip label for a button that allows users to connect to a service",
  },
  connector_loading: {
    message: "Connector loading",
    description: "Alt text for spinner indicating a connector loading",
  },
  connector_connected_title: {
    message: `You‘re all set!`,
    description: "Message indicating the connector is now set up",
  },
  connector_connected: {
    message: "You can now continue to Dash",
    description: "Message indicating to the user they can now close the window",
  },
  failed_to_connect_generic_title: {
    message: "Failed to connect",
    description:
      "Message indicating that there were errors when connecting to the connector",
  },
  failed_to_connect_generic: {
    message:
      "Something went wrong. If you believe this is an error, please contact your team admin for assistance.",
    description:
      "Error message indicating that there was something wrong when connecting the connector",
  },
  failed_to_connect_due_to_invalid_email_domain_title: {
    message: "Email not allowed",
    description: "Message indicating that the current email was not allowed",
  },
  failed_to_connect_due_to_invalid_email_domain: {
    message:
      "Adding apps with this email to Dash isn‘t permitted at your company. Please try again with a different email address.",
    description:
      "Error message indicating that the current email was not allowed",
  },
  connector_close_window: {
    message: "Close Window",
    description: "Message that let users to close the popup window",
  },
  disconnect_title: {
    message: "Disconnect {{serviceName}}",
    description: "Title displayed in the disconnect modal",
  },
  disconnect_modal_text: {
    message:
      "The {{serviceName}} account for {{userEmail}} will be disconnected. You can reconnect anytime.",
    description: "Text displayed in the disconnect modal",
  },
  disconnect_modal_text_without_email: {
    message:
      "The {{serviceName}} account will be disconnected. You can reconnect anytime.",
    description: "Text displayed in the disconnect modal",
  },
  disconnect_modal_text_for_web_extension: {
    message:
      "The {{webExtensionName}} will be removed. You can reconnect anytime.",
    description:
      "Text displayed in the disconnect modal for disconnecting web extensions",
  },
  disconnect_safari_modal_title: {
    message: "Disconnect Safari",
    description:
      "Header text displayed in the Safari-specific browser extension disconnect modal",
  },
  disconnect_safari_modal_steps_subtitle: {
    message: "Steps to take",
    description:
      "Text displayed in the disconnect modal as a subheading for the instruction steps",
  },
  disconnect_safari_modal_done_button_text: {
    message: "Done",
    description:
      "Text displayed in the disconnect modal as a done button used to dismiss the modal",
  },
  disconnect_safari_modal_step_1: {
    message: "Open Safari  <strong>Settings</strong>  <keys></keys>",
    description: "Text for step one of disconnecting the Safari extension",
  },
  disconnect_safari_modal_step_2: {
    message: "On the <strong>Extensions</strong> tab, select Dash",
    description: "Text for step two of disconnecting the Safari extension",
  },
  disconnect_safari_modal_step_3: {
    message: "<strong>Uninstall</strong>, then delete in Finder",
    description: "Text for step three of disconnecting the Safari extension",
  },
  disconnect_cancel: {
    message: "Cancel",
    description: "Label for a button that allows the user to close the modal",
  },
  disconnect_safari_modal_gif_alt_text: {
    message: "Safari instructional GIF",
    description: "Alt text for the instructional GIF image",
  },
  reauthenticate: {
    message: "Reconnect",
    description:
      "Label for a button that allows users to retry authenticating to a failing a service",
  },
  connector_status_connected: {
    message: "Connected",
    description:
      "Label letting the user know they are connected and authenticated to a service",
  },
  connector_status_sync_in_progress: {
    message: "Sync in progress...",
    description:
      "Label letting the user know their connection to this service is currently syncing data",
  },
  connector_status_sync_failed: {
    message: "Sync failed",
    description:
      "Label letting the user know their connection to this service has failed to authenticate and will require the user to reauthenticate",
  },
  connector_status_expired: {
    message: "Expired",
    description:
      "Label letting the user know their connection to this service has failed to authenticate and will require the user to reauthenticate",
  },
  connector_status_reconnecting: {
    message: "Reconnecting…",
    description:
      "Label letting the user know that a reconnection to a third party service is currently in progress",
  },
  connector_status_disconnecting: {
    message: "Disconnecting…",
    description:
      "Label letting the user know that a disconnection from a third party connector is currently in progress",
  },
  connectors_settings_browser_description: {
    message: "Search tabs and bookmarks",
    description:
      "Description for browser that can be connected to Dropbox Dash",
  },
  connectors_settings_disconnected_from_service: {
    message: "{{appName}} has been removed",
    description:
      "Notification telling the user they have successfully disconnected one of their apps, previously linked to Dash",
  },
  connectors_settings_error_disconnecting: {
    message: "{{appName}} couldn’t be removed",
    description:
      "Notification telling the user that a dash app disconnection as failed",
  },
  connector_settings_delay_notice: {
    message: "This is taking longer than expected. Please wait",
    description:
      "Notification telling the user that a dash app operating is taking longer than expected.",
  },
  connectors_settings_reconnected_from_service: {
    message: "{{appName}} has been reconnected",
    description:
      "Notification telling the user they have successfully reconnected one of their apps",
  },
  connectors_settings_error_reconnecting: {
    message: "{{appName}} couldn’t be reconnected",
    description:
      "Notification telling the user that a dash app reconnection as failed",
  },
  connectors_settings_error_reconnecting_cleanup: {
    message:
      "{{appName}} was reconnected with an issue. You may disconnect the expired account",
    description:
      "Notification telling the user that a dash app reconnection as succeeded with an error",
  },
  connectors_settings_connected_to_service: {
    message: "{{appName}} was successfully connected",
    description:
      "Notification telling the user they are connected to a dash app",
  },
  not_found_page_title: {
    message: "Page not found",
    description: "Page title for a requested page that could not be found",
  },
  not_found: {
    message: "Sorry, we could not find the page you are looking for.",
    description: "Message showing the requested page could not be found",
  },
  move_to_section: {
    message: "Move to section",
    description: "Move stack item to section",
  },
  default_section: {
    message: "Default section",
    description: "Menu item to move stack item to default section",
  },
  add_connectors: {
    message:
      "Instantly find files, docs, emails, calendar events, and more with a single search.",
    description:
      "Text on search typeahead to prompt user to add some connectors",
  },
  connect_a_calendar: {
    message:
      "Add your Google or Outlook calendar to quickly view, prepare, and join meetings.",
    description:
      "Text on card that prompts user to connect a calendar connector",
  },
  add_calendar: {
    message: "Add calendar",
    description:
      "Text on CTA that opens modal to allow user to connect a calendar",
  },
  add_your_calendar: {
    message: "Add your calendar",
    description: "Title text on modal where user can add a calendar connector",
  },
  select_calendar: {
    message: "Select the calendar you use most.",
    description:
      "Description text on on modal where user can add a calendar connector",
  },
  calendar_connection_error_connected: {
    message: "You have successfully connected Google Calendar.",
    description:
      "Success message shown when Google Calendar connection is established after a connection error",
  },
  calendar_connection_error_not_connected: {
    message: "Please connect Google Calendar to use this feature.",
    description:
      "Message shown when Google Calendar needs to be connected to use calendar features",
  },
  stacks_empty_state_title: {
    message: "No stacks created yet",
    description: "Title text on empty page when user has no stacks",
  },
  stacks_empty_state_message: {
    message:
      "Use stacks to store, discover, and share all your important resources in one location",
    description: "Message text on empty page when user has no stacks",
  },
  company_stacks_empty_state_title: {
    message: "No company stacks yet",
    description: "Title text on empty page when user has no company stacks",
  },
  company_stacks_empty_state_message: {
    message: "Company stacks shared with you will show up here",
    description: "Message text on empty page when user has no company stacks",
  },
  archived_stacks_empty_state_title: {
    message: "No archived stacks yet",
    description: "Title text on empty page when user has no archived stacks",
  },
  archived_stacks_empty_state_message: {
    message:
      "Archived stacks remain accessible and shareable but won’t send notifications or clutter your list",
    description: "Message text on empty page when user has no archived stacks",
  },
  shared_stacks_empty_state_title: {
    message: "Nothing shared with you yet",
    description: "Title text on empty page when user has no shared stacks",
  },
  shared_stacks_empty_state_message: {
    message: "Stacks shared with you will show up here",
    description: "Message text on empty page when user has no shared stacks",
  },
  aria_dismiss_icon: {
    message: "Dismiss icon",
    description: "ARIA label that describes dismiss icon",
  },
  aria_add_icon: {
    message: "Add icon {{connectorName}}",
    description: "ARIA label that describes add icon",
  },
  migration_update_title: {
    message: "Introducing Dash for Business",
    description: "Title for migration modal",
  },
  migration_update_title_chip: {
    message: "New",
    description: "New chip displayed next to introduction on migration modal",
  },
  ui_update_intro_blurb_part_1: {
    message: "Dash for Business",
    description: "App name highlighted on the temporary migration dialog",
  },
  ui_update_intro_blurb_part_2: {
    message:
      "offers powerful new features for companies that help teams effortlessly find, organize, share and secure content across work apps. While you can still use Dash for individual use, we invite you to discover what’s new.",
    description: "Temporary migration dialog text content",
  },
  acknowledge_button_cta: {
    message: "Got it",
    description: "Button text for acknowledging.",
  },
  learn_more_sunset_button_text: {
    message: "Discover Dash for Business →",
    description: "Button text for acknowledging and the sunset modal.",
  },
  last_updated_filter_title: {
    message: "Updated",
    description: "Title for last updated filter",
  },
  custom_last_updated_filter_title: {
    message: "{{labelStart}} - {{labelEnd}}",
    description: "Title for custom last updated filter",
  },
  last_updated_filter_any_date: {
    message: "Any date",
    description:
      "Filter search results to those last updated over any date range",
  },
  last_updated_filter_last_24_hours: {
    message: "Last 24 hours",
    description:
      "Filter search results to those last updated over the last 24 hours",
  },
  last_updated_filter_last_7_days: {
    message: "Last 7 days",
    description:
      "Filter search results to those last updated over the last 7 days",
  },
  last_updated_filter_last_30_days: {
    message: "Last 30 days",
    description:
      "Filter search results to those last updated over the last 30 days",
  },
  last_updated_filter_last_90_days: {
    message: "Last 90 days",
    description:
      "Filter search results to those last updated over the last 90 days",
  },
  last_updated_filter_last_12_months: {
    message: "Last 12 months",
    description:
      "Filter search results to those last updated over the last 12 months",
  },
  last_updated_filter_custom: {
    message: "Custom",
    description:
      "Filter search results to those last updated over a custom date range",
  },
  last_updated_filter_modal_title: {
    message: "Custom date range",
    description: "Select a custom date range for filtering search results",
  },
  last_updated_filter_modal_from: {
    message: "From",
    description: "Start date of custom date range",
  },
  last_updated_filter_modal_to: {
    message: "To",
    description: "End date of custom date range",
  },
  last_updated_filter_modal_cancel: {
    message: "Cancel",
    description: "Cancel selection of custom date range",
  },
  last_updated_filter_modal_apply: {
    message: "Apply",
    description: "Apply currently selected custom date range",
  },
  ask_follow_up: {
    message: "Ask a follow up...",
    description: "Text on the button to ask follow up question",
  },
  dash_premium_experience_banner_title: {
    message:
      "You’re enjoying a free trial of Dash Premium. In the coming months, you’ll need a paid plan to access these features.",
    description:
      "Message to let the user know that the free trial is coming, and for now the users can enjoy Dash Premium features for free",
  },
  open_dash_keyboard_shortcut: {
    message: "Open Dash",
    description: "Text beside the CMD + E shortcut user education banner",
  },
  typeahead_shortcut_create: {
    message: "Create",
    description: "Text beside /new typeahead shortcut user education banner",
  },
  dash_value_prop_answers: {
    message: "Search and get answers about your content",
    description: "Title text on card explaining value proposition of Dash.",
  },
  manage_cookies: {
    message: "Cookies & CCPA Preferences",
    description: "Text on menu action for manage cookies",
  },
  managed_by_admin: {
    message: "managed by admin",
    description:
      "Label letting the user know that the admin manages a given connection",
  },
  managed_by_admin_public: {
    message: "managed by admin (public)",
    description:
      "Label letting the user know that the admin manages the public connection",
  },
  email_private_label: {
    message: "{{email}} (private)",
    description:
      "Label letting the user that the connection is private e.x: 'test@email.com (private)'",
  },
  connect_private_account_banner_title: {
    message: "Search all your Slack messages?",
    description: "Title for the connect private slack account banner",
  },
  connect_private_account_banner_subtitle: {
    message:
      "Your admin already added public channels. Add DMs and private channels for you and the other people in those messages.",
    description: "Subtitle for the connect private slack account banner",
  },
  connect_private_account_banner: {
    message:
      "Add your private conversations? People who already have access in Slack will get search results too.",
    description: "Text to inform the user to connect their private account",
  },
  connect_private_account_add: {
    message: "Add",
    description: "Button text for starting the connection process",
  },
  connect_private_account_learn_more: {
    message: "Learn more",
    description: "Link text to learn more about connecting private accounts",
  },
  search_or_add_link: {
    message: "Search or add a link",
    description: "Placeholder text for adding an item to a stack",
  },
  no_search_results: {
    message: "No results for that search term",
    description: "Label text for no search results",
  },
  no_search_results_query: {
    message: "No results for “<truncate>{{query}}</truncate>”",
    description: "Label text for no search results",
  },
  clear_search: {
    message: "Clear search",
    description: "Label for clearing the search query",
  },
  clear_chat: {
    message: "Clear chat",
    description: "Label for clearing the chat",
  },
  query_suggestion_count: {
    message: "{{startIndex}} of {{endIndex}}",
    description: "Defines place within set of query suggestions",
  },
  settings_general: {
    message: "General",
    description: "tab title for the settings page",
  },
  settings_apps: {
    message: "Apps",
    description: "tab title for the settings page",
  },
  settings_hide_app_on_start: {
    message: "Show Dash on startup",
    description: "should app show on startup",
  },
  settings_show_dash_in_dock_darwin: {
    message: "Show in dock",
    description: "macos version of show in dock",
  },
  settings_show_dash_in_dock_win32: {
    message: "Show on taskbar",
    description: "windows version of show in dock",
  },
  settings_open_files_in_desktop_apps: {
    message: "Open files in desktop apps when available",
    description: "should files open in desktop apps when possible",
  },
  settings_app_to_nearest_window_darwin: {
    message: "Show on current screen (experimental)",
    description:
      "In show taskbar icon mode, app will attempt to show on any screen",
  },
  settings_app_to_nearest_window_win32: {
    message: "Show on current screen (experimental)",
    description:
      "In show dock icon mode, app will attempt to show on any screen",
  },
  settings_dash_as_new_tab: {
    message: "Dash as default new tab",
    description: "Title for settings to enable/disable Dash new tab",
  },
  settings_dash_as_new_tab_subtitle: {
    message: "New tabs open with Dash.",
    description: "Subtitle for settings to enable/disable Dash new tab",
  },
  settings_extension_action_bar: {
    message: "Quick actions",
    description: "Title for settings to enable/disable extension action bar",
  },
  settings_extension_action_bar_subtitle: {
    message:
      "Appears as a toolbar you can open to use and customize quick actions.",
    description: "Subtitle for settings to enable/disable extension action bar",
  },
  settings_notification_stack_shared: {
    message: "Notify me when someone shares a stack with me",
    description:
      "Title for setting to enable/disable a push notification when a stack is shared with the user",
  },
  settings_extension_turn_off: {
    message: "Turn off",
    description: "Label for turning off an extension setting",
  },
  settings_extension_on: {
    message: "On",
    description: "Label for a setting that is currently on",
  },
  settings_extension_off: {
    message: "Off",
    description: "Label for a setting that is currently off",
  },
  settings_keyboard_shortcuts: {
    message: "Keyboard shortcuts",
    description: "tab title for the settings page",
  },
  app_shortcut: {
    message: "Open/Hide Dash",
    description: "App shortcut label",
  },
  app_shortcut_launcher: {
    message: "Open/Hide Dash launcher",
    description: "App shortcut label",
  },
  app_shortcut_persistent: {
    message: "Open Dash persistent window",
    description: "App shortcut label",
  },
  open_persistent_app: {
    message: "Open full app",
    description: "CTA text for opening persistent desktop app",
  },
  settings_settings_shortcut_label: {
    message: "Open settings",
    description: "shortcut label for opening settings",
  },
  settings_keyboard_shortcuts_aria_for_action: {
    message: "Type a keyboard shortcut for {{label}}",
    description: "Explains what the shortcut does",
  },
  settings_keyboard_shortcuts_placeholder_type_shortcut: {
    message: "Type shortcut",
    description: "placeholder for keyboard shortcut input edit",
  },
  settings_keyboard_shortcuts_cancel: {
    message: "Cancel",
    description: "tooltip for keyboard settings cancel",
  },
  settings_keyboard_shortcuts_aria_cancel: {
    message: "Cancel editing {{label}}",
    description: "cancel editing keyboard setting",
  },
  settings_keyboard_shortcuts_editing: {
    message: "Editing keyboard shortcut for {{label}}",
    description: "used between action and shortcut",
  },
  settings_keyboard_shortcuts_edit: {
    message: "Edit",
    description: "tooltip for keyboard settings edit",
  },
  settings_keyboard_shortcuts_reset: {
    message: "Reset",
    description: "tooltip for keyboard settings reset",
  },
  settings_keyboard_shortcuts_aria_reset: {
    message: "Reset to default shortcut",
    description: "reset keyboard setting",
  },
  settings_keyboard_shortcuts_save: {
    message: "Save",
    description: "tooltip for keyboard settings save",
  },
  settings_keyboard_shortcuts_aria_save: {
    message: "Save keyboard shortcut",
    description: "aria Save shortcut",
  },
  settings_kb_error_no_valid_modifier: {
    message: "Missing modifier key",
    description: "keyboard setting error, is missing a modifier",
  },
  settings_kb_error_no_valid_char: {
    message: "Missing valid letter",
    description: "keyboard setting error, missing valid character",
  },
  settings_kb_error_reserved: {
    message: "Shortcut is reserved",
    description: "keyboard setting error, reserved shortcut",
  },
  settings_kb_error_multi_letter: {
    message: "Only one letter permitted",
    description: "keyboard setting error, only one letter",
  },
  settings_local_files: {
    message: "Local files",
    description: "tab title for the local files settings page",
  },
  settings_manage_apps: {
    message: "Open Dash settings",
    description:
      "label for the button shown in the desktop app which opens the settings page where users can manage their connectors",
  },
  settings_manage_apps_title: {
    message: "Manage apps in your browser",
    description:
      "title for describing to user in the desktop app to open settings page in web app to manage connectors",
  },
  settings_manage_apps_subtitle: {
    message: "Add or remove apps in Dash Settings on the web",
    description:
      "subtitle for describing to user in the desktop app to open settings page in web app to manage connectors",
  },
  suggestions_box_title: {
    message: "Suggestions",
    description: "Title of the suggestions box",
  },
  settings_manage_apps_icon_title: {
    message: "Laptop Icon",
    description: "Alt title of laptop icon for accessibility purposes",
  },
  disable_dash_new_tab_tooltip_graphic_alt: {
    message: "Browser extension context menu",
    description: "Alt text for the new tab graphic",
  },
  disable_dash_new_tab_tooltip_title: {
    message: "Turn off Dash as new tab",
    description:
      "Tooltip title for instructions on how to disable the Dash new tab",
  },
  disable_dash_new_tab_tooltip_step_1: {
    message: "Go to browser extensions",
    description:
      "Tooltip text for step 1 of instructions on how to disable the Dash new tab",
  },
  disable_dash_new_tab_tooltip_step_2: {
    message: "Click the 3-dot menu on Dropbox Dash",
    description:
      "Tooltip text for step 2 of instructions on how to disable the Dash new tab",
  },
  disable_dash_new_tab_tooltip_step_3: {
    message: "Click ‘Use Dash start page (ON)’ to toggle it",
    description:
      "Tooltip text for step 3 of instructions on how to disable the Dash new tab",
  },
  disable_dash_new_tab_tooltip_step_1_safari: {
    message: "Go to Safari settings.",
    description:
      "Tooltip text for step 1 of instructions on how to disable the Dash new tab",
  },
  disable_dash_new_tab_tooltip_step_2_safari: {
    message: "Select the dropdown for “new tabs open with.”",
    description:
      "Tooltip text for step 2 of instructions on how to disable the Dash new tab",
  },
  disable_dash_new_tab_tooltip_step_3_safari: {
    message: "Select your preferred option.",
    description:
      "Tooltip text for step 3 of instructions on how to disable the Dash new tab",
  },
  aria_search_result_rendered: {
    message: "Loaded search results",
    description: "ARIA live announcement for when search results have loaded",
  },
  aria_answers_question_send: {
    message: "Submit question",
    description: "ARIA button for submitting question",
  },
  aria_answers_announce_show_all_sources: {
    message: "All sources, expanded",
    description: "ARIA label for announcement all sources are shown",
  },
  aria_answers_user_query: {
    message: "User query",
    description: "ARIA label user's query in conversation",
  },
  aria_answers_system_answer: {
    message: "Answer",
    description: "ARIA label dash's answer in conversation",
  },
  aria_settings_privacy_policy: {
    message: "Open Dropbox privacy policy in a new browser tab",
    description: "ARIA text in settings for opening privacy policy",
  },
  single_step_onboarding_title: {
    message: "Let’s start by adding apps",
    description: "Title for the single step onboarding",
  },
  single_step_onboarding_subtitle: {
    message:
      "We recommend 3-5 apps for the best experience. You can always add more later.",
    description: "Subtitle for the single step onboarding",
  },
  single_step_onboarding_v2_subtitle: {
    message:
      "Search and get answers across all your apps—we recommend at least 3 for the best experience. You can always add or remove apps later.",
    description: "Subtitle for the single step onboarding",
  },
  onboarding_connectors_section_popular: {
    message: "Popular apps",
    description:
      "Header for the list of popular connectors in the onboarding page",
  },
  onboarding_connectors_section_all: {
    message: "All apps",
    description:
      "Header for the list of all available connectors in the onboarding page",
  },
  onboarding_connectors_section_added: {
    message: "Added",
    description:
      "Header for the list of added connectors in the onboarding page",
  },
  onboarding_search_apps: {
    message: "Search apps",
    description: "Placeholder for search apps input in the onboarding page",
  },
  onboarding_connectors_section_added_select_to_remove: {
    message: "Select to remove",
    description:
      "Sub header for the list of added connectors in the onboarding page",
  },
  onboarding_connectors_section_suggested: {
    message: "Suggested",
    description:
      "Header for the list of suggested connectors in the onboarding page",
  },
  got_it: {
    message: "Got it",
    description: "Button text for acknowledging",
  },
  skip: {
    message: "Skip",
    description: "Button text for skipping",
  },
  continue_button: {
    message: "Continue",
    description: "Button text for continuing the onboarding",
  },
  continue_button_disabled_instructions: {
    message: "Add at least 1 app to continue",
    description:
      "Instructions for the user to select at least one app to continue the onboarding",
  },
  skip_button: {
    message: "Add later",
    description: "Button text for skipping the onboarding",
  },
  privacy_info: {
    message:
      "Dropbox is SOC2-compliant and committed to handling your information with care. Learn about how we use and protect your data in our <ppLink>Privacy Policy</ppLink> and <faqLink>Privacy Policy FAQ</faqLink>.",
    description:
      "Information about privacy relevant to the Dash onboarding onboarding flow.",
  },
  more_apps_coming_soon: {
    message: "More apps coming soon!",
    description:
      "Text informing users that more connector apps are coming soon",
  },
  team_onboarding_title: {
    message: "Add apps to find your content in one place",
    description: "Title for the team onboarding",
  },
  team_onboarding_description: {
    message:
      "Save time with Dash by searching your content in one place instead of 10.",
    description: "Description for the team onboarding",
  },
  team_onboarding_privacy_prompt: {
    message: "Learn more about our <pButton>privacy measures and AI</pButton>.",
    description: "Link for Dash privacy information",
  },
  team_onboarding_extension_upsell_title: {
    message: "Bring AI to any tab with the extension",
    description: "Title for the team onboarding extension upsell",
  },
  team_onboarding_extension_upsell_description: {
    message:
      "Use Dash to summarize, rewrite, or draft content based on the page you’re viewing.",
    description: "Description for the team onboarding extension upsell",
  },
  team_onboarding_extension_upsell_title_with_sidepanel: {
    message: "Get AI at your side, on any tab",
    description: "Title for the team onboarding extension upsell",
  },
  team_onboarding_extension_upsell_description_with_sidepanel: {
    message:
      "Summarize or draft something based on the page.\nOpen the extension when you want. Close it when you don’t.",
    description: "Description for the team onboarding extension upsell",
  },
  team_onboarding_extension_upsell_button: {
    message: "Add Dash extension",
    description: "Text for the team onboarding extension upsell button",
  },
  team_onboarding_extension_upsell_image_alt_text: {
    message: "Web page with AI tools next to it",
    description: "Alt text for the team onboarding extension upsell image",
  },
  extension_encourage_first_action_alt: {
    message: "Web page with AI tools next to it",
    description: "Alt text for the encourage first action prompt",
  },
  extension_omnibox_prompt_alt: {
    message:
      "Animation of a Chrome window, showing the cursor clicking into the search bar.",
    description: "Alt text for the omnibox prompt",
  },
  privacy_modal_title: {
    message: "Learn how Dash uses your data",
    description: "Title for the privacy policy modal",
  },
  privacy_soc2_title: {
    message: "Dropbox Dash is a SOC 2 compliant product",
    description: "Title for SOC2 compliance",
  },
  privacy_soc2_subtitle: {
    message:
      "Dash being SOC 2 compliant means that it meets the high standards for managing customer data set by the AICPA.",
    description: "Subtitle for SOC2 compliance",
  },
  privacy_soc2_description: {
    message:
      "The SOC 2 framework is a benchmark for security, availability, processing integrity, confidentiality, and privacy. Compliance indicates that Dash has established and follows strict information security policies and procedures, encompassing the secure management of data to protect the interests of the organization and the privacy of its clients. For Dash users, this means they can trust that their data is handled with care and rigorous security measures are in place to protect it.",
    description: "Explanation of SOC2 compliance",
  },
  privacy_soc2_security_practice_link_title: {
    message: "Verifying our Security Practices",
    description: "Link to learn more about Dash's security practices",
  },
  privacy_soc2_soc_link_title: {
    message: "What SOC reports are and why they’re important",
    description: "Link to learn more about SOC",
  },
  privacy_privacy_first_title: {
    message: "Your privacy comes first",
    description: "Title for privacy first section",
  },
  privacy_privacy_first_subtitle: {
    message: "You’re in charge of your data with Dropbox.",
    description: "Subtitle for privacy first section",
  },
  privacy_privacy_first_description1: {
    message:
      "Dash only collects data that is needed to provide you access, debug the product in case anything goes wrong, give you feature access in Dash, and improve the product. As a Dropbox product, we are committed to protecting your data and keeping it secure—hundreds of millions of users and businesses trust Dropbox for their most important information.",
    description: "First description for privacy first section",
  },
  privacy_privacy_first_description2: {
    message:
      "If you would like to submit a data access request or object to the processing of your personal data, please email us at <ppLink>privacy@dropbox.com</ppLink>.",
    description: "Second description for privacy first section",
  },
  privacy_privacy_first_data_link_title: {
    message: "Privacy Policy",
    description: "Link to Dropbox privacy policy",
  },
  privacy_dash_ai_title: {
    message: "How Dropbox Dash uses AI",
    description: "Title for use of AI in Dash",
  },
  privacy_dash_ai_description: {
    message:
      "Dropbox Dash uses AI, which is supported by the third-party service, OpenAI. This helps us provide you with certain features you use in Dash, such as summarization and suggestions. We also use data to help improve the quality of our AI-powered features. When we use data for either purpose, it is anonymized and not traceable to you. Data sent to OpenAI is never used to train OpenAI models, and is deleted after 30 days.",
    description: "Description for use of AI in Dash",
  },
  privacy_dash_ai_link_title: {
    message: "Our AI Principles",
    description: "Link to learn more about Dropbox AI principles",
  },
  privacy_dash_product_title: {
    message: "Dash is a Dropbox product",
    description: "Title for Dash product section",
  },
  privacy_dash_product_subtitle: {
    message:
      "Dropbox Dash adheres to the same high privacy and security standards as Dropbox.",
    description: "Subtitle for Dash product section",
  },
  privacy_dash_product_promise_title: {
    message: "Our promise to you:",
    description: "Title for Dash product promise section",
  },
  privacy_dash_product_promise_item1: {
    message: "We will never sell your data",
    description: "First promise item for Dash product promise section",
  },
  privacy_dash_product_promise_item2: {
    message:
      "Employees at Dropbox can’t access your data unless you explicitly give them permission to (e.g., when speaking to Customer Support).",
    description: "Second promise item for Dash product promise section",
  },
  privacy_dash_product_promise_item3: {
    message:
      "Your content remains your own—confidential or proprietary data is always yours, and protecting it is our top priority.",
    description: "Third promise item for Dash product promise section",
  },
  privacy_dash_product_promise_item4: {
    message:
      "We’ll never alter the content, home, or organization of your content in the original app unless you’ve directly asked us to.",
    description: "Fourth promise item for Dash product promise section",
  },
  privacy_need_more_info_title: {
    message: "Need help or more info?",
    description: "Title for section with link or links for more information",
  },
  connected_by_admin_description: {
    message: "Added by your company",
    description: "Description for the admin managed connectors",
  },
  added_by_user_description: {
    message: "Added by you",
    description: "Description for the user managed connectors",
  },
  team_content_description: {
    message: "Team content",
    description: "Description for the admin managed connectors",
  },
  user_content_description: {
    message: "Your content",
    description: "Description for the user managed connectors",
  },
  syncing_content_description: {
    message: "Syncing...",
    description: "Description for the user managed connectors while syncing",
  },
  jtbd_welcome_title: {
    message: "Welcome, {{firstName}}",
    description: "Title with welcome message with user's name",
  },
  jtdb_tell_us_about_yourself_title: {
    message: "Tell us about yourself",
    description:
      "Title on the onboarding page to prompt user to tell us about themselves",
  },
  jtbd_type_of_work_question: {
    message: "What type of work do you do?",
    description: "Question to ask user about the type of work they do",
  },
  jtbd_type_of_work_placeholder: {
    message: "Select One",
    description: "Placeholder text for the type of work dropdown",
  },
  jtbd_type_of_work_communications: {
    message: "Communications",
    description: "Option for user to select if they work in communications",
  },
  jtbd_type_of_work_consultant: {
    message: "Consultant",
    description: "Option for user to select if they work as a consultant",
  },
  jtbd_type_of_work_creative: {
    message: "Creative",
    description: "Option for user to select if they work in a creative field",
  },
  jtbd_type_of_work_educator: {
    message: "Educator",
    description: "Option for user to select if they work as an educator",
  },
  jtbd_type_of_work_finance: {
    message: "Finance",
    description: "Option for user to select if they work in finance",
  },
  jtbd_type_of_work_human_resources: {
    message: "Human Resources",
    description: "Option for user to select if they work in human resources",
  },
  jtbd_type_of_work_legal: {
    message: "Legal",
    description: "Option for user to select if they work in legal",
  },
  jtbd_type_of_work_marketing: {
    message: "Marketing",
    description: "Option for user to select if they work in marketing",
  },
  jtbd_type_of_work_operations: {
    message: "Operations",
    description: "Option for user to select if they work in operations",
  },
  jtbd_type_of_work_sales: {
    message: "Sales",
    description: "Option for user to select if they work in sales",
  },
  jtbd_type_of_work_software: {
    message: "Software",
    description: "Option for user to select if they work in software",
  },
  jtbd_type_of_work_student: {
    message: "Student",
    description: "Option for user to select if they are a student",
  },
  jtbd_type_of_work_product: {
    message: "Product",
    description: "Option for user to select if they work in product",
  },
  jtbd_type_of_work_design: {
    message: "Design",
    description: "Option for user to select if they work in design",
  },
  jtbd_type_of_work_engineering: {
    message: "Engineering",
    description: "Option for user to select if they work in engineering",
  },
  jtbd_type_of_work_other_option: {
    message: "Other",
    description: "Option for user to select if they work in a field not listed",
  },
  jtbd_work_with_question: {
    message: "Who do you usually collaborate with?",
    description: "Question to ask user about who they work with",
  },
  jtbd_work_with_teammates: {
    message: "Teammates",
    description: "Option for user to select if they work with teammates",
  },
  jtbd_work_with_clients: {
    message: "Clients",
    description: "Option for user to select if they work with clients",
  },
  jtbd_work_with_self: {
    message: "Just me",
    description: "Option for user to select if they work alone",
  },
  jtbd_relevant_question_title: {
    message: "Which is most relevant to you?",
    description:
      "Title on the onboarding page to ask user which is most revelant to them",
  },
  jtdb_select_one_title: {
    message: "Select one",
    description:
      "Title on the onboarding page to ask user to select one answer",
  },
  jtbd_type_search: {
    message: "Wasting time searching for things",
    description: "Option for user to select if they need help with search",
  },
  jtbd_type_organize: {
    message: "Feeling disorganized",
    description:
      "Option for user to select if they need help with organization",
  },
  jtbd_type_meetings: {
    message: "Joining video meetings on time",
    description: "Option for user to select if they need help with meetings",
  },
  jtbd_type_not_sure: {
    message: "Not sure, just checking things out",
    description:
      "Option for user to select if they are not sure what they need help with",
  },
  show_more_description: {
    message: "show more",
    description: "Button text to show more of a truncated event description",
  },
  show_less_description: {
    message: "show less",
    description: "Button text to less of an expanded event description",
  },
  event_description_label: {
    message: "Description",
    description: "Label used for event description",
  },
  event_attending_label: {
    message: "Attending",
    description: "Label used for event attendees",
  },
  declined_event_one: {
    message: "1 declined meeting",
    description: "Label used for a single declined meeting",
  },
  declined_event_many: {
    message: "{{count}} declined meetings",
    description: "Label used for many declined meetings",
  },
  show_more_answer: {
    message: "Show more",
    description: "Button text to show more of a truncated answer",
  },
  show_less_answer: {
    message: "Show less",
    description: "Button text to show less of an expanded answer",
  },
  calendar_response_error_message: {
    message:
      "Dash is unable to respond to your request at this time. Please share your feedback about this experience <openModalLink>here</openModalLink>.",
    description:
      "Generic assistant error message when we are unable to show relevant data",
  },
  settings_section_theme: {
    message: "Theme",
    description: "Settings title for Theme section",
  },
  settings_section_locale: {
    message: "Language",
    description: "Settings title for Language section",
  },
  settings_section_preferences: {
    message: "Preferences",
    description: "Settings title for Preferences section",
  },
  settings_section_extension: {
    message: "Extension",
    description: "Settings title for Extension section",
  },
  settings_tab_title: {
    message: "Settings",
    description: "Settings browser tab title",
  },
  settings_section_more: {
    message: "More",
    description: "Settings title for More section",
  },
  settings_section_debug: {
    message: "Debug",
    description: "Settings title for debug section",
  },
  settings_section_security: {
    message: "Data & security",
    description: "Settings title for security section",
  },
  settings_dash_version_copy_text: {
    message: "Dash Version: {{appVersion}}",
    description:
      "Text copied to the clipboard when copying the application version",
  },
  settings_version_label: {
    message: "Version {{appVersion}}",
    description: "Label displayed for application version in Settings",
  },
  settings_version_label_for_organizations: {
    message: "Version {{appVersion}} - Managed by your organization",
    description:
      "Label displayed for application version in Settings for organizations",
  },
  settings_version_tooltip_click_to_copy: {
    message: "Click to copy version to the clipboard",
    description: "Settings version tooltip on hover",
  },
  settings_version_snackbar_copied_to_clipboard: {
    message: "Dash version copied to clipboard",
    description:
      "Settings snackbar after clicking to copy version to clipboard",
  },
  settings_check_for_updates: {
    message: "Check for updates",
    description: "Label for check for updates button in Settings",
  },
  settings_legal_and_privacy: {
    message: "Legal and privacy",
    description: "Label for legal and privacy button in Settings",
  },
  settings_reset_and_quit: {
    message: "Reset and quit",
    description: "Label for Reset and quit button in Settings",
  },
  settings_reset_and_quit_confirm_title: {
    message: "Reset Dash?",
    description: "Reset and quit dialog title in Settings",
  },
  settings_reset_and_quit_confirm_text: {
    message:
      "This will log you out, clear your search activity, and restore default preferences. Apps will not be disconnected. To disconnect your apps, click ‘Open Dash settings’ before resetting.",
    description: "Reset and quit dialog text in Settings",
  },
  settings_reset_and_quit_confirm_button: {
    message: "Reset",
    description: "Reset and quit dialog reset button in Settings",
  },
  settings_quit: {
    message: "Quit Dash",
    description: "Label for Quit button in Settings",
  },
  settings_quit_confirm_title: {
    message: "Quit Dash?",
    description: "Quit dialog title in Settings",
  },
  settings_quit_confirm_text: {
    message: "Quit",
    description: "Quit dialog text in Settings",
  },
  settings_title: {
    message: "Settings",
    description: "Settings panel title",
  },
  settings_theme_system: {
    message: "System",
    description: "Follow system theme settings option",
  },
  settings_theme_aria_label_system: {
    message: "follow system theme option",
    description: "Follow system theme settings radio option",
  },
  settings_theme_dark: {
    message: "Dark",
    description: "dark theme settings option",
  },
  settings_theme_aria_label_dark: {
    message: "dark theme option",
    description: "dark theme settings radio option",
  },
  settings_theme_light: {
    message: "Light",
    description: "light theme settings option",
  },
  settings_theme_aria_label_light: {
    message: "light theme option",
    description: "light theme settings radio option",
  },
  settings_enable_dev_tools: {
    message: "Enable DevTools",
    description: "Enable developer tools settings option",
  },
  settings_clear_browsing_history: {
    message: "Clear browsing history",
    description: "Title for setting to clear browsing history",
  },
  settings_clear_browsing_history_subtext: {
    message:
      "Clearing your history will remove past history from this browser from showing up in recents, and suggested files",
    description: "Subtext for setting to clear browsing history",
  },
  settings_clear_history_button: {
    message: "Clear history",
    description: "Button text to clear history",
  },
  settings_clear_history_confirm_title: {
    message: "Are you sure you want to delete your browsing history?",
    description: "Title for modal to confirm clearing history",
  },
  settings_clear_history_confirm_text: {
    message:
      "This will erase all browsing data collected by the Dash extension, clear your recent activity, and stop past sites from being recommended in stacks. Future browsing history will continue to be collected as long as the Dash extension is installed.",
    description: "Text for modal to confirm clearing history",
  },
  settings_clear_history_success: {
    message: "Your browser history is being cleared.",
    description:
      "Snackbar message shown when clear history API call has succeeded",
  },
  settings_clear_history_error: {
    message:
      "Failed to clear browser history. Please reload the page and try again.",
    description: "Snackbar message shown when clear history API call fails",
  },
  clear_filters: {
    message: "Clear all",
    description: "Button for clearing all filters",
  },
  filter_by: {
    message: "Filter by",
    description: "Prefix for filtering",
  },
  filter_by_app: {
    message: "App",
    description: "Title for app filter on search filter bar",
  },
  browser_history_filter_title: {
    message: "Browser history",
    description: "Title for browser history filter on search filter bar",
  },
  select_all: {
    message: "Select all",
    description: "Button for selecting all options in a filter",
  },
  deselect_all: {
    message: "Deselect all",
    description: "Button for deselecting all options in a filter",
  },
  settings_enable_debug_mode: {
    message: "Enable debug mode",
    description: "Enable debug mode settings option",
  },
  download_desktop: {
    message: "Download desktop",
    description: "Button text for download desktop version of dash",
  },
  navatar_desktop_app: {
    message: "Desktop app",
    description:
      "Button text for download desktop version of dash within the navatar",
  },
  navatar_mobile_app: {
    message: "Mobile app",
    description:
      "Button text for download Mobile app version of dash within the navatar",
  },
  iphone: {
    message: "iPhone",
    description: "Name for iphones",
  },
  download_iphone_app: {
    message: "Download the iPhone Dash App",
    description: "Title prompt for download iphone Dash app",
  },
  android: {
    message: "Android",
    description: "Name for android OS",
  },
  download_android_app: {
    message: "Download the Android Dash App",
    description: "Title prompt for download android Dash app",
  },
  open_app_store_cta: {
    message: "Open App Store",
    description: "Button cta text for opening app store",
  },
  connected_apps_issue: {
    message:
      "Dash has upgraded to a better authentication service, which means you need to reconnect your apps.",
    description:
      "Banner text notifying the user that one or more of their connections has an issue.",
  },
  connected_apps_issue_reauth: {
    message: "One or more of your apps have disconnected.",
    description:
      "Banner text notifying the user that one or more of their connections needs to be reconnected.",
  },
  connected_apps_issue_ack_btn: {
    message: "Add again",
    description:
      "A button on a banner which notifies the user of connected app issues which takes the user to the settings page.",
  },
  meticulous_recording_banner_title: {
    message: "Meticulous is recording",
    description:
      "Banner title notifying the user that Meticulous is recording.",
  },
  meticulous_recording_banner_text: {
    message:
      "This banner only appears on dev and web-master where Meticulous records sessions. Request deletion if you have concerns about recordings being viewed by others.",
    description: "Banner text notifying the user that Meticulous is recording.",
  },
  meticulous_request_deletions: {
    message: "Request deletions",
    description: "Link text to request deletion of Meticulous sessions.",
  },
  meticulous_view_sessions: {
    message: "View sessions",
    description: "Link text to view Meticulous sessions.",
  },
  onboarding_add_files_btn: {
    message: "Add your files",
    description: "Button text for adding dropbox connector",
  },
  onboarding_add_later_btn: {
    message: "Add later",
    description: "Button text for skipping adding connectors",
  },
  onboarding_one_click_title: {
    message: "Give Dash permission to access your Dropbox files",
    description: "Title text for one-click onboarding experiment",
  },
  onboarding_one_click_blurb: {
    message:
      "Ask questions about your content, and Dash will search all your files to write an answer. You can add more apps later.",
    description: "Blurb text for one-click onboarding experiment",
  },
  onboarding_dual_mode_rich_tooltip_title: {
    message: "Quick access to the full Dash app",
    description: "Title for rich tooltip education",
  },
  onboarding_dual_mode_rich_tooltip_body: {
    message: "Find all the features you love.",
    description: "Body for rich tooltip education",
  },
  onboarding_dual_mode_rich_tooltip_illustration_alt: {
    message: "storage illustration",
    description: "Alt text for rich tooltip education",
  },
  onboarding_dual_mode_stage_one_title: {
    message: "Dash on Desktop got a refresh",
    description: "Title for stage one of dual mode onboarding",
  },
  onboarding_dual_mode_stage_one_bullet_first: {
    message: "The Dash website you know and love, all from your desktop app.",
    description: "Bullet point for stage one of dual mode onboarding",
  },
  onboarding_dual_mode_stage_one_bullet_second: {
    message:
      "Ask questions and write content quickly on the <bold>Chat</bold> page.",
    description: "Bullet point for stage one of dual mode onboarding",
  },
  onboarding_dual_mode_stage_one_bullet_third: {
    message: "The app stays open for as long as you want it to.",
    description: "Bullet point for stage one of dual mode onboarding",
  },
  onboarding_dual_mode_stage_two_title: {
    message: "Search quickly with {{shortcut}}",
    description: "Title for stage two of dual mode onboarding",
  },
  onboarding_dual_mode_stage_two_blurb: {
    message:
      "Just need a quick answer? Jump into search or join your next meeting with {{shortcut}} without opening the full desktop app.",
    description: "Blurb for stage two of dual mode onboarding.",
  },
  onboarding_dual_mode_stage_two_blurb_kb_settings: {
    message: "Change your keyboard shortcuts anytime in settings.",
    description:
      "Blurb for stage two of dual mode onboarding to change keyboard",
  },
  onboarding_dual_mode_preview_background_alt: {
    message: "background image for desktop preview",
    description: "Alt text for dual mode onboarding",
  },
  onboarding_dual_mode_preview_persistent_window_alt: {
    message: "preview image for the persistent app window",
    description: "Alt text for dual mode onboarding",
  },
  onboarding_dual_mode_preview_launcher_window_alt: {
    message: "preview image for the temporary app window",
    description: "Alt text for dual mode onboarding",
  },
  tip_dual_mode_launcher_blurb: {
    message: "pulls up Dash search anywhere on your desktop",
    description: "Text for educating user on dual mode usage",
  },
  search_icon_alt: {
    message: "search icon",
    description: "Alt text for a search icon",
  },
  tip_colon: {
    message: "Tip:",
    description: "The word Tip. For title text",
  },
  show_more_with_count: {
    message: "Show {{count}} more",
    description:
      "Label for the button allowing the user to view all of the items in a collection and how many will be shown",
  },
  show_fewer: {
    message: "Show fewer",
    description:
      "Label for the button allowing the user to hide a portion of the items in a collection",
  },
  see_all_apps: {
    message: "See all apps",
    description:
      "Label for the button allowing the user to open the apps page from the welcome banner",
  },
  stacks_typeahead_subtitle: {
    message: "Stack",
    description: "Subtitle for stack result in typeahead search.",
  },
  stacks_typeahead_default_title: {
    message: "Stack",
    description: "Title for stack result in typeahead search.",
  },
  suggested_stacks: {
    message: "Suggested stacks",
    description: "Module title for a list of automatically generated stacks",
  },
  updates_from_connector: {
    message: "From {{connector}}",
    description:
      "Module title for a list of recently updated content from a specific connector (eg Dropbox or Gmail)",
  },
  suggestions_subtitle: {
    message: "Based on your browser & file history",
    description:
      "Module subtitle for a list of automatically generated suggested links",
  },
  refresh: {
    message: "Refresh",
    description: "Tooltip for refresh suggestions.",
  },
  reload: {
    message: "Reload",
    description: "Label for button to reload the page",
  },
  stacks_connector_empty_alt: {
    message: "No stack items",
    description: "Alt text for the stack details empty state image",
  },
  stacks_connector_empty_cta: {
    message: "Nothing in this stack yet",
    description: "CTA message for empty state of stacks connector",
  },
  stacks_no_search_results_cta: {
    message: "No matching results",
    description: "Alt text for the stack details empty state image",
  },
  result_open_button_text: {
    message: "Open",
    description: "Text of the button for opening a result",
  },
  stack_result_subtext_title: {
    message: "Stack",
    description: "Subtext title for stack result",
  },
  select_calendar_you_use_most: {
    message: "Select the calendar you use the most.",
    description: "Subtitle within add your calendar modal",
  },
  your_admin_has_not_enabled_calendars: {
    message: "There are no calendar apps available to be connected.",
    description:
      "Error message displayed when user tries to connect a calendar before an admin has enabled it.",
  },
  app_connected: {
    message: "{{connectorName}} has been connected",
    description: "Snackbar displayed when an app has been connected",
  },
  edit_stack_title: {
    message: "Edit stack title",
    description: "Button label for editing a stack's title",
  },
  edit_stack_description: {
    message: "Edit stack description",
    description: "Button label for editing a stack's description",
  },
  edit_stack_details: {
    message: "Edit stack Details",
    description: "Button label for editing a stack's details",
  },
  copy_link_to_stack: {
    message: "Copy link to stack",
    description: "Button label for copying a link to a stack",
  },
  stack_theme: {
    message: "Stack theme",
    description: "Label for the stack color picker setting",
  },
  delete_stack: {
    message: "Delete stack",
    description: "Button label for deleting a stack",
  },
  aria_remove_recent_result: {
    message: "Remove result from history",
    description:
      "ARIA label for the remove button beside search history items insearch typeahead",
  },
  tooltip_remove_recent_result: {
    message: "Remove",
    description:
      "Tooltip label for the remove button beside search history items insearch typeahead",
  },
  search_result_recent_file: {
    message: "Recent file",
    description: "Subtitle label for recent file search result",
  },
  shortcuts_section_title: {
    message: "Shortcuts",
    description: "Title of the shortcuts section on desktop homepage",
  },
  shortcuts_section_title_apps: {
    message: "Add apps",
    description:
      "Title of the apps section in the shortcuts section on desktop homepage",
  },
  shortcuts_section_title_calendar: {
    message: "Connect your calendar",
    description:
      "Title of the calendar section in the shortcuts section on desktop homepage",
  },
  shortcuts_section_title_extension: {
    message: "Install browser extension",
    description:
      "Title of the extension section in the shortcuts section on desktop homepage",
  },
  shortcuts_section_title_stacks: {
    message: "Create stack",
    description:
      "Title of the stacks section in the shortcuts section on desktop homepage",
  },
  create_section: {
    message: "Create section",
    description: "Text for create section button",
  },
  new_section_name: {
    message: "Section name",
    description: "Default name for newly created section",
  },
  failed_to_create_stack: {
    message: "Failed to create stack. Try again later.",
    description: "Snackbar text after a creating a stack fails.",
  },
  failed_to_create_stack_item: {
    message: "Failed to create stack item. Try again later.",
    description: "Snackbar text after a creating a stack item fails.",
  },
  connect_apps_message: {
    message: "For the best experience, we recommend adding at least 3 apps.",
    description: "Message on connect apps section on start page",
  },
  hide_card: {
    message: "Hide",
    description:
      "Text on button that hides a specific button on the start page card",
  },
  add_browser_extension: {
    message: "Add Dash for {{browserName}}",
    description: "Text on button opens browser extension install link",
  },
  get_browser_extension: {
    message: "Get Dash for {{browserName}}",
    description: "Text on button opens browser extension install link",
  },
  get_extension: {
    message: "Get extension",
    description: "Text on button opens browser extension install link",
  },
  browser_extension_install_message: {
    message: "Make Dash your new tab and navigate recent tabs",
    description: "Text displayed on browser extension card on start page",
  },
  calendar_empty_state_info_text: {
    message: "See upcoming events and join meetings from your homepage",
    description: "Text displayed within calendar empty state in start page",
  },
  link_dash_eligibility_article: {
    message: "For more information, visit our <0>Help Center</0>.",
    description:
      "Text on modal that provides more information on why users cannot access Dash",
  },
  no_results: {
    message: "No results",
    description: "Generic text to indicate that there are no results",
  },
  confirm_skip_adding_apps_modal_title: {
    message: "Continue without adding apps?",
    description:
      "Title of modal confirming user wants to continue without adding apps",
  },
  confirm_skip_adding_apps_modal_text_line_1: {
    message: "Dash can’t provide a delightful experience until you add apps.",
    description:
      "First line modal text confirming user wants to continue without adding apps",
  },
  confirm_skip_adding_apps_modal_text_line_2: {
    message: "If you’re having second thoughts, here’s what you’ll be missing:",
    description:
      "Second line of modal text confirming user wants to continue without adding apps",
  },
  confirm_skip_adding_apps_modal_text_mobile: {
    message:
      "Dash can’t provide a delightful experience until you add apps. Here’s what you’ll be missing:",
    description:
      "Mobile modal text confirming user wants to continue without adding apps",
  },
  search: {
    message: "Search",
    description: "Name of the search feature",
  },
  search_feature_description: {
    message: "Instantly find content across apps ",
    description: "Description of the search feature",
  },
  answers: {
    message: "Answers",
    description: "Name of the answers feature",
  },
  answers_feature_description: {
    message: "Get AI answers about your work",
    description: "Description of the answers feature",
  },
  calendar: {
    message: "Calendar",
    description: "Name of the calendar feature",
  },
  calendar_feature_description: {
    message: "Switch between deep work and meetings easily",
    description: "Description of the answers feature",
  },
  calendar_customize_description: {
    message:
      "View all your daily meetings, get notifications and join calls without leaving Dash.",
    description: "Description of the calendar module in customize view",
  },
  skip_for_now: {
    message: "Skip for now",
    description: "Skip for now",
  },
  see_more: {
    message: "more",
    description: "Text on button that shows more of a truncated answer",
  },
  see_less: {
    message: "less",
    description: "Text on button that shows less of an expanded answer",
  },
  desktop_application_subtitle: {
    message: "Application",
    description:
      "Subtitle shown on typeahead results that show a desktop application (local app)",
  },
  connect_title_subheading: {
    message: "{{briefDescription}}",
    description: "Description for the Airtable connection",
  },
  subdomain_connect_label: {
    message: "{{displayName}} Subdomain",
    description: "Description displayed in the connect modal for subdomain",
  },
  subdomain_label: {
    message: "Subdomain",
    description: "Label for the subdomain input field",
  },
  api_key_connect_label: {
    message: "API Key",
    description: "Label displayed in the connect modal for API Key",
  },
  api_key_label: {
    message: "api_key_1234",
    description: "Placeholder in the connect modal for API Key",
  },
  team_name_connect_label: {
    message: "Team Name",
    description: "Label displayed in the connect modal for Team Name",
  },
  team_name_label: {
    message: "Marketing Team",
    description: "Placeholder displayed in the connect modal for Team Name",
  },
  site_url_label: {
    message: "Site URL",
    description: "Label for the site URL input field",
  },
  client_id_label: {
    message: "Client ID",
    description: "Label for the client ID input field",
  },
  secret_value_label: {
    message: "Client Secret",
    description: "Label for the client secret input field",
  },
  url_team_id_label: {
    message: "Figma Team URL",
    description: "Label for the URL Team ID input field",
  },
  site_url_connect_label: {
    message: "{{displayName}} Site URL",
    description: "Description displayed in the connect modal for site URL",
  },
  connect_label: {
    message: "Connect {{displayName}}",
    description: "Label for a button that initiates the connection process",
  },
  add_button_label: {
    message: "Add",
    description: "Label for a button that initiates the connection process",
  },
  connect_button_label: {
    message: "Connect",
    description: "Label for a button that initiates the connection process",
  },
  cancel_button_label: {
    message: "Cancel",
    description: "Label for a button that cancels the connection process",
  },
  zendesk_prompt: {
    message:
      "Enter your Zendesk subdomain, e.g. https://mycompany.zendesk.com.",
    description: "Zendesk auth prompt",
  },
  figma_prompt: {
    message:
      "After completing the <0>Figma setup guide</0>, copy info from the <1>Developer Apps</1> site.",
    description: "Figma auth prompt",
  },
  onboarding_connectors_section_recommended: {
    message: "Recommended",
    description:
      "Header for the list of recommended connectors in the onboarding page",
  },
  ecosystem_connector_google_suite_title: {
    message: "Google Suite",
    description: "Title for the Google Suite ecosystem connector",
  },
  ecosystem_connector_google_suite_description: {
    message: "Search Google Drive, Gmail, and Calendar",
    description: "Description for the Google Suite ecosystem connector",
  },
  ecosystem_connector_microsoft_suite_title: {
    message: "Microsoft Suite",
    description: "Title for the Microsoft Suite ecosystem connector",
  },
  ecosystem_connector_microsoft_suite_description: {
    message: "Search OneDrive, Outlook, and Calendar",
    description: "Description for the Microsoft Suite ecosystem connector",
  },
  new_section: {
    message: "New Section",
    description: "Placeholder for new section",
  },
  could_not_open_popup: {
    message:
      "Could not open popup. Please allow your browser to open it and try again.",
    description: "Error message when browser fails to open a popup",
  },
  error_getting_oauth_url: {
    message: "Error getting OAuth URL. Please try again.",
    description: "Error message when an OAuth URL request fails",
  },
  error_detecting_new_connection: {
    message: "Could not detect new {{appName}} connection. Please try again.",
    description: "Error message when a new connection is not detected",
  },
  get_started_checklist_dismiss: {
    message: "Dismiss checklist",
    description: "Text on onboarding checklist dismiss button",
  },
  get_started_with_dash: {
    message: "Get started with Dash",
    description: "Text on onboarding checklist get started button",
  },
  get_started_find_content_title: {
    message: "Search for content",
    description:
      "Title on checklist item to perform your first search checklist item",
  },
  get_started_find_content_message: {
    message: "Try searching for a recent doc from one of your connected apps.",
    description:
      "Text within checklist item describing steps to perform your first search checklist item",
  },
  get_started_find_content_cta: {
    message: "Try it now",
    description:
      "Call to action button text on perform your first search checklist item",
  },
  get_started_explore_getting_started_stack_title: {
    message: "Explore your “Getting started with Dash” stack",
    description:
      "Title on checklist item to explore getting started stack checklist item",
  },
  get_started_explore_getting_started_stack_message: {
    message:
      "Jumpstart your Dash journey and discover key features with this pre-built stack made just for you.",
    description:
      "Text within checklist item describing steps to explore getting started stack checklist item",
  },
  get_started_explore_getting_started_stack_cta: {
    message: "Show me",
    description:
      "Call to action button text on explore getting started stack checklist item",
  },
  get_started_create_stack_title: {
    message: "Create your first stack",
    description: "Title on checklist item to create a stack checklist item",
  },
  get_started_create_stack_message: {
    message:
      "Think of stacks as a flexible folder that lets you gather scattered info. This stack will be private until you choose to share it.",
    description:
      "Text within checklist item describing steps to create a stack checklist item",
  },
  get_started_create_stack_cta: {
    message: "Create stack",
    description: "Call to action button text on create stack checklist item",
  },
  get_started_get_the_most_title: {
    message: "Get the most out of Dash",
    description:
      "Title on checklist item to install extension and desktop app checklist item",
  },
  get_started_get_the_most_message: {
    message:
      "Search even faster on your computer with Dash’s desktop app and extension.",
    description:
      "Text within checklist item describing steps toinstall extension and desktop app checklist item",
  },
  get_started_get_the_most_message_desktop: {
    message: "Search even faster on your computer with Dash’s desktop app.",
    description:
      "Text within checklist item describing steps to the desktop app checklist item",
  },
  get_started_get_the_most_cta: {
    message: "Extension",
    description:
      "Call to action button text on extension and desktop app checklist item",
  },
  get_started_get_the_most_alt_cta: {
    message: "Desktop app",
    description:
      "Secondary Call to action button text on extension and desktop app checklist item",
  },
  get_started_learn_more: {
    message: "Learn more",
    description:
      "Text displayed on secondary button within getting started checklist item",
  },
  get_started_complete_title: {
    message: "Nice—you’ve got the basics!",
    description:
      "Title displayed on the congratulatory getting started checklist on completion",
  },
  get_started_complete_message: {
    message: "Keep exploring Dash",
    description:
      "Text displayed on the congratulatory getting started checklist on completion",
  },
  get_started_complete_add_extension: {
    message: "Add extension",
    description:
      "Text displayed on the congratulatory getting started checklist to prompt user to install extension",
  },
  get_started_complete_install_desktop_app: {
    message: "Install desktop app",
    description:
      "Text displayed on the congratulatory getting started checklist to prompt user to install desktop app",
  },
  public_stack_footer_log_in: {
    message: "Log in to your account",
    description: "Bold CTA text on public stack page footer",
  },
  public_stack_footer_suffix: {
    message: " to get full access to Dash",
    description: "CTA text on public stack page footer",
  },
  public_stack_sign_in_cta_title: {
    message: "Sign in to Dash",
    description: "CTA title text on public stack page hover overlay",
  },
  public_stack_sign_in_cta: {
    message: "Sign in to Dash to have AI help organize your content for you.",
    description: "CTA text on public stack page hover overlay",
  },
  public_stack_sign_in_to_share_cta: {
    message: "Sign in to Dash to share this stack",
    description: "CTA text on public stack page share button tooltip",
  },
  public_stack_sign_in_to_add_item_cta: {
    message: "Sign in to Dash to add to this stack",
    description: "CTA text on public stack page add-to-stack button tooltip",
  },
  public_stack_learn_about_dash: {
    message: "Learn about Dash",
    description: "CTA text on public stack page footer button",
  },
  details: {
    message: "Details",
    description: "Label for the details section of the image metadata",
  },
  nobody: {
    message: "No one",
    description: "Default avatar name when user is unknown or undefined",
  },
  stack_share_access_public_description: {
    message: "Anyone with the link",
    description: "Description of which people can access some content.",
  },
  stack_share_access_public_description_can_view: {
    message: "Anyone with the link can view",
    description: "Description of which people can access some content.",
  },
  stack_share_access_public_description_can_edit: {
    message: "Anyone with the link can edit",
    description: "Description of which people can access some content.",
  },
  stack_share_access_team_description: {
    message: "Anyone at {{team}}",
    description: "Description of which people can access some content.",
  },
  stack_share_access_team_description_can_view: {
    message: "Anyone at {{team}} can view",
    description: "Description of which people can access some content.",
  },
  stack_share_access_team_description_can_edit: {
    message: "Anyone at {{team}} can edit",
    description: "Description of which people can access some content.",
  },
  stack_share_access_team_description_fallback: {
    message: "Anyone at your company",
    description: "Description of which people can access some content.",
  },
  stack_share_access_team_description_fallback_can_view: {
    message: "Anyone at your company can view",
    description: "Description of which people can access some content.",
  },
  stack_share_access_team_description_fallback_can_edit: {
    message: "Anyone at your company can edit",
    description: "Description of which people can access some content.",
  },
  stack_share_access_private_description: {
    message: "Only those invited",
    description: "Description of which people can access some content.",
  },
  stack_share_access_private_description_can_view: {
    message: "Only those invited can view",
    description: "Description of which people can access some content.",
  },
  stack_share_access_private_description_can_edit: {
    message: "Only those invited can edit",
    description: "Description of which people can access some content.",
  },
  stack_share_who_has_access: {
    message: "Who has access",
    description: "Label for the stack sharing modal shared members list",
  },
  stack_share_what_can_they_do: {
    message: "What can they do",
    description: "Label for the stack sharing modal shared members list",
  },
  calendar_events_view_more: {
    message: "View all",
    description: "Text on button that shows more calendar events",
  },
  calendar_events_view_less: {
    message: "View less",
    description: "Text on button that shows less calendar events",
  },
  download: {
    message: "Download",
    description: "button text for download nav link",
  },
  download_dash_upsell: {
    message: "Use Dash anywhere",
    description: "button text for download nav link",
  },
  download_dash_desktop_upsell: {
    message: "Include local files in your results",
    description: "header text for Download Dash desktop upsell",
  },
  download_dash_extension_upsell: {
    message: "Use Dash on any web page",
    description: "header text for Download Dash extension upsell",
  },
  download_dash_mobile_upsell: {
    message: "Access Dash on the go",
    description: "header text for Download Dash mobile upsell",
  },
  tab_manager_browser_extension: {
    message: "Browser extension",
    description: "header text for Download Dash upsell's extension section",
  },
  install_upsell: {
    message: "Download desktop app",
    description:
      "button text for Download Dash upsell's desktop section call to action",
  },
  install_again: {
    message: "Install again",
    description:
      "button text for Download Dash upsell's desktop section call to action if the app has already been installed",
  },
  add_extension: {
    message: "Add extension",
    description:
      "button text for Download Dash upsell's extension section call to action",
  },
  extension_upsell_banner_title: {
    message: "Use Dash anywhere",
    description: "title for extension upsell banner",
  },
  extension_upsell_banner_description: {
    message: "Summarize or ask questions on any web page.",
    description: "description for extension upsell banner",
  },
  download_mobile_cta: {
    message: "Download mobile app",
    description:
      "button text for Download Dash upsell's mobile section call to action",
  },
  add_again: {
    message: "Add again",
    description:
      "button text for Download Dash upsell's extension section call to action if the extension has already been installed",
  },
  archive_stack: {
    message: "Archive stack",
    description: "Text on button that shows what stack to archive",
  },
  unarchive_stack: {
    message: "Unarchive stack",
    description: "Text on button that shows what stack to unarchive",
  },
  confirm_archive_stack_title: {
    message: "Are you sure you want to archive this stack?",
    description: "Modal title on whether to archive this stack",
  },
  confirm_archive_stack_body: {
    message:
      "Moving this stack to archive will disable all notifications and updates for everyone who this stack is shared with.",
    description: "Body text for archive stack confirmation",
  },
  confirm_unarchive_stack_title: {
    message: "Are you sure you want to unarchive this stack?",
    description: "Body text for unarchive stack confirmation",
  },
  confirm_unarchive_stack_body: {
    message:
      "Unarchiving this stack will re-enable all notifications and updates for everyone who this stack is shared with.",
    description: "Body text for archive stack confirmation",
  },
  archived_stack_snackbar: {
    message: "Archived “{{stackName}}”",
    description: "Snackbar text for archiving a stack",
  },
  unarchived_stack_snackbar: {
    message: "Unarchived “{{stackName}}”",
    description: "Snackbar text for unarchiving a stack",
  },
  move: {
    message: "Move",
    description: "Button text for move handles",
  },
  feedback_modal_title: {
    message: "How can we help?",
    description: "Title for inapp feedback modal",
  },
  feedback_modal_blurb: {
    message:
      "Send feedback to our team to help us create a better Dash experience.",
    description: "Blurb for feedback modal",
  },
  feedback_modal_bug_blurb: {
    message:
      "Help us improve Dash by reporting bugs. For suggestions and questions, please <0>contact</0> our team.",
    description: "Internal blurb for feedback modal",
  },
  feedback_modal_contact_blurb: {
    message: "If you need help with an issue, please contact <0>support</0>.",
    description: "Blurb for feedback modal support",
  },
  feedback_modal_type_dropdown_default: {
    message: "Feedback type",
    description: "Default dropdown text for feedback modal",
  },
  feedback_modal_cta_text: {
    message: "Send",
    description: "Button text for cta on feedback modal",
  },
  feedback_modal_title_placeholder: {
    message: "Title: What is this feedback about?",
    description: "Button text for cta on feedback modal",
  },
  feedback_modal_body_placeholder: {
    message: "Describe your feedback here.",
    description: "Button text for cta on feedback modal",
  },
  feedback_modal_title_bug_placeholder: {
    message: "Title: What is the bug?",
    description: "Button text for cta on feedback modal",
  },
  feedback_modal_body_bug_placeholder: {
    message: "Describe your bug here.",
    description: "Button text for cta on feedback modal",
  },
  feedback_modal_attach_screentshot_cta: {
    message: "Attach screenshot",
    description: "Button text for attaching a screenshot to the feedback modal",
  },
  feedback_modal_remove_image: {
    message: "Remove image",
    description: "Text for removing image from feedback",
  },
  feedback_screenshot_failed: {
    message: "Failed to attach image. Please try again later.",
    description: "Text shown after feedback screenshot is unable to attach",
  },
  expand_stack_item_summary: {
    message: "Summarize",
    description: "Tooltip text for summarizing a stack item",
  },
  collapse_stack_item_summary: {
    message: "Collapse Summary",
    description: "Tooltip text for collapsing a stack item summary",
  },
  stack_item_summary_source: {
    message: "Dash Summary",
    description: "Text for source attribution of generated stack item summary",
  },
  stack_item_summary_regenerate: {
    message: "Regenerate",
    description: "Button label for regenerating a stack item summary",
  },
  stack_item_summary_visibility_user_only: {
    message: "Only visible to you",
    description: "Tooltip text for stack item summary visibility icon",
  },
  stack_item_summary_loading_summary: {
    message: "Summarizing...",
    description: "Text displayed while a stack item summary is being generated",
  },
  doc_summary_qna_title: {
    message: "Summarize and ask",
    description: "Title when showing summarize_qna",
  },
  doc_summary_qna_related_questions: {
    message: "Related questions",
    description: "Related questions section of summarize_qna",
  },
  doc_summary_qna_what_are_the_key_takeaways: {
    message: "What are the key takeaways?",
    description: "Question for summarize_qna",
  },
  doc_summary_qna_can_you_find_any_next_steps: {
    message: "Can you find any next steps?",
    description: "Question for summarize_qna",
  },
  doc_summary_qna_loading_summary: {
    message: "Summarizing...",
    description: "Text displayed while a doc summary is being generated",
  },
  doc_summary_qna_input_placeholder: {
    message: "Ask something about this file",
    description: "Description when showing summarize_qna input",
  },
  doc_summary_qna_generated_using_third_party_ai: {
    message: "Generated using third party AI. Click to learn more",
    description: "Tooltip displayed in doc summary qna rail",
  },
  doc_summary_unexpected_error: {
    message: "Something went wrong.",
    description: "Unexpected error from doc summary",
  },
  doc_summary_qna_feedback_irrelevant_answer: {
    message: "Didn’t answer question",
    description: "Feedback option for irrelevant answer in summaryQnA",
  },
  doc_summary_qna_feedback_incorrect: {
    message: "Factually incorrect (Hallucination)",
    description: "Feedback option for incorrect answer in summaryQnA",
  },
  doc_summary_qna_feedback_key_details_missing: {
    message: "Key details missing",
    description: "Feedback option for key details missing in summaryQnA",
  },
  doc_summary_qna_feedback_verbose: {
    message: "Answer too verbose",
    description: "Feedback option for verbose answer in summaryQnA",
  },
  doc_summary_qna_feedback_misunderstood: {
    message: "Answer wasn’t coherent",
    description: "Feedback option wasn't coherent in summaryQnA",
  },
  doc_summary_qna_feedback_other_option: {
    message: "Other",
    description: "Feedback option for other in summaryQnA",
  },
  doc_summary_qna_question_reset: {
    message: "Reset",
    description:
      "ARIA button label for resetting the question input summaryQnA",
  },
  doc_summary_qna_ask_new_question: {
    message: "Ask new question",
    description: "Button label for asking a new question in summaryQnA",
  },
  doc_summary_qna_error_something_went_wrong: {
    message: "Sorry, something went wrong.",
    description:
      "Error message displayed when an unexpected error occurs for doc summary/qna",
  },
  stack_item_qna_loading_answer: {
    message: "Answering...",
    description: "Text displayed while a stack item answer is being generated",
  },
  stack_item_qna_input_placeholder: {
    message: "Ask a question…",
    description:
      "Placeholder text for the input field to ask a question about a stack item",
  },
  stack_item_qna_submit_tooltip: {
    message: "Submit",
    description:
      "Tooltip text for the submit button to ask a question about a stack item",
  },
  stack_item_qna_question_source_prefix: {
    message: "Asked by {{name}}",
    description:
      "Prefix for the source attribution of a question asked about a stack item",
  },
  stack_item_qna_summary_unexpected_error: {
    message: "An unexpected error occurred.",
    description:
      "Error message displayed when an unexpected error occurs for stack item summary/qna",
  },
  creating_paper_doc: {
    message: "Creating Paper Doc...",
    description: "User is creating their paper doc",
  },
  failed_paper_doc_creation: {
    message: "Failed to create Paper Doc",
    description: "Paper Doc cannot be created",
  },
  paper_doc_creation_placeholder: {
    message: "Enter a Paper Doc filename",
    description: "Placeholder for paper doc creation",
  },
  search_inline_cta_local_file: {
    message: "Open on desktop",
    description:
      "Inline call-to-action for the search input field for local file search",
  },
  search_inline_cta_stack: {
    message: "Open stack",
    description: "Inline call-to-action for the search input field for Stacks",
  },
  search_inline_cta_stack_item: {
    message: "Open stack item",
    description:
      "Inline call-to-action for the search input field for Stack items",
  },
  search_inline_cta_search_result: {
    message: "Open in {{appName}}",
    description:
      "Inline call-to-action for the search input field for recommended results",
  },
  search_inline_cta_desktop_app: {
    message: "Open",
    description:
      "Inline call-to-action for the search input field for desktop app search (long version)",
  },
  search_inline_cta_shortcut: {
    message: "Open",
    description:
      "Inline call-to-action for the search input field for shortcuts",
  },
  people_search_empty: {
    message: "Begin typing to search",
    description: "Placeholder text for the people search input field",
  },
  people_search_no_results: {
    message: "No results found",
    description: "Text shown when there are no results for people search",
  },
  people_search_chip_placeholder: {
    message: "People",
    description: "Placeholder for the people search chip",
  },
  people_search_input_placeholder: {
    message: "Search for people",
    description: "Placeholder text for the people search input field",
  },
  people_filter_anyone_option: {
    message: "Anyone",
    description: "Option that represents deselecting the people filter",
  },
  clone_stack: {
    message: "Duplicate stack",
    description: "Text on button that shows what stack to duplicate",
  },
  confirm_clone_stack_title: {
    message: "Sharing permissions won’t transfer",
    description: "Modal title on whether to clone this stack",
  },
  confirm_clone_stack_body: {
    message:
      "After duplicating the stack, users from the current stack won’t have immediate access to the new one. You will need to manually invite and share the duplicated stack if access is needed.",
    description: "Body text for archive stack confirmation",
  },
  clone_stack_snackbar_pending: {
    message: "Duplicating “{{stackName}}”",
    description: "Snackbar text for starting a duplication",
  },
  clone_stack_snackbar_error: {
    message: "Error duplicating “{{stackName}}”",
    description: "Snackbar text for error in duplicating a stack",
  },
  clone_stack_snackbar_error_already_ongoing: {
    message: "Already duplicating “{{stackName}}”",
    description: "Snackbar text for when a duplication is already ongoing",
  },
  clone_stack_snackbar_success: {
    message: "Duplicated “{{stackName}}”",
    description: "Snackbar text for successfully duplicated a stack",
  },
  sharing_typeahead_empty_hint: {
    message: "Enter a valid email address",
    description:
      "Hint text for the sharing typeahead when no suggestions have been returned and the value is not a valid email address",
  },
  sharing_typeahead_completion_hint: {
    message: "Press ‘Enter’ to select this email address",
    description: "Hint text for the sharing typeahead completion",
  },
  sharing_typehead_paste_hint_one: {
    message: "Press ‘Enter’ to add this email address",
    description: "Hint text for the sharing typeahead paste",
  },
  sharing_typehead_paste_hint_few: {
    message: "Press ‘Enter’ to add {{count}} email addresses",
    description: "Hint text for the sharing typeahead paste",
  },
  sharing_typehead_paste_hint_many: {
    message: "Press ‘Enter’ to add {{count}} email addresses",
    description: "Hint text for the sharing typeahead paste",
  },
  sharing_typehead_paste_hint_other: {
    message: "Press ‘Enter’ to add {{count}} email addresses",
    description: "Hint text for the sharing typeahead paste",
  },
  activity_feed_header_title: {
    message: "Activity feed",
    description: "Title for the activity feed module",
  },
  activity_feed_filters_menu_toggle_tooltip: {
    message: "Filter your apps",
    description: "Tooltip for the filter menu toggle in the activity feed",
  },
  activity_feed_filters_by_person_label: {
    message: "Filter by person",
    description:
      "Label to show next to above the filter by person menu in the activity feed",
  },
  activity_feed_filters_by_person_everyone: {
    message: "Everyone",
    description:
      "Filter option for activity feed to show activities for everyone",
  },
  activity_feed_filters_by_person_me: {
    message: "Only me",
    description:
      "Filter option for activity feed to show only activities related to the user",
  },
  activity_feed_item_type_stack: {
    message: "Stack",
    description: "Label shown when the activity object was a Stack",
  },
  activity_feed_expanded_label_edit_document_no_actor: {
    message: "<subject>Someone</subject> modified",
    description:
      "Activity displayed when a file is modified by someone whose name we don't know",
  },
  activity_feed_expanded_label_edit_document_one_actor: {
    message: "<subject>{{actorName1}}</subject> modified",
    description: "Activity displayed when a file is modified by on person",
  },
  activity_feed_expanded_label_edit_document_two_actors_zero: {
    message:
      "<subject>{{actorName1}}</subject> and <subject>{{actorName2}}</subject> modified",
    description: "Activity displayed when a file is modified by two people",
  },
  activity_feed_expanded_label_edit_document_two_actors_other: {
    message:
      "<subject>{{actorName1}}</subject>, <subject>{{actorName2}}</subject>, and <subjectOverflow>{{count}} others</subjectOverflow> modified",
    description:
      "there are more than 3 actors and we display the first two and an additional count of extra actors",
  },
  activity_feed_expanded_label_edit_document_three_actors: {
    message:
      "<subject>{{actorName1}}</subject>, <subject>{{actorName2}}</subject>, and <subject>{{actorName3}}</subject> modified",
    description: "Activity displayed when a file is modified by three people",
  },
  activity_feed_expanded_label_edit_stack_name_no_actor: {
    message: "<subject>Someone</subject> changed the title",
    description:
      "Activity displayed when someone unknown else changes the title of your stack",
  },
  activity_feed_expanded_label_edit_stack_name_one_actor: {
    message: "<subject>{{actorName1}}</subject> changed the title",
    description:
      "Activity displayed when someone else changes the title of your stack",
  },
  activity_feed_expanded_label_edit_stack_description_no_actor: {
    message: "<subject></subject> changed the description",
    description:
      "Activity displayed when someone else changes the description of your stack",
  },
  activity_feed_expanded_label_edit_stack_description_one_actor: {
    message: "<subject>{{actorName1}}</subject> changed the description",
    description:
      "Activity displayed when someone else changes the description of your stack",
  },
  activity_feed_expanded_label_archive_stack_no_actor: {
    message: "<subject>Someone</subject> archived",
    description: "Activity displayed when someone unknown archives a stack",
  },
  activity_feed_expanded_label_archive_stack_one_actor: {
    message: "<subject>{{actorName1}}</subject> archived",
    description: "Activity displayed when someone else archives a stack",
  },
  activity_feed_expanded_label_unarchive_stack_no_actor: {
    message: "<subject>Someone</subject> unarchived",
    description: "Activity displayed when someone unknown unarchives a stack",
  },
  activity_feed_expanded_label_unarchive_stack_one_actor: {
    message: "<subject>{{actorName1}}</subject> unarchived",
    description: "Activity displayed when someone else unarchives a stack",
  },
  activity_feed_expanded_label_share_document_no_actor: {
    message: "<subject>Someone</subject> shared a file with you",
    description:
      "Activity displayed when a file is shared with you but the actor's name is unknown",
  },
  activity_feed_expanded_label_share_document_one_actor: {
    message: "<subject>{{actorName1}}</subject> shared a file with you",
    description:
      "Activity displayed when a file is shared with you by a known actor",
  },
  activity_feed_expanded_label_share_stack_no_actor: {
    message: "<subject></subject> shared a stack with you",
    description:
      "Activity displayed when a stack is shared with the user but the actor's name is unknown",
  },
  activity_feed_expanded_label_share_stack_one_actor: {
    message: "<subject>{{actorName1}}</subject> shared a stack with you",
    description: "Activity displayed when a stack is shared with the user",
  },
  activity_feed_expanded_label_add_stack_item_no_actor: {
    message:
      "<subject>Someone</subject> added <addedItemLink>{{addedItemName}}</addedItemLink>",
    description:
      "Activity displayed when someone unknown adds a stack item from your stack",
  },
  activity_feed_expanded_label_add_stack_item_one_actor: {
    message:
      "<subject>{{actorName1}}</subject> added <addedItemLink>{{addedItemName}}</addedItemLink>",
    description:
      "Activity displayed when someone else adds a stack item from your stack",
  },
  activity_feed_expanded_label_add_stack_item_one_actor_multiple_items: {
    message: "<subject>{{actorName1}}</subject> added {{itemCount}} items",
    description:
      "Activity displayed when someone else adds multiple stack items to your stack",
  },
  activity_feed_expanded_label_add_stack_two_actors: {
    message:
      "<subject>{{actorName1}}</subject> and <subject>{{actorName2}}</subject> added {{itemCount}} items",
    description:
      "Activity displayed when two people add stack items to your stack",
  },
  activity_feed_expanded_label_add_stack_three_actors: {
    message:
      "<subject>{{actorName1}}</subject>, <subject>{{actorName2}}</subject>, and <subjectOverflow>{{actorCount}} other</subjectOverflow> added {{itemCount}} items",
    description:
      "Activity displayed when three or more people add stack items to your stack",
  },
  activity_feed_expanded_label_add_stack_many_actors: {
    message:
      "<subject>{{actorName1}}</subject>, <subject>{{actorName2}}</subject>, and <subjectOverflow>{{actorCount}} others</subjectOverflow> added {{itemCount}} items",
    description:
      "Activity displayed when more than three people add stack items to your stack",
  },
  activity_feed_expanded_label_remove_stack_item_no_actor: {
    message:
      "<subject>Someone</subject> removed <removedItemLink>{{removedItemName}}</removedItemLink>",
    description:
      "Activity displayed when someone unknown removes a stack item from your stack",
  },
  activity_feed_expanded_label_remove_stack_item_one_actor: {
    message:
      "<subject>{{actorName1}}</subject> removed <removedItemLink>{{removedItemName}}</removedItemLink>",
    description:
      "Activity displayed when someone else removes a stack item from your stack",
  },
  activity_feed_end_of_feed_title: {
    message: "That’s all for now",
    description:
      "Message displayed on top line when user scrolls to end of feed",
  },
  activity_feed_end_of_feed_subtitle: {
    message: "Check back later. Your feed will update as you use Dash",
    description:
      "Message displayed on bottom line when user scrolls to end of feed",
  },
  activity_feed_empty_state_add_apps_text: {
    message: "See the latest activity from your connected apps",
    description:
      "Text on the activity feed empty state when you have not added apps",
  },
  activity_feed_empty_state_text: {
    message: "We don’t have any new content for you - try refreshing later.",
    description: "Text on the activity feed empty state",
  },
  activity_feed_empty_state_text_reset_filters: {
    message:
      "We don’t have any new content for you - try resetting your filters or refreshing later.",
    description:
      "Text displayed when the activity feed is empty and filters are set.",
  },
  activity_feed_empty_state_text_reset_filters_button: {
    message: "Reset filters",
    description:
      "Button label for resetting your filters in the activity feed empty state.",
  },
  set_as_default_prompt: {
    message: "Set as default",
    description: "Button text to set a prompt as the default",
  },
  clear_default_prompt: {
    message: "Clear default",
    description: "Button text to clear the default prompt selection",
  },
  default_prompt_set: {
    message: "Default prompt set",
    description: "Snackbar message when a prompt is set as default",
  },
  default_prompt_cleared: {
    message: "Default prompt cleared",
    description: "Snackbar message when the default prompt is cleared",
  },
  submit_prompt: {
    message: "Submit Prompt",
    description:
      "Button label for submitting a search with a prompt in the search relevance modal",
  },
  search_relevance_tip_title: {
    message: "See Search Relevance Explanation",
    description:
      "Title of the tip displayed when the search relevance button is clicked",
  },
  search_relevance_modal_title: {
    message: "Search Result Relevance",
    description: "Title for the search relevance modal",
  },
  search_relevance_modal_error: {
    message: "Error computing search relevance",
    description: "Error message for the search relevance modal",
  },
  search_relevance_modal_description: {
    message:
      "The relevance of the search result to the search query is displayed below.",
    description: "Description for the search relevance modal",
  },
  search_relevance_recent_prompts: {
    message: "Recent Prompts",
    description:
      "Title for the recent prompts heading in the search relevance modal",
  },
  delete_search_relevance_prompt_title: {
    message: "Delete Prompt",
    description: "Title for the delete prompt confirmation modal",
  },
  delete_search_relevance_prompt_body: {
    message:
      "Are you sure you want to delete this prompt? This action cannot be undone.",
    description: "Body for the delete prompt confirmation modal",
  },
  delete_search_relevance_prompt: {
    message: "Prompt deleted successfully",
    description: "Message displayed when a search relevance prompt is deleted",
  },
  delete_search_relevance_prompt_error: {
    message: "Failed to delete prompt",
    description: "Message displayed when a search relevance prompt is deleted",
  },
  frontend_prompt: {
    message: "Frontend Prompt",
    description: "Title for the frontend prompt",
  },
  backend_prompt: {
    message: "Backend Prompt",
    description: "Title for the backend prompt",
  },
  customized_prompt: {
    message: "Customized Prompt",
    description: "Title for the customized prompt",
  },
  summarize_tip_title: {
    message: "Ask about this file",
    description:
      "Title of the tip displayed when the search call to action is clicked",
  },
  summarize_tip_message: {
    message:
      "Dash will summarize your files and compose a concise answer for you. Try it now.",
    description:
      "Message on the tip displayed when the search call to action is clicked",
  },
  settings_banner_title: {
    message: "Search even faster. Enable Dash wherever you work.",
    description:
      "Title displayed in the feature banner within the settings page",
  },
  settings_banner_message: {
    message:
      "Save time by utilizing keyboard shortcuts on your desktop to search Dash even quicker. Set Dash as your new tab with the browser extension to streamline your workflow.",
    description:
      "Message displayed in the feature banner within the settings page",
  },
  settings_banner_alt: {
    message: "Searching faster",
    description:
      "Aria label for the image in the feature banner within the settings page",
  },
  extension_call_to_action: {
    message: "Browser extension",
    description: "Call to action button text to install the browser extension",
  },
  desktop_app_call_to_action: {
    message: "Desktop app",
    description:
      "Call to action button text to install the desktop application",
  },
  content_type_filter_title: {
    message: "Type",
    description: "Title for the content type filter",
  },
  content_type_filter_title_with_count: {
    message: "Type • {{count}}",
    description: "Title for the content type filter",
  },
  last_updated_label: {
    message: "Last updated",
    description: "Label text for last updated field",
  },
  file_type_label: {
    message: "File type",
    description: "Label text for file type field",
  },
  found_in_label: {
    message: "Found in",
    description: "Label text for found in field",
  },
  updated_by_label: {
    message: "Updated by",
    description: "Label text for updated by field",
  },
  when_label: {
    message: "When",
    description: "Label text for when field",
  },
  where_label: {
    message: "Where",
    description: "Label text for where field",
  },
  guests_label: {
    message: "Guests",
    description: "Label text for guests field",
  },
  email_label: {
    message: "Email",
    description: "Label text for email field",
  },
  manager_label: {
    message: "Manager",
    description: "Label text for manager field",
  },
  result_created_by: {
    message: "Created by <tag>{{name}}</tag>",
    description: "Shown next to creator metadata on search results",
  },
  result_updated_by: {
    message: "Updated by <tag>{{name}}</tag>",
    description: "Shown next to creator metadata on search results",
  },
  by: {
    message: "By <tag>{{name}}</tag>",
    description: "Prefix to a user's name",
  },
  result_sent_by: {
    message: "Sent by <tag>{{name}}</tag>",
    description: "Shown next to sender metadata on search results",
  },
  stacks_banner_title: {
    message: "Stacks are the home for all your key resources",
    description: "Title displayed in the feature banner within the stacks page",
  },
  stacks_banner_message: {
    message:
      "From employee onboarding materials to client hand-off documents, you can use stacks to group, discover, and share important resources in one location. Your stacks remain private until you decide to share them.",
    description:
      "Message displayed in the feature banner within the stacks page",
  },
  stacks_banner_alt: {
    message: "Stacks banner logo",
    description:
      "Message displayed in the feature banner within the stacks page",
  },
  stacks_banner_call_to_action: {
    message: "Create a stack",
    description:
      "Call to action button text to create a stack on the stacks banner",
  },
  num_guests_one: {
    message: "{{count}} guest",
    description: "Number of meeting guests",
  },
  num_guests_few: {
    message: "{{count}} guests",
    description: "Number of meeting guests",
  },
  num_guests_many: {
    message: "{{count}} guests",
    description: "Number of meeting guests",
  },
  num_guests_other: {
    message: "{{count}} guests",
    description: "Number of meeting guests",
  },
  one_known_guest_one: {
    message: "{{guest_one}} and {{count}} other",
    description: "One named guest and a number of other guests",
  },
  one_known_guest_few: {
    message: "{{guest_one}} and {{count}} others",
    description: "One named guest and a number of other guests",
  },
  one_known_guest_many: {
    message: "{{guest_one}} and {{count}} others",
    description: "One named guest and a number of other guests",
  },
  one_known_guest_other: {
    message: "{{guest_one}} and {{count}} others",
    description: "One named guest and a number of other guests",
  },
  two_known_guests_zero: {
    message: "{{guest_one}} and {{guest_two}}",
    description: "Two named guests and no other guests",
  },
  two_known_guests_one: {
    message: "{{guest_one}}, {{guest_two}}, and {{count}} other",
    description: "Two named guests and a number of other guests",
  },
  two_known_guests_few: {
    message: "{{guest_one}}, {{guest_two}}, and {{count}} others",
    description: "Two named guests and a number of other guests",
  },
  two_known_guests_many: {
    message: "{{guest_one}}, {{guest_two}}, and {{count}} others",
    description: "Two named guests and a number of other guests",
  },
  two_known_guests_other: {
    message: "{{guest_one}}, {{guest_two}}, and {{count}} others",
    description: "Two named guests and a number of other guests",
  },
  created_by_me: {
    message: "Created by me",
    description: "Chip label for stacks created by the user",
  },
  created_by_you: {
    message: "Created by you",
    description: "Label for tool created by the user",
  },
  welcome_modal_title_step_0: {
    message: "Welcome to Dropbox Dash!",
    description: "Intro title for the welcome modal",
  },
  welcome_modal_message_step_0: {
    message:
      "Use Dash to quickly find, gather, and summarize content from the apps you already use, all in one place.  Take a look at some key features by clicking “Next” below.",
    description: "Intro message for the welcome modal",
  },
  welcome_modal_title_step_1: {
    message: "A home page built for focus",
    description: "Title for the home page step of the welcome modal",
  },
  welcome_modal_message_step_1: {
    message:
      "Your home page allows you to view your schedule at a glance and get up to speed on important work.",
    description: "Message for the home page step of the welcome modal",
  },
  welcome_modal_title_step_2: {
    message: "Search and ask about your files",
    description: "Title for the search step of the welcome modal",
  },
  welcome_modal_message_step_2: {
    message:
      "Search Dash to find exactly what you need across all your connected apps. You can also ask questions about a file to get answers related to your work.",
    description: "Message for the search step of the welcome modal",
  },
  welcome_modal_title_step_3: {
    message: "Use stacks to get organized",
    description: "Title for the stacks step of the welcome modal",
  },
  welcome_modal_message_step_3: {
    message:
      "Stacks help you group different types of content by project, team, or personal preference—whether it’s files, apps, or browser links.",
    description: "Message for the stacks step of the welcome modal",
  },
  welcome_modal_spotlight_alt: {
    message: "Welcome Modal Spotlight",
    description: "Alt text for the main image of the welcome modal",
  },
  next: {
    message: "Next",
    description: "Action text that is to navigate to the next element in list",
  },
  logout_screen_title: {
    message: "Find your content in one place",
    description: "Title of logout screen",
  },
  logout_screen_purchaser_note: {
    message:
      "Your admin has purchased a seat for you on Dropbox Dash. Click ’Continue to log in’ to join your team.",
    description:
      "Note to the user on logout screen that their admin has purchased them a seat.",
  },
  logout_screen_copyright: {
    message: "Dropbox Dash \u00A9 {{copyrightYear}}",
    description: "Copyright note on the logout screen",
  },
  logout_screen_extension_welcome: {
    message:
      "Welcome to Dropbox Dash! With the Dash extension, you can search content across all your apps in this tab. Log in or create an account to get started.",
    description:
      "Note to the user on logout screen that this page shows up because they installed the Dash extension.",
  },
  stack_item_updated_ago: {
    message: "Updated {{timeAgo}}",
    description:
      "Message displayed to indicate when stack item was last updated",
  },

  recommended_header: {
    message: "Suggested items based on",
    description: "Header for the list of recommended stack items",
  },
  create_stack_tour_name_stack_title: {
    message: "Name your stack",
    description: "Title of the name your stack tour item",
  },
  create_stack_tour_name_stack_message: {
    message:
      "Often, people use stacks to organize important content like onboarding resources, project docs, client handoffs, and more.",
    description: "Message on the name your stack tour item",
  },
  create_stack_tour_more_files_title: {
    message: "Add more than just files",
    description: "Title of the file selector tour item",
  },
  create_stack_tour_more_files_message: {
    message: "Type to search for the content you want to add, or paste a link.",
    description: "Message on the file selector tour item",
  },
  skip_tour: {
    message: "Skip tour",
    description: "Skip tour call to action",
  },
  next_tour: {
    message: "Next",
    description: "Next button tour call to action",
  },
  done_tour: {
    message: "Done",
    description: "Done button tour call to action to dismiss tour as finished",
  },
  all_day_event: {
    message: "{{startDate}} - {{endDate}}",
    description: "the date for an all day event",
  },
  initial_sync_message_single: {
    message: "{{connector}} is still syncing. Results may be incomplete.",
    description:
      "Message shown to the user if 1 app is syncing on initial sync",
  },
  initial_sync_message_with_count: {
    message:
      "{{connectorCount}} new apps are still syncing. Results may be incomplete.",
    description:
      "Message shown to the user if more than 3 apps are syncing on initial sync",
  },
  initial_sync_message_list: {
    message: "{{connectorList}} are still syncing. Results may be incomplete.",
    description:
      "Message shown to the user if 3 or less apps are syncing on initial sync",
  },
  conjunction_and: {
    message: "and",
    description: "Separator in a list of terms",
  },
  error: {
    message: "Error",
    description: "Generic error text to use in error messages",
  },
  retry_search: {
    message: "Retry your search",
    description: "Retry search button text",
  },
  cannot_have_more_than_max_keystrokes_keystrokes: {
    message: "Cannot have more than {{MAX_KEYSTROKES}} keystrokes",
    description:
      "Error message when the user has typed too many keystrokes in a hotkey",
  },
  company_apps_empty_state_title: {
    message: "Your company hasn’t added any apps yet",
    description: "Title displayed if there are no configured apps",
  },
  company_apps_empty_state_message: {
    message:
      "Your company selects and adds the apps you can use in Dash. Contact your admin for more apps.",
    description: "Message displayed if there are no configured apps",
  },
  file_type_filter_any_option: {
    message: "Any type",
    description: "Option to filter by any file type",
  },
  sections_empty_cta: {
    message: "Add sections to organize your stack",
    description: "CTA message for empty state of stack sections",
  },
  admin_console: {
    message: "Admin console",
    description: "Menu item that will navigate to the Admin console",
  },
  admin: {
    message: "Admin",
    description:
      "Displayed to user on navigation avatar when user is team admin",
  },
  delete_account_title: {
    message: "Permanently delete your Dropbox account?",
    description: "Title to confirm account deletion",
  },
  delete_account_password_error_title: {
    message: "Incorrect password",
    description: "Error title for account deletion error",
  },
  delete_account_password_error_message: {
    message:
      "We were unable to delete your account as the password was incorrect. Please refer to the <help>help article</help> for other options or try again later.",
    description: "Error message for account deletion error",
  },
  delete_account_failed_title: {
    message: "Failed to delete account",
    description: "Error title for account deletion error",
  },
  delete_account_failed_message: {
    message:
      "Sorry, we were unable to delete your account. Please refer to the <help>help article</help> for other options or try again later.",
    description: "Error message for account deletion error",
  },
  delete_account_email: {
    message: "<bold>Account email:</bold> {{email}}",
    description: "Email to display for account deletion",
  },
  delete_account_paragraph_1: {
    message:
      "Your files in Dropbox will be gone forever, and you’ll no longer have access to anything that’s been shared with you. It may take a few days to complete the deletion. <learn>Learn more about deleting your account.</learn>",
    description: "Paragraph 1 to confirm account deletion",
  },
  delete_account_paragraph_2: {
    message:
      "Before you delete your account, we might be able to help. <contact>Get in touch with us.</contact>",
    description: "Paragraph 2 to confirm account deletion",
  },
  password: {
    message: "Password",
    description: "Label for a password",
  },
  reason_for_leaving: {
    message: "Reason for leaving",
    description: "Label to indicate reason for deleting account",
  },
  delete_account_reason_dont_need_space: {
    message: "Don’t need the space",
    description: "Reason for deleting account",
  },
  delete_account_reason_dont_need_service: {
    message: "Don’t need the service",
    description: "Reason for deleting account",
  },
  delete_account_reason_found_something_better: {
    message: "Found something better",
    description: "Reason for deleting account",
  },
  delete_account_reason_tech_issues: {
    message: "Technical issues",
    description: "Reason for deleting account",
  },
  delete_account_reason_ease_of_use_issues: {
    message: "Ease of use issues",
    description: "Reason for deleting account",
  },
  delete_account_reason_too_expensive: {
    message: "Too expensive",
    description: "Reason for deleting account",
  },
  delete_account_reason_missing_features: {
    message: "Missing features",
    description: "Reason for deleting account",
  },
  // `_other` is a special postfix, so use `_other1` to pass typechecking.
  delete_account_reason_other1: {
    message: "Other",
    description: "Reason for deleting account",
  },
  more_details: {
    message: "More details",
    description: "Label for user to enter text to explain the account deletion",
  },
  optional: {
    message: "Optional",
    description: "Label to indicate something is optional to have",
  },
  delete_account_confirmation: {
    message:
      "I acknowledge and understand that the changes cannot be undone and I will lose all the data in the account.",
    description: "Confirmation text to acknowledge account deletion",
  },
  delete_account: {
    message: "Delete account",
    description: "Button text to start account deletion",
  },
  compose: {
    message: "Compose",
    description: "Button text for compose nav link in sidebar",
  },
  chat: {
    message: "Chat",
    description: "Button text for chat nav link in sidebar",
  },
  assistant: {
    message: "Assistant",
    description: "Button text for assistant nav link in sidebar",
  },
  assistant_changelog: {
    message: "Changelog",
    description:
      "Button tooltip + Modal title for the Dash Assistant changelog",
  },
  assistant_request_a_feature: {
    message: "Request a feature",
    description: "Button text to request a feature for the Dash Assistant",
  },
  assistant_changelog_description: {
    message: "New updates and improvements to the Dash Assistant.",
    description: "Description for the Dash Assistant changelog modal",
  },
  assistant_changelog_default_link: {
    message: "Try it",
    description: "Default text for a changelog item CTA link",
  },
  compose_context: {
    message: "Context",
    description:
      "Label for tab that lets user provide context for the composing a draft",
  },
  compose_chat: {
    message: "Chat",
    description:
      "Label for tab that lets user chat with a the compose assistant AI",
  },
  compose_sessions: {
    message: "Sessions",
    description:
      "Button text for menu that lets user view past compose sessions",
  },
  compose_new_session: {
    message: "New session",
    description: "Button text to start a new compose session",
  },
  compose_prompt_dash_placeholder: {
    message: "Choose an option above or start chatting to get started…",
    description: "Placeholder text for the compose AI chat input",
  },
  compose_prompt_dash_placeholder_chat: {
    message: "Chat with Dash",
    description: "Placeholder text for compose chat after content selected",
  },
  compose_prompt_dash_placeholder_chat_with_source: {
    message: "Chat with 1 source…",
    description: "Placeholder text compose chat after content and sources",
  },
  compose_prompt_dash_placeholder_chat_with_sources: {
    message: "Chat with {{count}} sources…",
    description: "Placeholder text compose chat after content and sources",
  },
  compose_message_follow_up_suggestions: {
    message: "Follow up suggestions",
    description: "Label for follow-up suggestions in compose chat",
  },
  compose_message_waiting_for_response: {
    message: "Thinking",
    description: "Loading state label when composing a response",
  },
  compose_message_waiting_for_response_drafting: {
    message: "Drafting",
    description: "Loading state label when composing a response for a draft",
  },
  compose_message_title_read_browser_tab: {
    message: "Read {{title}}",
    description: "Title for the compose chat message to read a browser tab",
  },
  compose_generic_error: {
    message: "Unable to get chat response, please try again",
    description: "Error message for compose chat",
  },
  compose_error_loading_content: {
    message: "Unable to read the document. Content format may be unsupported.",
    description:
      "Error message for compose chat due to error loading source content",
  },
  compose_assistant_title: {
    message: "Dash Chat",
    description: "Title for Dash Chat",
  },
  compose_editor_selection_action_make_longer: {
    message: "Make longer",
    description: "Action to make selected text longer in the compose editor",
  },
  compose_editor_selection_action_make_shorter: {
    message: "Make shorter",
    description: "Action to make selected text shorter in the compose editor",
  },
  compose_editor_selection_action_rewrite: {
    message: "Rewrite",
    description: "Action to rewrite selected text in the compose editor",
  },
  compose_editor_selection_action_prompt: {
    message: "Prompt",
    description:
      "Action to prompt the AI about the selected text in the compose editor",
  },
  compose_selection_action_make_longer: {
    message: "Make selection longer",
    description: "User message asking AI to make selected text longer",
  },
  compose_selection_action_make_shorter: {
    message: "Make selection shorter",
    description: "User message asking AI to make selected text shorter",
  },
  compose_selection_action_rewrite: {
    message: "Rewrite selection",
    description: "User message asking AI to rewrite selected text",
  },
  compose_editor_placeholder_title: {
    message: "Title",
    description: "Placeholder text for the compose editor title",
  },
  compose_editor_placeholder_subtitle: {
    message: "Subtitle",
    description: "Placeholder text for the compose editor subtitle",
  },
  compose_editor_placeholder_body: {
    message:
      "Provide inputs in the context pane to get started. Dash will use sources to create a new draft for you here!",
    description: "Placeholder text for the compose editor body",
  },
  compose_editor_export_action: {
    message: "Export",
    description: "Action to export content of the compose editor",
  },
  compose_editor_export_action_copy_text: {
    message: "Copy text",
    description: "Action to copy text from the compose editor",
  },
  compose_editor_export_action_copy_markdown: {
    message: "Copy markdown",
    description: "Action to copy markdown from the compose editor",
  },
  compose_editor_export_action_save_pdf: {
    message: "Save as PDF",
    description: "Action to save content as a PDF from the compose editor",
  },
  compose_editor_export_error_saving_pdf_not_supported: {
    message: "PDF export is not supported for this content type",
    description:
      "Error message when trying to save PDF for unsupported content",
  },
  compose_editor_export_error_saving_pdf_failed: {
    message: "Failed to save PDF. Please try again later.",
    description: "Error message when saving PDF fails",
  },
  compose_editor_export_action_save_paper: {
    message: "Save to Paper",
    description: "Action to save content to Paper from the compose editor",
  },
  compose_editor_export_copied_completion: {
    message: "Copied to clipboard",
    description: "message after copying content from the compose editor",
  },
  compose_editor_export_progress_saving_paper: {
    message: "Exporting to Paper",
    description: "message about ongoing export to Paper",
  },
  compose_editor_export_error_saving_paper: {
    message: "Failed to export. Please try again later.",
    description: "message about error exporting to Paper",
  },
  compose_editor_toolbar_action_undo: {
    message: "Undo",
    description: "Action to undo the last action in the compose editor",
  },
  compose_editor_toolbar_action_redo: {
    message: "Redo",
    description: "Action to redo the last action in the compose editor",
  },
  compose_editor_toolbar_action_format_bold: {
    message: "Format Bold",
    description: "Action to bold text in the compose editor",
  },
  compose_editor_toolbar_action_format_italic: {
    message: "Format Italic",
    description: "Action to italicize text in the compose editor",
  },
  compose_editor_toolbar_action_format_underline: {
    message: "Format Underline",
    description: "Action to underline text in the compose editor",
  },
  compose_editor_toolbar_action_format_strikethrough: {
    message: "Format Strikethrough",
    description: "Action to strikethrough text in the compose editor",
  },
  compose_editor_toolbar_action_format_heading1: {
    message: "Format Heading 1",
    description: "Action to convert text to a heading 1 in the compose editor",
  },
  compose_editor_toolbar_action_format_heading2: {
    message: "Format Heading 2",
    description: "Action to convert text to a heading 2 in the compose editor",
  },
  compose_editor_toolbar_action_format_heading3: {
    message: "Format Heading 3",
    description: "Action to convert text to a heading 3 in the compose editor",
  },
  compose_editor_toolbar_action_format_link: {
    message: "Create Link",
    description: "Action to add a url link to text in the compose editor",
  },
  compose_editor_toolbar_action_format_list: {
    message: "Format List",
    description: "Action to convert text to a list item in the compose editor",
  },
  compose_editor_toolbar_action_insert_table: {
    message: "Insert Table",
    description: "Action to add a table in the compose editor",
  },
  compose_editor_toolbar_action_enter_link: {
    message: "Enter URL Link",
    description: "Prompt to enter a URL link in the compose editor",
  },
  compose_editor_insert_table_column_left: {
    message: "Insert column left",
    description: "Action to add a column to the left in a table",
  },
  compose_editor_insert_table_column_right: {
    message: "Insert column right",
    description: "Action to add a column to the right in a table",
  },
  compose_editor_insert_table_row_above: {
    message: "Insert row above",
    description: "Action to add a row above in a table",
  },
  compose_editor_insert_table_row_below: {
    message: "Insert row below",
    description: "Action to add a row below in a table",
  },
  compose_new_tone: {
    message: "New tone",
    description: "Custom tone default name",
  },
  compose_context_form_content_type: {
    message: "Content type",
    description: "Label for content type in the Compose context form",
  },
  compose_context_form_source: {
    message: "Sources",
    description: "Label for sources in the Compose context form",
  },
  compose_context_form_describe: {
    message: "Describe what you want to create",
    description: "Label for description input in the Compose context form",
  },
  compose_context_form_describe_placeholder: {
    message: "Goal, tone, length, etc…",
    description:
      "Placeholder for description input in the Compose context form",
  },
  compose_context_form_tone: {
    message: "Tone",
    description: "Label for choosing a tone in the Compose context form",
  },
  compose_context_form_create_tone: {
    message: "Create custom tone",
    description: "Button text to create a new tone configuration",
  },
  compose_context_form_content_type_email: {
    message: "Email",
    description: "Option for content type in the Compose context form",
  },
  compose_context_form_content_type_message: {
    message: "Chat Message",
    description: "Option for content type in the Compose context form",
  },
  compose_context_form_content_type_report: {
    message: "Report",
    description: "Option for content type in the Compose context form",
  },
  compose_context_form_content_type_proposal: {
    message: "Proposal",
    description: "Option for content type in the Compose context form",
  },
  compose_context_form_content_type_social_media_post: {
    message: "Social Media Post",
    description: "Option for content type in the Compose context form",
  },
  compose_context_form_content_type_meeting_agenda: {
    message: "Meeting Agenda",
    description: "Option for content type in the Compose context form",
  },
  compose_context_form_content_type_none: {
    message: "Other",
    description:
      "Option for not choosing a content type in the Compose context form",
  },
  compose_sources_empty_state_title: {
    message: "Upload or drag files here",
    description: "Title for empty state in the Compose sources form",
  },
  compose_sources_no_results_description: {
    message: "No results found",
    description: "Title for empty state in the Compose sources form",
  },
  compose_sources_no_results_empty_query_description: {
    message: "Start typing to search",
    description:
      "Description for no results with an empty query in Compose sources form",
  },
  compose_sources_empty_state_sources_subtitle: {
    message: "PDF, DOCX, XLSX, CSV, TXT, MD",
    description:
      "Subtitle with file types for empty state in the Compose sources form",
  },
  compose_sources_header: {
    message: "Sources",
    description: "Header for add sources component in Compose",
  },
  compose_sources_subheader: {
    message: "Add sources to reference during your conversation.",
    description: "Subheader for add sources component in Compose",
  },
  compose_assistant_file_uploader_button_label: {
    message: "Upload",
    description: "Label for file uploader button in Compose",
  },
  compose_assistant_browser_tab_sources_button_label: {
    message: "Tabs",
    description: "Label for browser tab sources button in Compose",
  },
  compose_assistant_file_uploader_snackbar_message: {
    message: "File uploaded for this session only",
    description: "Label for file upload snackbar message",
  },
  compose_assistant_file_uploader_snackbar_message_templates: {
    message: "File uploaded for this template only",
    description: "Label for file upload snackbar message",
  },
  compose_assistant_save_company_snackbar_message_templates: {
    message: "Created a template for your company",
    description: "Label for file upload snackbar message",
  },
  compose_assistant_save_individual_snackbar_message_templates: {
    message: "Created a new private template",
    description: "Label for file upload snackbar message",
  },
  compose_assistant_file_uploader_snackbar_dismiss: {
    message: "Got it",
    description: "Label for file upload snackbar dismissal",
  },
  compose_assistant_file_uploader_error_title: {
    message: "Upload failed.",
    description: "Label for file uploader failure",
  },
  compose_assistant_file_uploader_error_size: {
    message: "Files must be 50MB or less",
    description: "Subtitle label for file uploader size failure",
  },
  compose_assistant_file_uploader_error_type: {
    message: "Supported file types: .pdf, .docx, .xlsx, .csv, .txt, .rtf",
    description: "Subtitle label for file uploader type failure",
  },
  compose_assistant_file_uploader_error_unexpected: {
    message: "An unexpected error occured",
    description: "Subtitle label for file uploader generic failure",
  },
  compose_assistant_file_uploader_dnd_title: {
    message: "Upload a file as a source",
    description: "Title for dnd when uploading local file",
  },
  compose_assistant_file_uploader_dnd_subtitle: {
    message:
      "Drag and drop into this window and Dash will upload the file as a source.",
    description: "Subtitle for dnd when uploading local file",
  },
  compose_assistant_file_uploader_dnd_text: {
    message:
      "50MB Limit. Supported file types: .pdf, .docx, .xlsx, .csv, .txt, .rtf",
    description: "Subtitle for dnd when uploading local file",
  },
  compose_sources_search_input_placeholder: {
    message: "Search Dash or paste a link",
    description: "Placeholder for search input in the Compose sources form",
  },
  compose_sources_search_title: {
    message: "Add sources",
    description: "Title for search in the Compose sources form",
  },
  compose_source_content_load_error: {
    message: "Error loading content",
    description: "Error message for failing to load content for a source",
  },
  compose_source_unsupported_error: {
    message: "Unsupported content type",
    description: "Error message for unsupported source types",
  },
  compose_source_row_open_button_label: {
    message: "Open source",
    description: "CTA for opening a source in a new tab",
  },
  compose_source_row_remove_button_label: {
    message: "Remove source",
    description: "CTA for removing a source in a compose source row",
  },
  compose_source_row_upload_tooltip: {
    message:
      "Uploaded documents are only available in this chat session, not in the rest of Dash.",
    description: "Tooltip for compose sources that are manual uploads",
  },
  compose_context_form_generate_draft_action: {
    message: "Create draft",
    description: "Button text to generate a draft in the Compose context form",
  },
  compose_draft_prompt_generate: {
    message:
      "Generate a draft for a {{contentTypeString}} with the following description",
    description: "Prompt text submitted to AI for generating a new draft",
  },
  compose_draft_prompt_generate_no_content_type: {
    message: "Generate a draft with the following description",
    description: "Prompt text submitted to AI for generating a new draft",
  },
  compose_draft_prompt_generate_include_sources: {
    message: "Make sure to reference the sources included above",
    description: "Prompt text submitted to AI for generating a new draft",
  },
  compose_draft_generate_draft_short_message: {
    message: "Generate a draft",
    description: "Short message to generate a draft",
  },
  compose_delete_session_confirm_title: {
    message: "Delete this session?",
    description: "Title for the delete session confirmation dialog",
  },
  compose_delete_session_confirm_description: {
    message:
      "Draft and all messages with the assistant in this session will be deleted.",
    description: "Description for the delete session confirmation dialog",
  },
  assist_delete_action_confirm_title: {
    message: "Delete this action?",
    description: "Title for the delete action confirmation dialog",
  },
  assist_delete_action_confirm_description: {
    message: "This action will be deleted.",
    description: "Description for the delete action confirmation dialog",
  },
  assist_action_create_title: {
    message: "Create a quick action",
    description: "Title for the create action modal",
  },
  assist_action_edit_title: {
    message: "Edit quick action",
    description: "Title for the edit action modal",
  },
  assist_action_name_label: {
    message: "Name",
    description: "Label for field to name an action in the Actions pane",
  },
  assist_action_name_placeholder: {
    message: "Write something…",
    description: "Placeholder for field to name an action in the Actions pane",
  },
  assist_action_icon_label: {
    message: "Icon",
    description: "Label for field to set an icon in the Actions pane",
  },
  assist_action_url_condition_label: {
    message: "URL",
    description: "Label for field to set a URL condition in the Actions pane",
  },
  assist_action_url_condition_helper_text: {
    message: "When does this AI tool appear?",
    description:
      "Helper text for field to set a URL condition in the Actions pane",
  },
  assist_action_url_condition_placeholder: {
    message: "https://example.com/*",
    description:
      "Placeholder for field to set a URL condition in the Actions pane",
  },
  assist_action_doc_type_condition_label: {
    message: "Any page like this",
    description:
      "Label for toggle to set a doc type condition in the Actions pane",
  },
  assist_action_doc_type_condition_helper_text: {
    message:
      "This action will appear on other pages similar to this one ({{docType}}).",
    description: "Helper text for toggle to set a doc type condition",
  },
  assist_action_instruction_label: {
    message: "Prompt",
    description: "Label for field to set an instruction in the Actions pane",
  },
  assist_action_instruction_helper_text: {
    message: "Give Dash instructions for how the tool should behave.",
    description:
      "Helper text for field to set an instruction in the Actions pane",
  },
  assist_action_instruction_placeholder: {
    message:
      "Try something descriptive e.g. “Summarize this email in less than 50 words”",
    description:
      "Placeholder for field to set an instruction in the Actions pane",
  },
  assist_ai_prompt_disclaimer: {
    message: "Uses third-party AI. Your data stays private.",
    description: "Disclaimer for the user prompt inputs in Dash Assistant",
  },
  assist_ai_prompt_external_link: {
    message: "Read our AI principles",
    description: "Disclaimer for the user prompt inputs in Dash Assistant",
  },
  assist_action_permissions_label: {
    message: "Permissions",
    description: "Label for field to set permissions in the Actions pane",
  },
  assist_action_permissions_helper_text: {
    message: "Set who can use this action",
    description: "Helper text for field to set permissions in the Actions pane",
  },
  publish_action_to_company_label_helper_text: {
    message: "Everyone at your company will be able to use this action",
    description: "Helper text for selecting to publish action to company",
  },
  assist_demo_prompt_summarize: {
    message:
      "Provide a concise summary of this document, highlighting the key points, main insights, and any actionable takeaways.",
    description: "Prompt for summarizing a document in the assistant demo",
  },
  assist_demo_prompt_analyze: {
    message:
      "Examine this content for trends, patterns, or key insights. Identify strengths, weaknesses, and any potential improvements based on the data or structure presented.",
    description: "Prompt for analyzing a document in the assistant demo",
  },
  assist_demo_prompt_brainstorm: {
    message:
      "Write up new ideas, improvements, or alternative approaches based on the themes or objectives of this document. Consider innovative strategies, creative directions, or optimizations.",
    description: "Prompt for brainstorming a document in the assistant demo",
  },
  assist_demo_error_getting_pdf_file_from_url: {
    message: "Error while loading a pdf file",
    description: "Error message for failing to get pdf file from url",
  },
  assist_demo_error_processing_pdf_file: {
    message: "Error while processing a pdf file",
    description: "Error message for failing to process pdf file",
  },
  assist_ai_buttons_tab_your_actions: {
    message: "Your actions",
    description: "Label for the Your actions tab in the Actions pane",
  },
  assist_ai_buttons_tab_all_actions: {
    message: "All actions",
    description: "Label for the All actions tab in the Actions pane",
  },
  assist_manage_quick_actions_title: {
    message: "Manage quick actions",
    description: "Title for the Actions pane",
  },
  assist_add_ai_button: {
    message: "Create",
    description: "Button label for creating a new AI tool in the Actions pane",
  },
  assist_ai_button_add: {
    message: "Add",
    description: "Button label for enabling an AI tool in the Actions pane",
  },
  assist_ai_button_remove: {
    message: "Remove",
    description: "Button label for disabling an AI tool in the Actions pane",
  },
  assist_buttons_list_title_user_created: {
    message: "Created by you",
    description: "Section title for user-created AI Actions",
  },
  assist_buttons_list_title_created_by_colleagues: {
    message: "Created by colleagues",
    description: "Section title for AI Actions created by colleagues",
  },
  assist_buttons_list_title_created_by_dash: {
    message: "Created by Dash",
    description: "Section title for preset AI Actions created by Dash",
  },
  assist_buttons_list_title_shared: {
    message: "Shared buttons",
    description: "Section title for shared (created by other users) AI Actions",
  },
  assist_ai_action_condition_header: {
    message: "Appears on",
    description: "Label for showing the condition of an AI Action",
  },
  assist_ai_action_condition_named: {
    message: "Appears on {{serviceNames}}",
    description:
      "Label for showing the condition of an AI Action (named sites)",
  },
  assist_ai_action_condition_named_truncated: {
    message: "Appears on {{serviceNames}} and {{remainingCount}} other sites",
    description:
      "Label for showing the condition of an AI Action (named sites, truncated)",
  },
  assist_ai_action_condition_any_url: {
    message: "any website",
    description: "Label for showing that an AI Action matches any website",
  },
  assist_conversation_list_modal_title: {
    message: "All sessions",
    description: "Title for all sessions modal",
  },
  assist_conversation_list_embed_modal_title: {
    message: "History",
    description: "Title for all sessions modal",
  },

  assist_conversation_list_modal_title_today: {
    message: "Today",
    description: "Title for today in the conversation list modal",
  },
  assist_conversation_list_modal_title_yesterday: {
    message: "Yesterday",
    description: "Title for yesterday in the conversation list modal",
  },
  assist_conversation_list_modal_title_previous_30_days: {
    message: "Previous 30 days",
    description: "Title for previous 30 days in the conversation list modal",
  },
  assist_template_title_status_report: {
    message: "Status Report",
    description: "Title for status report template",
  },
  assist_template_title_follow_up_email: {
    message: "Follow-up Email",
    description: "Title for follow-up email template",
  },
  assist_template_title_meeting_summary: {
    message: "Meeting Summary",
    description: "Title for meeting summary template",
  },
  assist_templates_title: {
    message: "Templates",
    description: "Title for templates menu",
  },
  assist_templates_explore: {
    message: "Explore AI Tools",
    description: "Label for accessing templates menu",
  },
  assist_templates_home_view_more: {
    message: "View more templates",
    description: "Label for accessing templates menu",
  },
  use_template_confirmation_description: {
    message: "Do you want to use this template now?",
    description: "Description for the use template confirmation dialog",
  },
  use_tone_confirmation_description: {
    message: "Do you want to use this tone now?",
    description: "Description for the use tone confirmation dialog",
  },
  tool_confirmation_dialog_yes: {
    message: "Yes",
    description: "Label for the yes button in the confirmation dialog",
  },
  tool_confirmation_dialog_no: {
    message: "No",
    description: "Label for the no button in the confirmation dialog",
  },
  assist_templates_home_subtitle_your_templates: {
    message: "Your templates",
    description: "Label for the your templates section in the assist write app",
  },
  assist_templates_home_subtitle_starter_templates: {
    message: "Starter templates",
    description:
      "Label for the starter templates section in the assist write app",
  },
  assist_templates_home_subtitle_company_templates: {
    message: "Company templates",
    description:
      "Label for the company templates section in the assist write app",
  },
  assist_templates_type_scratch: {
    message: "Start from scratch",
    description: "Button for not choosing a specific content type",
  },
  assist_templates_menu_title: {
    message: "Template",
    description:
      "Dropdown menu title for selecting a template in the compose editor",
  },
  assist_templates_pane_title: {
    message: "Add sources",
    description: "Title for the Templates pane in the assist editor settings",
  },
  assist_templates_modal_stepper_save_template_title: {
    message: "Save template",
    description: "Title for the save template step in the modal stepper",
  },
  assist_delete_templates_confirm_title: {
    message: "Delete this template?",
    description: "Title for the delete template confirmation dialog",
  },
  assist_delete_templates_confirm_description: {
    message: "This template configuration will be deleted.",
    description: "Description for the delete template confirmation dialog",
  },
  assist_templates_modal_stepper_name_placeholder: {
    message: "What would you like to call this template?",
    description: "Placeholder for field to name a template",
  },
  assist_templates_modal_stepper_description_placeholder: {
    message: "What is this template for?",
    description: "Placeholder for field to describe a template",
  },
  assist_templates_settings_from_sources_sublabel: {
    message: "Set who can edit and use this template",
    description: "Sublabel for field to share a template in the Tones pane",
  },
  assist_templates_settings_from_sources_use_template: {
    message: "Use Template",
    description: "Button to use template",
  },
  assist_templates_modification_error_msg: {
    message: "There was an error generating your template. Please try again.",
    description: "Modify custom template message description",
  },
  assist_new_template: {
    message: "New template",
    description: "Default name for a new template",
  },
  assist_template_search: {
    message: "Search all templates",
    description: "Search template text input placeholder",
  },
  assist_template_create: {
    message: "Create Template",
    description: "Label to create a new template",
  },
  assist_template_filter: {
    message: "Filter by template type",
    description: "Aria label to filter by template type",
  },
  assist_template_no_results: {
    message: "No results",
    description: "Search template empty result",
  },
  assist_template_rewrite_message_default: {
    message: "Write a new draft using the {{templateName}} Template",
    description: "Default message to rewrite using a template",
  },
  assist_template_rewrite_message_custom: {
    message: "Write a new draft using {{templateName}}",
    description: "Custom message to rewrite using a template",
  },
  assist_template_selected_label: {
    message: "Selected Template",
    description: "Label for selected template in the assist editor",
  },
  assist_template_edit_label: {
    message: "Edit Template",
    description: "Label for editing a template in the assist editor",
  },
  assist_template_sources_title: {
    message: "Add sources",
    description: "Label for page one of custom template creation",
  },
  assist_template_sources_description: {
    message: "Add sources for the assistant to generate a template",
    description: "Description for page one of custom template creation",
  },
  assist_template_created_message: {
    message: "Template created",
    description: "Description for intial template creation message",
  },
  assist_template_updated_message: {
    message: "Template updated",
    description: "Description for template update message",
  },
  assist_template_loading_message: {
    message: "Drafting custom template",
    description: "Description for template creation loading message",
  },
  assist_templates_faq_document_title: {
    message: "FAQ Document",
    description: "Title for FAQ Document template",
  },
  assist_templates_faq_document_description: {
    message: "Create a comprehensive FAQ document with organized Q&A sections",
    description: "Description for FAQ Document template",
  },
  assist_templates_faq_document_content: {
    message: `# FAQ for Product X\n\n### Password Reset\n**Q**: How do I reset my password?  \n**A**: Go to the login page and click “Forgot Password.” Enter your email, and you’ll receive a reset link within minutes.\n\n### Free Plan Features\n**Q**: What features are included in the free plan?  \n**A**: The free plan includes basic task management, collaboration tools for up to 5 users, and 2 GB of storage.\n\n### Support Contact\n**Q**: How do I contact support?  \n**A**: You can reach our support team 24/7 via live chat or email at support@productx.com.`,
    description: "Content for FAQ Document template",
  },
  assist_templates_team_meeting_agenda_title: {
    message: "Team Meeting Agenda",
    description: "Title for Team Meeting Agenda template",
  },
  assist_templates_team_meeting_agenda_description: {
    message: "Structure a clear and effective team meeting agenda",
    description: "Description for Team Meeting Agenda template",
  },
  assist_templates_team_meeting_agenda_content: {
    message: `# Weekly Standup\n\n**Date**: November 20, 2024  \n**Time**: 10:00 AM – 11:00 AM  \n**Location**: Zoom (Link: [Insert Link])\n\n## Agenda\n\n### 1. Welcome and Objectives (10 mins)\n- Review meeting purpose and key outcomes\n\n### 2. Project Updates (15 mins)\n- Team Leads provide status updates\n\n### 3. Challenges and Blockers (15 mins)\n- Discuss current obstacles and potential solutions\n\n### 4. Upcoming Deliverables (10 mins)\n- Review deadlines for Q4\n\n### 5. Q&A and Open Discussion (10 mins)\n\n### 6. Action Items Recap and Closing (5 mins)`,
    description: "Content for Team Meeting Agenda template",
  },
  assist_templates_project_kickoff_title: {
    message: "Project Kickoff",
    description: "Title for Project Kickoff template",
  },
  assist_templates_project_kickoff_description: {
    message: "Create a detailed project kickoff meeting agenda and structure",
    description: "Description for Project Kickoff template",
  },
  assist_templates_project_kickoff_content: {
    message: `# AI Integration Project\n\n**Date**: November 22, 2024  \n**Time**: 2:00 PM – 3:30 PM  \n**Attendees**: [Project Sponsor, PM, Team Leads]\n\n## Agenda\n\n### 1. Welcome and Introductions (10 mins)\n- Overview of roles and responsibilities\n\n### 2. Project Objectives (15 mins)\n- Define goals and success metrics\n\n### 3. Scope and Deliverables (20 mins)\n- Review project charter and timelines\n\n### 4. Communication Plan (15 mins)\n- Set meeting cadence and tools for updates\n\n### 5. Next Steps and Q&A (30 mins)`,
    description: "Content for Project Kickoff template",
  },
  assist_templates_meeting_summary_title: {
    message: "Meeting Summary",
    description: "Title for Meeting Summary template",
  },
  assist_templates_meeting_summary_description: {
    message: "Summarize key points, decisions, and action items from meetings",
    description: "Description for Meeting Summary template",
  },
  assist_templates_meeting_summary_content: {
    message: `# Monthly Retro Notes\n\n**Team/Project**: [Team Name/Project Name]  \n**Date**: November 20, 2024  \n**Attendees**: [Names/Roles]\n\n## Summary\n- Discussed Q4 project milestones\n- Identified blockers in marketing campaign execution\n- Reviewed new deadlines for deliverables\n\n## Next Steps\n1. [Team Member 1] to finalize marketing materials by November 25th\n2. [Team Member 2] to resolve software issue with IT by November 23rd\n3. Schedule follow-up meeting for November 27th at 3:00 PM`,
    description: "Content for Meeting Summary template",
  },
  assist_templates_task_tracking_title: {
    message: "Task Tracking",
    description: "Title for Task Tracking template",
  },
  assist_templates_task_tracking_description: {
    message: "Organize and track tasks effectively",
    description: "Description for Task Tracking template",
  },
  assist_templates_task_tracking_content: {
    message: `## Purpose: Stay organized and ensure your team is aligned on priorities\n\n### How to Use:\n- Task Name: Clearly describe the task to avoid confusion.\n- Owner: Assign responsibility to a specific person.\n- Due Date: Set realistic deadlines to keep the project moving forward.\n- Priority: Label tasks (e.g., High, Medium, Low) to focus on what matters most.\n- Status: Track progress with statuses like Not Started, In Progress, or Completed.\n- Notes: Capture any additional details or updates.\n\nThis template ensures that tasks are visible, ownership is clear, and nothing falls through the cracks. Perfect for team collaboration or personal productivity!`,
    description: "Content for Task Tracking template",
  },
  assist_templates_status_report_title: {
    message: "Status Report",
    description: "Title for Status Report template",
  },
  assist_templates_status_report_description: {
    message: "Provide a concise update on project status and progress",
    description: "Description for Status Report template",
  },
  assist_templates_status_report_content: {
    message: `## Purpose: Provide a quick, clear update on progress, challenges, and next steps\n\n### Structure:\n1. Project Name/Overview: A brief one-liner summarizing the project or initiative.\n2. Highlights: Share major wins or milestones achieved this period.\n3. Challenges: Mention blockers or risks impacting progress and any steps being taken to address them.\n4. Metrics/Deliverables: Include key numbers or deliverables to show measurable progress.\n5. Next Steps: Outline what’s coming up and who is responsible.\n\nThis template helps stakeholders stay informed and aligns everyone on what’s next. Pro tip: Keep it short and focused—people appreciate concise updates!`,
    description: "Content for Status Report template",
  },
  assist_templates_change_management_plan_title: {
    message: "Change Management Plan",
    description: "Title for Change Management Plan template",
  },
  assist_templates_change_management_plan_description: {
    message:
      "Develop a structured plan for implementing organizational changes",
    description: "Description for Change Management Plan template",
  },
  assist_templates_change_management_plan_content: {
    message: `# Change Management Plan\n\n## 1. Objective\nTransition from the current project management software to a more robust, cloud-based solution to improve team collaboration and reduce task duplication.\n\n## 2. Stakeholders\n- Executive Sponsors (CEO, CTO)\n- Project Management Team (PMO Lead, Project Managers)\n- End Users (All employees managing tasks and projects)\n\n## 3. Communication Plan\n- Weekly email updates to all staff\n- Bi-weekly town hall for Q&A and feedback\n- Dedicated intranet page with FAQs and training videos\n\n## 4. Implementation Steps\n### Phase 1 (Feb 15 – Feb 28)\n- Pilot testing with the PMO team, led by PMO Lead\n\n### Phase 2 (Mar 1 – Mar 15)\n- Roll-out to project managers, including short training sessions, led by Training Manager\n\n### Phase 3 (Mar 16 – Mar 31)\n- Full organization-wide launch, monitored by IT and Customer Success teams for support\n\n## 5. Training/Support\n- Virtual workshops and recorded sessions available via company LMS\n- On-demand email and help desk support for troubleshooting\n- “Office hours“ twice a week for live assistance\n\n## 6. Success Metrics\n- 90% of projects fully active on new software within one month of launch\n- 25% reduction in duplicate task creation after three months\n- Positive user feedback score of 8/10 or higher on post-implementation survey`,
    description: "Content for Change Management Plan template",
  },
  assist_templates_team_recognition_email_title: {
    message: "Team Recognition Email",
    description: "Title for Team Recognition Email template",
  },
  assist_templates_team_recognition_email_description: {
    message: "Write an email recognizing team accomplishments",
    description: "Description for Team Recognition Email template",
  },
  assist_templates_team_recognition_email_content: {
    message: `### Subject: Big Kudos to the Marketing Team 🎉\n\nHi Team,\n\nI want to take a moment to spotlight our incredible Marketing Team for their outstanding work on the Spring Product Launch campaign. They orchestrated a seamless rollout that not only captured our customers’ attention but also drove a significant boost in our online engagement.\n\nTheir creativity and hard work truly shone through, and I’m thrilled to see how this has positively impacted our brand visibility and overall sales performance. I especially appreciate the late hours they put in leading up to launch day—your dedication did not go unnoticed!\n\nLet’s all give them a big round of applause 👏 and celebrate this amazing accomplishment together!\n\nKeep up the fantastic work, everyone—it’s inspiring to see the dedication and talent on this team!\n\nBest,  \n[Your Name]`,
    description: "Content for Team Recognition Email template",
  },
  assist_templates_standard_operating_procedure_sop_title: {
    message: "Standard Operating Procedure",
    description: "Title for SOP template",
  },
  assist_templates_standard_operating_procedure_sop_description: {
    message: "Document step-by-step procedures for common tasks",
    description: "Description for SOP template",
  },
  assist_templates_standard_operating_procedure_sop_content: {
    message: `## SOP: Submitting a Marketing Campaign Proposal\n\n### Purpose: \nTo outline the process for submitting and approving marketing campaign proposals.\n\n### Scope: \nApplies to all marketing team members submitting proposals for review.\n\n### Procedure:\n1. Draft Proposal:\n    - Use the Marketing Proposal Template.\n    - Include campaign goals, target audience, budget, and timeline.\n2. Submit for Review:\n    - Upload the draft to the shared drive under the “Proposals“ folder.\n    - Notify the Marketing Manager via Slack with the link to the proposal.\n3. Approval Process:\n    - The Marketing Manager reviews and provides feedback within 2 business days.\n    - Update the document based on feedback and resubmit for final approval.\n4. Archival:\n    - Once approved, move the final proposal to the “Approved Campaigns“ folder.\n\n### Tools and Resources:\n- Marketing Proposal Template: [Link]\n- Shared Drive: [Link]`,
    description: "Content for SOP template",
  },
  assist_templates_follow_up_email_title: {
    message: "Follow-Up Email",
    description: "Title for Follow-Up Email template",
  },
  assist_templates_follow_up_email_description: {
    message: "Send a professional follow-up after meetings or discussions",
    description: "Description for Follow-Up Email template",
  },
  assist_templates_follow_up_email_content: {
    message: `### Subject: “Great connecting today, Ashley!“\n\nHi Ashley,\n\nIt was great speaking with you earlier! I wanted to recap our conversation and highlight the next steps we discussed:\n\n- You’re interested in automating your reporting process to save time.\n- I’ll send over a demo link by Friday for you to review with your team.\n\nIn the meantime, here’s a case study I mentioned: [Link]. Let me know if you have any questions!\n\nLooking forward to reconnecting next week.\n\nBest regards, \n[Your Name]`,
    description: "Content for Follow-Up Email template",
  },
  assist_templates_meeting_scheduling_email_title: {
    message: "Meeting Scheduling Email",
    description: "Title for Meeting Scheduling Email template",
  },
  assist_templates_meeting_scheduling_email_description: {
    message: "Coordinate meeting times with participants",
    description: "Description for Meeting Scheduling Email template",
  },
  assist_templates_meeting_scheduling_email_content: {
    message: `### Subject: “Let’s schedule our next meeting“\n\nHi Ashley,\n\nI hope you’re doing well! I’d like to schedule a follow-up meeting to discuss the next steps on the project. Here are some times that work for me:\n\n- Tuesday, November 21, 10:00 AM – 11:00 AM\n- Wednesday, November 22, 2:00 PM – 3:00 PM\n\nLet me know what works best for you, or feel free to suggest another time.\n\nLooking forward to connecting!\n\nBest regards, \n[Your Name]`,
    description: "Content for Meeting Scheduling Email template",
  },
  assist_templates_customer_onboarding_email_title: {
    message: "Customer Onboarding Email",
    description: "Title for Customer Onboarding Email template",
  },
  assist_templates_customer_onboarding_email_description: {
    message: "Welcome and guide new customers through initial steps",
    description: "Description for Customer Onboarding Email template",
  },
  assist_templates_customer_onboarding_email_content: {
    message: `### Subject: “Welcome to [Your Company]!“\n\nHi Ashley,\n\nWelcome to [Company Name]! We’re excited to have you on board. Here’s everything you need to get started:\n\n1. Log in to your account: [Insert Link].\n2. Review our Getting Started Guide: [Insert Link].\n3. Join our onboarding webinar: [Insert Date/Time and Link].\n\nIf you have any questions, don’t hesitate to reach out to our support team at [email].\n\nLooking forward to helping you succeed!\n\nBest regards, \n[Your Name]`,
    description: "Content for Customer Onboarding Email template",
  },
  assist_templates_sales_outreach_email_title: {
    message: "Sales Outreach Email",
    description: "Title for Sales Outreach Email template",
  },
  assist_templates_sales_outreach_email_description: {
    message:
      "Connect with potential customers and highlight value propositions",
    description: "Description for Sales Outreach Email template",
  },
  assist_templates_sales_outreach_email_content: {
    message: `### Subject: “Ashley, let’s simplify your customer onboarding process“\n\nHi Ashley,\n\nI recently came across your team’s work in streamlining customer experiences for SMBs—impressive!\n\nI’m reaching out because I believe we can help you take that impact even further. Our AI-powered platform reduces customer onboarding time by 40%, helping teams like yours focus on building relationships instead of managing tedious tasks.\n\nFor example, a flooring installation company we worked with cut manual data entry by 50%, saving 15 hours a week.\n\nWould you be open to a quick call to explore if this is a good fit for your goals? Feel free to grab a time on my calendar here: [insert link].\n\nLooking forward to connecting!\n\nWarm regards, \n[Your Name] \n[Your Title] \n[Your Company]`,
    description: "Content for Sales Outreach Email template",
  },
  assist_templates_marketing_email_campaign_title: {
    message: "Marketing Email Campaign",
    description: "Title for Marketing Email Campaign template",
  },
  assist_templates_marketing_email_campaign_description: {
    message: "Create engaging marketing email content",
    description: "Description for Marketing Email Campaign template",
  },
  assist_templates_marketing_email_campaign_content: {
    message: `### Subject: “Unlock 20% Off Our AI-Powered Tools—This Week Only!“\n\nImagine saving hours every week by automating your repetitive tasks. With our AI-powered tools, it’s now easier than ever to focus on what matters most.\n\nFor a limited time, enjoy 20% off all plans and access features designed to simplify your workflows:\n\n- Automate reporting, task management, and client communications.\n- Gain insights faster with AI-driven analytics.\n- Get exclusive access to our new assistant feature tailored for small businesses.\n\nJoin 10,000+ professionals already transforming their productivity. “This tool has completely changed the way my team works!“ – Jessica B.\n\nDon’t miss out—this offer ends November 25th!\n[Save Now]\n\nFollow us on social media. Unsubscribe anytime.`,
    description: "Content for Marketing Email Campaign template",
  },
  assist_templates_marketing_blog_post_title: {
    message: "Marketing Blog Post",
    description: "Title for Marketing Blog Post template",
  },
  assist_templates_marketing_blog_post_description: {
    message: "Write informative and engaging blog content",
    description: "Description for Marketing Blog Post template",
  },
  assist_templates_marketing_blog_post_content: {
    message: `# Title: “5 Must-Know Marketing Trends to Dominate 2024“\n\n## Introduction: \nAre your marketing strategies stuck in the past? With 2024 right around the corner, staying ahead of the curve is critical. This post reveals five cutting-edge trends that top marketers are using to outpace their competition. Let’s dive in and future-proof your marketing game!\n\n1. Personalization at Scale \nToday’s customers demand a tailored experience. According to a recent report, 80% of consumers are more likely to buy from brands that offer personalized experiences. Use tools like HubSpot or Mailchimp to segment your audience and deliver relevant messages.\n\n2. Short-Form Video Dominance \nPlatforms like TikTok and Instagram Reels are reshaping consumer preferences. Videos under 60 seconds drive 74% higher engagement rates. Create behind-the-scenes clips, tutorials, or customer testimonials to maximize your reach.\n\n3. Sustainability Matters \nConsumers are prioritizing eco-friendly brands. Highlight your sustainability initiatives in marketing campaigns to resonate with this growing demographic. For example, Patagonia effectively communicates its environmental impact in every campaign.\n\n## Conclusion: \nThe future of marketing is fast, personal, and socially conscious. By embracing these trends, your brand will be positioned for success. Don’t wait—subscribe to our newsletter for weekly insights to keep your strategies sharp!`,
    description: "Content for Marketing Blog Post template",
  },
  assist_templates_sales_customer_onboarding_email_title: {
    message: "Sales Customer Onboarding",
    description: "Title for Sales Customer Onboarding template",
  },
  assist_templates_sales_customer_onboarding_email_description: {
    message: "Guide new customers through your product or service",
    description: "Description for Sales Customer Onboarding template",
  },
  assist_templates_sales_customer_onboarding_email_content: {
    message: `### Subject: “Welcome to StreamlinePro—Let’s Get Started!“\n\nHi [Customer Name],\n\nWe’re thrilled to have you on board at StreamlinePro! Your journey to simplified project management starts now.\n\nHere’s how to get started:\n\nStep 1: Set Up Your Account \nClick here to log in and follow our quick setup wizard. It only takes 2 minutes!\n\nStep 2: Explore Key Features\n- Task Automation: Save hours by automating repetitive tasks.\n- Team Collaboration: Assign roles and share updates with a single click.\n- Progress Tracking: Monitor your projects in real-time on our sleek dashboard.\n\nStep 3: Connect with Us \nGot questions? Our team is here 24/7 via live chat or email at support@streamlinepro.com.\n\nLet’s get started! Click below to set up your account and begin your journey. \nComplete Setup Now\n\nWe’re excited to see you succeed!\n\nWarm regards, \nThe StreamlinePro Team`,
    description: "Content for Sales Customer Onboarding template",
  },
  assist_templates_customer_support_email_title: {
    message: "Customer Support Email",
    description: "Title for Customer Support Email template",
  },
  assist_templates_customer_support_email_description: {
    message: "Respond professionally to customer inquiries",
    description: "Description for Customer Support Email template",
  },
  assist_templates_customer_support_email_content: {
    message: `### Subject: “We’re here to help with your recent issue“\n\nHi Ashley,\n\nThank you for reaching out about the login issue you experienced. I understand how frustrating that can be.\n\nHere’s what we’ve done to resolve the issue:\n- Reset your account password. You can create a new one using this link: [Insert Link].\n- Confirmed that your account is now active and working correctly.\n\nIf you continue to experience issues, please don’t hesitate to reply to this email or contact us at [Insert Support Contact Info].\n\nWe’re here to help!\n\nBest regards, \n[Your Name] \nCustomer Support Specialist`,
    description: "Content for Customer Support Email template",
  },
  assist_templates_product_release_notes_title: {
    message: "Product Release Notes",
    description: "Title for Product Release Notes template",
  },
  assist_templates_product_release_notes_description: {
    message: "Document new(features) and improvements",
    description: "Description for Product Release Notes template",
  },
  assist_templates_product_release_notes_content: {
    message: `# New Features and Updates: November 2024\n\nWe’re excited to share the latest updates to [Product Name]!\n\nWhat’s New:\n- Enhanced Analytics Dashboard: Visualize your data with improved charts and customizable reports.\n- Team Collaboration Tools: Assign tasks and track progress directly in the app.\n- Bug Fixes: Resolved login issues and improved app speed by 25%.\n\nCheck out the full release notes here: [Insert Link].\nWe hope you enjoy these updates! Let us know what you think.\n\nBest regards, \n[Your Team]`,
    description: "Content for Product Release Notes template",
  },
  assist_templates_analysis_report_title: {
    message: "Analysis Report",
    description: "Title for Analysis Report template",
  },
  assist_templates_analysis_report_description: {
    message: "Present data findings and recommendations",
    description: "Description for Analysis Report template",
  },
  assist_templates_analysis_report_content: {
    message: `## Quarterly Sales Analysis – Q3 2024\n\nOverview: \nQ3 2024 saw a 15% increase in revenue compared to Q2, driven primarily by higher SMB conversions. Key takeaways include:\n\n- Top-performing region: West Coast, with 35% of total sales.\n- Best-selling product: AI Assistant Pro, contributing 50% of sales growth.\n- Customer churn: Reduced by 8% after implementing proactive outreach campaigns.\n\nRecommendations:\n1. Increase marketing spend in the West Coast region.\n2. Develop a bundled pricing model for AI Assistant Pro.\n3. Expand outreach campaigns to target mid-market segments.`,
    description: "Content for Analysis Report template",
  },
  assist_templates_business_memo_title: {
    message: "Business Memo",
    description: "Title for Business Memo template",
  },
  assist_templates_business_memo_description: {
    message: "Communicate important information within an organization",
    description: "Description for Business Memo template",
  },
  assist_templates_business_memo_content: {
    message: `## Policy Change: Remote Work Flexibility\n\nTo: All Employees \nFrom: HR Department \nDate: November 18, 2024\n\nOverview: \nStarting December 1, 2024, employees may work remotely up to three days a week. This policy aims to enhance work-life balance while maintaining productivity.\n\nDetails:\n- Eligible Employees: All full-time staff.\n- Remote Work Days: Monday through Thursday (Friday reserved for in-office collaboration).\n- Process: Submit weekly schedules via the HR portal.\n\nFor more information, visit our HR page or contact hr@company.com.\n\nBest regards, \n[Your Name] \n[Your Title]`,
    description: "Content for Business Memo template",
  },
  compose_session_untitled_label: {
    message: "New Chat",
    description: "Label for untitled compose session",
  },
  compose_num_sources_one: {
    message: "{{count}} source",
    description: "Number of sources in a compose session",
  },
  compose_num_sources_few: {
    message: "{{count}} sources",
    description: "Number of sources in a compose session",
  },
  compose_num_sources_many: {
    message: "{{count}} sources",
    description: "Number of sources in a compose session",
  },
  compose_num_sources_other: {
    message: "{{count}} sources",
    description: "Number of sources in a compose session",
  },
  compose_num_sources_considered_one: {
    message: "Considered {{count}} source",
    description: "Number of sources in a compose session",
  },
  compose_num_sources_considered_few: {
    message: "Considered {{count}} sources",
    description: "Number of sources in a compose session",
  },
  compose_num_sources_considered_many: {
    message: "Considered {{count}} sources",
    description: "Number of sources in a compose session",
  },
  compose_num_sources_considered_other: {
    message: "Considered {{count}} sources",
    description: "Number of sources in a compose session",
  },
  compose_tones_pane_title: {
    message: "Add sources",
    description: "Title for the Tones pane in the compose editor settings",
  },
  compose_tones_pane_description: {
    message: "Add sources to generate a tone.",
    description:
      "Description for the Tones pane in the compose editor settings",
  },
  compose_settings_reference_label: {
    message: "Added sources",
    description: "Label for source section in settings",
  },
  compose_settings_preview_label: {
    message: "Edit & Preview",
    description: "Label Edit & Preview section in settings",
  },
  compose_settings_reference_description: {
    message: "Search or upload sources",
    description: "Description for source section in settings",
  },
  compose_tones_pane_references_subtitle: {
    message: "Dash will read the sources and generate a tone inspired by them.",
    description: "Subtitle for the references section in the modal stepper",
  },
  compose_tones_pane_preview_header: {
    message: "Edit & preview",
    description: "Header for the preview page in the modal stepper",
  },
  compose_tones_pane_preview_banner: {
    message: "View-only",
    description: "Banner for the preview section in the modal stepper",
  },
  compose_tones_pane_steps: {
    message: "Step {{current}}/{{total}}",
    description: "Label for the steps section in the modal stepper",
  },
  compose_tones_pane_skip: {
    message: "Skip",
    description: "Label to skip a step modal stepper",
  },
  compose_tones_pane_next: {
    message: "Next",
    description: "Label to go to the next step in the modal stepper",
  },
  compose_tones_modal_stepper_save_tone_title: {
    message: "Save tone",
    description: "Title for the save tone step in the modal stepper",
  },
  assist_template_modal_stepper_save_title: {
    message: "Save template",
    description: "Title for the save template step in the modal stepper",
  },
  compose_settings_from_sources_name_input_label: {
    message: "Name",
    description: "Label for field to name a tone in the Tones pane",
  },
  compose_settings_from_sources_sharing_label: {
    message: "Permissions",
    description: "Label for field to share a tone in the Tones pane",
  },
  compose_settings_from_sources_sublabel: {
    message: "Set who can edit and use this tone",
    description: "Sublabel for field to share a tone in the Tones pane",
  },
  conversation_prompt_placeholder: {
    message: "Chat with Dash",
    description: "Placeholder text for conversation prompt",
  },
  conversation_incognito_mode: {
    message: "Incognito",
    description: "Label for incognito mode button",
  },
  conversation_incognito_mode_enable: {
    message: "Enable incognito mode",
    description: "Aria label for enabling incognito mode",
  },
  conversation_incognito_mode_disable: {
    message: "Disable incognito mode",
    description: "Aria label for disabling incognito mode",
  },
  conversation_suggested_queries_title: {
    message: "Follow up",
    description: "Title for the suggested queries section",
  },
  conversation_step_label_searching: {
    message: "Searching",
    description: "Label for the searching step",
  },
  conversation_step_label_drafting: {
    message: "Drafting",
    description: "Label for the drafting step",
  },
  conversation_step_label_reading_files: {
    message: "Reading files",
    description: "Label for the reading files step",
  },
  conversation_step_label_processing_documents: {
    message: "Processing documents",
    description: "Label for the processing documents step",
  },
  conversation_step_label_generating_response_from_llm: {
    message: "Generating response",
    description: "Label for the generating response from LLM using agent step",
  },
  conversation_step_label_generating_response_from_agent: {
    message: "Generating agent response",
    description: "Label for the generating response from agent step",
  },
  conversation_step_label_generating_suggested_queries: {
    message: "Generating follow-up suggestions",
    description: "Label for the generating suggested queries step",
  },
  conversation_step_label_detecting_agent_from_query: {
    message: "Detecting agent from query",
    description: "Label for the detecting agent from query step",
  },
  conversation_not_found: {
    message: "Could not find the requested conversation",
    description: "Error message shown when a conversation ID is not found",
  },
  only_me_label: {
    message: "Only me",
    description: 'Label for the "Only me" sharing option',
  },
  publish_to_company_label: {
    message: "Publish to company",
    description: 'Label for the "Publish to company" sharing option',
  },
  compose_tones_modal_stepper_name_placeholder: {
    message: "What would you like to call this tone?",
    description: "Placeholder for field to name a tone in the Tones pane",
  },
  compose_settings_from_sources_description_input_label: {
    message: "Description (optional)",
    description: "Label for field to describe a tone in the Tones pane",
  },
  compose_tones_modal_stepper_description_placeholder: {
    message: "What is this tone for?",
    description: "Placeholder for field to describe a tone in the Tones pane",
  },
  compose_tones_pane_delete: {
    message: "Delete",
    description: "Action to delete a tone in the modal stepper",
  },
  compose_tones_pane_save: {
    message: "Done",
    description:
      "Action to save the currently editing tone in the modal stepper",
  },
  compose_tones_menu_title: {
    message: "Tone",
    description:
      "Dropdown menu title for selecting a tone in the compose editor",
  },
  compose_personal_tones_section: {
    message: "Your tones",
    description: "Label for personal tones section in voice selector",
  },
  compose_team_tones_section: {
    message: "Company tones",
    description: "Label for team tones section in voice selector",
  },
  compose_view_team_tones: {
    message: "View {{count}} tone{{plural}}",
    description:
      "Button text to view team tones, shows count of available tones",
  },
  compose_tone_generated_message: {
    message: "Tone created",
    description: "Tone created message in the edit and preview chat",
  },
  compose_tone_updated_message: {
    message: "Tone updated",
    description: "Tone updated message in the edit and preview chat",
  },
  compose_settings_loading_message: {
    message: "Drafting sample texts",
    description:
      "Initial message for the Tones pane in the compose editor settings",
  },
  compose_prompt_dash_placeholder_minimal: {
    message: "Chat to modify tone...",
    description: "Placeholder text for compose chat after content selected",
  },
  compose_prompt_dash_placeholder_minimal_template: {
    message: "Chat to modify template...",
    description:
      "Placeholder text for compose chat after content selected for templates",
  },
  compose_tones_pane_sources_count: {
    message: "{{count}} source{{plural}}",
    description: "Number of sources selected",
  },
  compose_delete_tones_confirm_title: {
    message: "Delete this tone?",
    description: "Title for the delete tone confirmation dialog",
  },
  compose_delete_tones_confirm_description: {
    message: "This tone configuration will be deleted.",
    description: "Description for the delete tone confirmation dialog",
  },
  compose_preset_neutral_tones_label_title: {
    message: "Neutral",
    description: "Title for the preset tone called Neutral",
  },
  compose_preset_neutral_tones_label_title_draft: {
    message: "Neutral Tone",
    description: "Title for the preset tone called Neutral",
  },
  compose_preset_neutral_tones_label_description: {
    message: "Straightforward with a strong focus on facts",
    description: "Description for the preset tone called neutral",
  },
  compose_preset_persuasive_tones_label_title: {
    message: "Persuasive",
    description: "Title for the preset tone called Persuasive",
  },
  compose_preset_persuasive_tones_label_title_draft: {
    message: "Persuasive Tone",
    description: "Title for the preset tone called Persuasive",
  },
  compose_preset_persuasive_tones_label_description: {
    message: "Structured with a strong focus on reasoning",
    description: "Description for the preset tone called Persuasive",
  },
  compose_preset_instructional_tones_label_title: {
    message: "Instructional",
    description: "Title for the preset tone called Instructional",
  },
  compose_preset_instructional_tones_label_title_draft: {
    message: "Instructional Tone",
    description: "Title for the preset tone called Instructional",
  },
  compose_preset_instructional_tones_label_description: {
    message: "Clear, concise, and step-by-step",
    description: "Description for the preset tone called Instructional",
  },
  compose_preset_narrative_tones_label_title: {
    message: "Narrative",
    description: "Title for the preset tone called Narrative",
  },
  compose_preset_narrative_tones_label_title_draft: {
    message: "Narrative Tone",
    description: "Title for the preset tone called Narrative",
  },
  compose_preset_narrative_tones_label_description: {
    message: "Structured storytelling",
    description: "Description for the preset tone called Narrative",
  },
  compose_preset_informal_tones_label_title: {
    message: "Informal",
    description: "Title for the preset tone called Informal",
  },
  compose_preset_informal_tones_label_title_draft: {
    message: "Informal Tone",
    description: "Title for the preset tone called Informal",
  },
  compose_preset_informal_tones_label_description: {
    message: "Casual and conversational",
    description: "Description for the preset tone called Informal",
  },
  compose_preset_analytical_tones_label_title: {
    message: "Analytical",
    description: "Title for the preset tone called Analytical",
  },
  compose_preset_analytical_tones_label_title_draft: {
    message: "Analytical Tone",
    description: "Title for the preset tone called Analytical",
  },
  compose_preset_analytical_tones_label_description: {
    message: "Fact-based and focused on data",
    description: "Description for the preset tone called Analytical",
  },
  compose_rewrite_message_tones_neutral: {
    message: "Rewrite to be more neutral",
    description: "User message for rewriting draft in the Neutral tone",
  },
  compose_rewrite_message_tones_persuasive: {
    message: "Rewrite to be more persuasive",
    description: "User message for rewriting draft in the Persuasive tone",
  },
  compose_rewrite_message_tones_instructional: {
    message: "Rewrite to be more instructional",
    description: "User message for rewriting draft in the Instructional tone",
  },
  compose_rewrite_message_tones_narrative: {
    message: "Rewrite to be more narrative",
    description: "User message for rewriting draft in the Narrative tone",
  },
  compose_rewrite_message_tones_informal: {
    message: "Rewrite to be more informal",
    description: "User message for rewriting draft in the Informal tone",
  },
  compose_rewrite_message_tones_analytical: {
    message: "Rewrite to be more analytical",
    description: "User message for rewriting draft in the Analytical tone",
  },
  compose_rewrite_message_tones_custom: {
    message: "Rewrite in the tone of “{{toneName}}”",
    description:
      "User message for rewriting draft in the custom tone named toneName",
  },
  created_by_dropbox: {
    message: "Created for you by Dropbox",
    description:
      "Text label shown in a stack header subtitle when the stack is a Unified Desktop welcome stack",
  },
  compose_voice_sample_sales_email: {
    message: `Subject: Streamline Your Operations with ABC’s Proven Solutions!\n\nHi [Client Name],\n\nI hope you’re well! As companies like yours face pressure to optimize operations, I wanted to introduce you to ABC’s automation platform, designed to cut costs and maximize productivity with minimal disruption. Our solutions are tailored for quick implementation, ensuring you see real results in weeks, not months. Just ask our clients, who’ve experienced up to a 35% reduction in processing times.\n\nWould you be open to a quick call next week to explore how ABC could enhance your team’s efficiency? Looking forward to connecting!\n\nBest,\n[Your Name]\nSales Manager, ABC`,
    description: "Sales email voice sample content",
  },
  compose_voice_sample_company_newsletter: {
    message: `Subject: Welcoming 2024 with New Goals and Team Milestones\n\nDear Team,\n\nAs we look ahead to 2024, I’m thrilled to share some recent accomplishments and new initiatives. Over the past quarter, ABC exceeded our goal of a 30% customer satisfaction increase, thanks to your hard work and commitment. In Q1, we’ll launch our updated client portal—an upgrade that promises smoother user experiences and stronger data insights.\n\nOur goal for this year is ambitious but achievable: to continue leading in process automation while deepening our customer relationships. Each of you is critical to our success, and together, I’m confident we’ll make 2024 our best year yet!\n\nBest,\n[CEO Name]\nCEO, ABC`,
    description: "Company newsletter voice sample content",
  },
  compose_voice_sample_analysis_report: {
    message: `Subject: Q3 Market Trends in Enterprise Automation\n\nOverview: ABC’s Q3 analysis highlights significant growth in demand for enterprise automation, driven by increased competition and the need for operational efficiency. Analysis of industry-wide data shows that 76% of companies are prioritizing automation investments, particularly in finance and customer service. With competitor innovations emerging in predictive analytics, ABC is well-positioned to gain market share by expanding our AI-driven solutions in these areas.\n\nKey Takeaways:\n- Market Growth: Automation market projected to grow by 8% in 2024, primarily in the logistics and healthcare sectors.\n- Strategic Opportunity: ABC can capture increased demand by investing in predictive analytics and enhanced customer support features.\n- Recommendations include accelerating R&D efforts and reinforcing partnerships in high-growth verticals to maintain our competitive advantage.`,
    description: "Analysis report voice sample content",
  },
  compose_voice_sample_sales_email_informative: {
    message: `Subject: Information About ABC’s Automation Platform Solutions\n\nHi [Client Name],\n\nI am writing to provide information about ABC’s automation platform and its operational capabilities. ABC develops automation solutions that are designed to reduce operational costs and increase productivity levels within existing business infrastructures. The platform is engineered for rapid deployment, with implementation timelines typically measured in weeks rather than months.\n\nBased on client performance data, organizations using ABC’s automation platform have reported processing time reductions of up to 35%. The system is designed to integrate with minimal disruption to current operational workflows.\n\nIf you would like to receive additional information about how ABC’s platform functions within your specific operational context, I can schedule a consultation call for next week. Please let me know if this would be useful.\n\nBest regards,\n[Your Name]\nSales Manager, ABC`,
    description: "Sales email voice sample content",
  },
  compose_voice_sample_company_newsletter_informative: {
    message: `Subject: 2024 Organizational Updates and Operational Milestones\n\nDear Team,\n\nThis communication provides an overview of recent organizational achievements and upcoming initiatives for 2024. During the previous quarter, ABC Company achieved a 30% increase in customer satisfaction metrics, surpassing the established target. The Q1 2024 timeline includes the implementation of an updated client portal system, which will deliver enhanced user interface functionality and improved data analytics capabilities.\n\nThe organization’s objectives for 2024 include maintaining leadership position in process automation services and expanding customer relationship management protocols. Each team member’s contributions are essential components of these operational goals. These initiatives represent the company’s strategic direction for the upcoming fiscal year.\n\nRegards,\n[CEO Name]\nCEO, ABC`,
    description: "Company newsletter voice sample content",
  },
  compose_voice_sample_analysis_report_informative: {
    message: `Subject: Q3 Market Trends Analysis: Enterprise Automation Sector Report\n\nExecutive Summary: This report presents ABC’s quarterly analysis of enterprise automation market trends for Q3. The data indicates measurable growth in enterprise automation adoption across multiple industry sectors. According to industry-wide survey data, 76% of surveyed companies have identified automation investments as a current priority, with the highest concentration of activity occurring in finance and customer service departments.\n\nMarket Analysis Findings:\n- Industry Growth Metrics: Current projections indicate the automation market will experience an 8% growth rate through 2024, with the logistics and healthcare sectors showing the strongest adoption rates.\n- Competitive Landscape Assessment: Recent developments in predictive analytics capabilities have been observed among industry competitors, creating new market dynamics.\n- Strategic Market Position: ABC’s existing AI-driven solution portfolio aligns with current market demand patterns in automation technology.\n\nRecommendations Based on Data Analysis:\nThe analysis suggests three primary areas for consideration: accelerating research and development initiatives, enhancing predictive analytics capabilities within customer support systems, and strengthening partnership agreements in high-growth industry verticals. These recommendations are based on observed market trends and competitive positioning data.`,
    description: "Analysis report voice sample content",
  },
  compose_voice_sample_sales_email_persuasive: {
    message: `Subject: Transform Your Operations Now - ABC’s Automation Platform Delivers Immediate ROI!\n\nHi [Client Name],\n\nI’m reaching out because companies in your industry are rapidly falling behind if they haven’t embraced automation. The evidence is clear: businesses that fail to optimize operations face declining competitiveness and shrinking margins. ABC’s automation platform isn’t just another solution—it’s your competitive advantage, proven to deliver results that directly impact your bottom line.\n\nConsider the compelling facts: Our clients consistently achieve up to 35% reduction in processing times, translating to immediate cost savings and enhanced productivity. This isn’t theoretical—it’s measurable ROI that starts within weeks of implementation. While your competitors struggle with outdated processes, you could be leading your market with streamlined, efficient operations.\n\nThe opportunity window is narrow. Every day without automation is revenue left on the table and efficiency gains handed to your competition. Don’t let this moment pass—schedule a call with me next week to discover exactly how ABC can transform your operations and secure your market position.\n\nThe choice is yours: lead with innovation or follow your competitors. Let’s discuss how to put you ahead.\n\nBest,\n[Your Name]\nSales Manager, ABC`,
    description: "Sales email voice sample content",
  },
  compose_voice_sample_company_newsletter_persuasive: {
    message: `Subject: 2024: The Year We Dominate Our Market - Your Role in Our Victory\n\nDear Team,\n\nAs we enter 2024, we stand at a pivotal moment that will define ABC’s future—and your career trajectory. The numbers don’t lie: we’ve already proven our potential by exceeding our 30% customer satisfaction goal. This isn’t just success; it’s proof that when we commit to excellence, we deliver extraordinary results.\n\nBut here’s the truth—our competition isn’t standing still. They’re watching our success and trying to replicate it. That’s exactly why our Q1 launch of the upgraded client portal is more than an improvement—it’s our statement that ABC sets the standard while others follow. This upgrade will deliver superior user experiences and deeper data insights that our competitors can only dream of achieving.\n\nOur 2024 goal is ambitious because mediocrity is not an option. We will continue leading in process automation while building unbreakable customer relationships. Your expertise, dedication, and innovation are the weapons that will secure our market dominance.\n\nThe question isn’t whether we can make 2024 our best year—it’s how decisively we’ll outperform every expectation. Join me in committing to excellence that our competitors cannot match. Together, we don’t just succeed—we redefine what success looks like.\n\nBest,\n[CEO Name]\nCEO, ABC`,
    description: "Company newsletter voice sample content",
  },
  compose_voice_sample_analysis_report_persuasive: {
    message: `Subject: Q3 Analysis Reveals Critical Window for ABC’s Market Domination\n\nOverview: ABC’s Q3 analysis exposes a game-changing opportunity in enterprise automation that demands immediate action. The data reveals unprecedented market conditions: 76% of companies are urgently prioritizing automation investments, creating a perfect storm for ABC to capture significant market share. While competitors scramble to develop predictive analytics capabilities, ABC’s established AI-driven solutions position us to dominate this expanding market.\n\nCompelling Evidence for Immediate Action:\n- Market Explosion: The automation market’s projected 8% growth in 2024, concentrated in logistics and healthcare, represents millions in untapped revenue—but only for companies that act decisively now.\n- Competitive Advantage Window: Our analysis confirms that competitor innovations in predictive analytics are still emerging, giving ABC a critical first-mover advantage that won’t last indefinitely.\n- Revenue Potential: ABC’s existing capabilities perfectly align with the 76% of companies actively seeking automation solutions, representing an unprecedented sales opportunity.\n\nStrategic Imperative - Act Now or Fall Behind:\nThe evidence is overwhelming: ABC must accelerate R&D efforts and strengthen partnerships in high-growth verticals immediately. Delay means watching competitors capture the market we’re positioned to own. This isn’t just an opportunity—it’s our moment to establish market leadership that will generate returns for years to come.\n\nThe window for action is closing. We must move decisively to capture this market before competitors recognize what we already know: enterprise automation is the path to sustained competitive advantage.`,
    description: "Analysis report voice sample content",
  },
  compose_voice_sample_sales_email_instructional: {
    message: `Subject: How to Implement ABC’s Automation Solutions for Maximum Operational Efficiency\n\nHi [Client Name],\n\nI hope you’re well! To help you optimize your operations effectively, here’s a step-by-step approach for implementing ABC’s automation platform:\n\n**Step 1: Assess Your Current Operations**\nIdentify areas where your company faces pressure to optimize processes and reduce costs.\n\n**Step 2: Evaluate Implementation Requirements**\nReview ABC’s automation platform features designed for quick implementation with minimal disruption to existing workflows.\n\n**Step 3: Plan Your Timeline**\nSchedule implementation to see measurable results within weeks rather than months, following our proven deployment process.\n\n**Step 4: Review Success Metrics**\nExamine case studies showing up to 35% reduction in processing times achieved by similar companies.\n\n**Step 5: Schedule Your Consultation**\nBook a call next week to discuss specific ways ABC can enhance your team’s efficiency and create a customized implementation plan.\n\n**Tip:** Prepare a list of your current operational challenges before our call to maximize the value of our discussion.\n\nBest,\n[Your Name]\nSales Manager, ABC`,
    description: "Sales email voice sample content",
  },
  compose_voice_sample_company_newsletter_instructional: {
    message: `Subject: How to Achieve Team Goals and Milestones: A 2024 Implementation Guide\n\nDear Team,\n\n**Step 1: Acknowledge Recent Achievements**\nRecognize that ABC has successfully exceeded our 30% customer satisfaction increase goal through dedicated team effort and commitment.\n\n**Step 2: Prepare for Q1 Initiatives**\nBegin preparing for the updated client portal launch, which will deliver:\n- Smoother user experiences\n- Stronger data insights\n\n**Step 3: Understand Your Role in 2024 Goals**\nFollow these priorities to continue leading in process automation:\n- Focus on deepening customer relationships\n- Maintain commitment to process excellence\n- Contribute your unique skills to team success\n\n**Step 4: Execute Daily Excellence**\nRemember that each team member plays a critical role in achieving our ambitious but achievable annual objectives.\n\n**Step 5: Stay Committed to Collective Success**\nWork together consistently to make 2024 our best year yet.\n\n**Prerequisites:** Maintain the same level of dedication and hard work that delivered our recent successes.\n\nBest,\n[CEO Name]\nCEO, ABC`,
    description: "Company newsletter voice sample content",
  },
  compose_voice_sample_analysis_report_instructional: {
    message: `Subject: How to Conduct Q3 Market Trend Analysis for Enterprise Automation\n\n**Step 1: Gather Industry-Wide Data**\nCollect comprehensive data showing that 76% of companies are prioritizing automation investments, particularly in finance and customer service sectors.\n\n**Step 2: Analyze Market Growth Projections**\nDocument that the automation market is projected to grow by 8% in 2024, with primary growth in logistics and healthcare sectors.\n\n**Step 3: Assess Competitive Landscape**\nIdentify competitor innovations emerging in predictive analytics to understand market positioning opportunities.\n\n**Step 4: Evaluate Strategic Positioning**\nDetermine how ABC is well-positioned to gain market share by expanding AI-driven solutions in identified growth areas.\n\n**Step 5: Develop Strategic Recommendations**\nCreate actionable recommendations including:\n- Accelerating R&D efforts\n- Reinforcing partnerships in high-growth verticals\n- Investing in predictive analytics\n- Enhancing customer support features\n\n**Step 6: Implement Competitive Advantage Strategies**\nExecute recommendations to maintain competitive advantage in the expanding automation market.\n\n**Prerequisites:** Access to industry-wide automation investment data and competitive intelligence resources.\n\n**Common Mistake to Avoid:** Don’t overlook emerging predictive analytics trends when assessing market opportunities.`,
    description: "Analysis report voice sample content",
  },
  compose_voice_sample_sales_email_narrative: {
    message: `Subject: The Story of Transformation: How ABC Turned Operational Chaos into Success\n\nHi [Client Name],\n\nI hope you’re well! Let me tell you about a journey I’ve witnessed countless times—the transformation from operational struggle to streamlined success.\n\nPicture this: A company much like yours, drowning in inefficient processes, watching competitors pull ahead while their team worked harder but not smarter. The pressure was mounting, deadlines slipping, and costs spiraling upward. Sound familiar?\n\nThen came the turning point. When they discovered ABC’s automation platform, everything changed. What had seemed like an impossible mountain to climb became a series of manageable steps. Within weeks—not the months they had feared—they watched their operations transform before their eyes. The most remarkable part? A 35% reduction in processing times that freed their team to focus on what truly mattered.\n\nToday, that company stands as a testament to what’s possible when the right solution meets determined leadership. Their story could be your story.\n\nWould you be open to a conversation next week about writing your own transformation narrative? I’d love to explore how ABC could be the catalyst for your team’s success story.\n\nBest,\n[Your Name]\nSales Manager, ABC`,
    description: "Sales email voice sample content",
  },
  compose_voice_sample_company_newsletter_narrative: {
    message: `Subject: Our 2024 Story Begins: From Triumph to Even Greater Heights\n\nDear Team,\n\nAs I sit here reflecting on our journey, I’m filled with pride at the story we’ve written together.\n\nJust months ago, we set what seemed like an audacious goal—a 30% increase in customer satisfaction. I remember the uncertainty in the room, the quiet question of whether we could truly deliver on such a promise. But you believed, and you acted with the kind of determination that defines champions.\n\nThe result? We didn’t just meet that goal—we exceeded it. Each satisfied customer became a chapter in our success story, each positive feedback a testament to your unwavering commitment. When I think about those late nights, those extra efforts, those moments when you chose excellence over easier paths, I see the heart of what makes ABC extraordinary.\n\nNow, as we stand at the threshold of 2024, we’re writing the opening chapter of an even more ambitious story. Our new client portal—launching in Q1—represents more than just an upgrade. It’s our promise to deliver experiences so smooth and insights so powerful that our customers will wonder how they ever managed without us.\n\nThe story we’re writing together isn’t just about leading in process automation or deepening customer relationships. It’s about proving that when extraordinary people unite around a shared vision, there are no limits to what we can achieve.\n\nHere’s to making 2024 the most remarkable chapter in the ABC story yet.\n\nBest,\n[CEO Name]\nCEO, ABC`,
    description: "Company newsletter voice sample content",
  },
  compose_voice_sample_analysis_report_narrative: {
    message: `Subject: The Q3 Revolution: A Story of Market Transformation and ABC’s Golden Opportunity\n\nAs the dust settles on Q3, a remarkable story emerges from the data—one that reveals a fundamental shift in how businesses operate and where the future lies.\n\nImagine walking through the corridors of corporate America today. In boardroom after boardroom, the same conversation is happening. Executives lean forward, charts spread across mahogany tables, as they grapple with a reality they can no longer ignore: automation isn’t the future—it’s the present. Our analysis reveals that 76% of companies have reached this same conclusion, prioritizing automation investments with an urgency that speaks to the competitive pressures reshaping entire industries.\n\nThe story becomes even more compelling when we look deeper. Finance departments and customer service teams—the traditional heartbeat of operations—are leading this charge. They’ve witnessed firsthand how manual processes have become anchors in a world that demands speed and precision.\n\nMeanwhile, in the background of this unfolding drama, a parallel narrative emerges. Competitors scramble to develop predictive analytics capabilities, racing to catch up with market demands they’re only now beginning to understand. But here’s where ABC’s story takes a remarkable turn.\n\nWhile others chase tomorrow’s solutions, we already possess today’s answers. Our AI-driven platform stands ready to capture the wave of demand now cresting across logistics and healthcare—sectors projected to drive 8% market growth throughout 2024.\n\nThe lesson embedded in this Q3 story is clear: opportunity belongs to those who recognize transformation while others see only change. ABC’s next chapter lies in accelerating R&D efforts and strengthening partnerships in high-growth verticals—not just to maintain our competitive advantage, but to write the definitive story of market leadership in enterprise automation.`,
    description: "Analysis report voice sample content",
  },
  compose_voice_sample_sales_email_informal: {
    message: `Subject: Hey! Let’s Chat About Making Your Operations Way Smoother\n\nHey [Client Name],\n\nHope you’re doing great! So I know you’re probably dealing with all the usual stuff - trying to make things run better, cut costs, you know how it is. Anyway, I wanted to tell you about ABC’s automation thing we’ve got going on. It’s pretty cool actually - helps companies like yours save money and get more done without turning everything upside down.\n\nHere’s the thing - we’ve made it super easy to get started, so you’ll actually see results in just a few weeks instead of waiting around forever. And get this - our other clients are seeing their processing times drop by like 35%! Pretty awesome, right?\n\nSo what do you think? Want to hop on a quick call next week and chat about how we could help your team get things done faster? I’d love to hear what you’re working with!\n\nTalk soon,\n[Your Name]\nSales Manager, ABC`,
    description: "Sales email voice sample content",
  },
  compose_voice_sample_company_newsletter_informal: {
    message: `Subject: 2024’s Looking Pretty Great - Check Out What We’ve Been Up To!\n\nHey Everyone,\n\nSo here we are in 2024, and honestly, I’m pretty excited to fill you in on what’s been happening! First off - you guys totally crushed it this past quarter. Remember that 30% customer satisfaction goal we had? Yeah, we didn’t just hit it, we smashed right through it. Seriously, you all rock!\n\nOh, and here’s something cool coming up - we’re rolling out this updated client portal in Q1. It’s going to make things so much easier for everyone and give us way better insights into what’s going on. I think you’re really going to like it.\n\nSo here’s the deal for this year - we want to keep being the best at what we do while getting even closer to our customers. I know it sounds like a lot, but honestly? With this team, I’m not worried at all. We’ve got this!\n\nCan’t wait to see what we accomplish together!\n\n[CEO Name]\nCEO, ABC`,
    description: "Company newsletter voice sample content",
  },
  compose_voice_sample_analysis_report_informal: {
    message: `Subject: Q3 Update - The Automation World’s Going Crazy (In a Good Way!)\n\nHey Team,\n\nSo I’ve been digging into what’s happening in the automation world this quarter, and wow - things are really picking up! Basically, everyone and their brother is jumping on the automation train. We’re talking about 76% of companies saying “yeah, we need this stuff” - especially in finance and customer service.\n\nHere’s what’s really interesting - competitors are starting to get into predictive analytics, which is cool for them, but here’s the thing: we’re already ahead of the game with our AI stuff. Perfect timing, right?\n\nSo here’s the scoop:\n- The whole automation market’s going to grow by about 8% next year, and logistics and healthcare are where it’s really happening.\n- We’ve got a sweet spot here - we can totally grab more customers by beefing up our predictive analytics and making our customer support even better.\n- Bottom line: we should probably speed up our R&D work and get tighter with our partners in these hot markets. That way we stay ahead of everyone else.\n\nPretty exciting stuff happening out there!`,
    description: "Analysis report voice sample content",
  },
  compose_voice_sample_sales_email_analytical: {
    message: `Subject: Operational Efficiency Analysis: ABC Automation Platform Performance Metrics\n\nDear [Client Name],\n\nIntroduction:\nThis communication presents an analytical assessment of operational optimization challenges facing organizations in your sector and the measurable performance outcomes achieved through ABC’s automation platform implementation.\n\nCurrent Market Analysis:\nIndustry data indicates that companies are experiencing increased pressure to optimize operational processes. Our analysis of implementation methodologies demonstrates that ABC’s automation platform addresses these challenges through systematic cost reduction and productivity enhancement protocols.\n\nPerformance Data:\nEmpirical evidence from client implementations shows:\n- Processing time reduction: Up to 35% decrease in operational processing times\n- Implementation timeline: Results achieved within weeks rather than months\n- Disruption metrics: Minimal operational interruption during deployment phase\n\nConclusion and Next Steps:\nBased on this analytical framework, a consultation meeting would provide an opportunity to conduct a detailed efficiency assessment specific to your operational parameters. This data-driven evaluation would quantify potential improvements for your organization.\n\nRegards,\n[Your Name]\nSales Manager, ABC`,
    description: "Sales email voice sample content",
  },
  compose_voice_sample_company_newsletter_analytical: {
    message: `Subject: 2024 Strategic Initiative Analysis: Performance Metrics and Organizational Goals\n\nDear Team,\n\nExecutive Summary:\nThis report analyzes ABC’s recent performance indicators and outlines the strategic framework for 2024 organizational objectives.\n\nQ4 Performance Analysis:\nQuantitative assessment of recent achievements reveals:\n- Customer satisfaction metrics: 30% increase achieved, exceeding established targets\n- Performance attribution: Direct correlation with team effort and commitment levels\n- Goal attainment ratio: 100% target achievement rate\n\nQ1 2024 Strategic Implementation:\nUpcoming initiatives include:\n- Client portal upgrade: Enhanced user experience functionality\n- Data analytics enhancement: Improved insight generation capabilities\n- Implementation timeline: Q1 deployment schedule\n\n2024 Organizational Objectives:\nStrategic analysis indicates two primary focus areas:\n1. Process automation leadership maintenance\n2. Customer relationship depth expansion\n\nConclusion:\nPersonnel contribution analysis demonstrates that individual team member performance directly correlates with organizational success metrics. Projected outcomes for 2024 indicate optimal achievement potential based on current performance trajectories.\n\nRegards,\n[CEO Name]\nCEO, ABC`,
    description: "Company newsletter voice sample content",
  },
  compose_voice_sample_analysis_report_analytical: {
    message: `Subject: Q3 Enterprise Automation Market Analysis: Comprehensive Industry Assessment\n\nExecutive Summary:\nThis analytical report examines Q3 market dynamics in the enterprise automation sector, providing data-driven insights into growth patterns, competitive positioning, and strategic opportunities for ABC.\n\nMethodology and Data Sources:\nAnalysis incorporates industry-wide data collection and competitive intelligence assessment to evaluate market conditions and strategic positioning.\n\nKey Findings:\n\nMarket Demand Analysis:\n- Industry adoption rate: 76% of surveyed companies prioritizing automation investments\n- Sector concentration: Finance and customer service departments showing highest implementation rates\n- Growth drivers: Increased competition and operational efficiency requirements\n\nMarket Projection Data:\n- Projected growth rate: 8% market expansion anticipated for 2024\n- Sector breakdown: Logistics and healthcare sectors demonstrating primary growth potential\n- Revenue opportunity: Significant market expansion in target verticals\n\nCompetitive Landscape Assessment:\n- Innovation trends: Emerging competitor developments in predictive analytics capabilities\n- Market positioning: ABC’s AI-driven solutions align with current demand patterns\n- Strategic advantage: Established capabilities in high-demand solution areas\n\nStrategic Recommendations:\nBased on analytical findings:\n1. Accelerate R&D investment allocation\n2. Enhance predictive analytics and customer support feature development\n3. Strengthen partnership frameworks in high-growth vertical markets\n\nConclusion:\nData analysis indicates favorable market conditions for ABC’s expansion strategy, with quantifiable opportunities in predictive analytics and customer support automation segments.`,
    description: "Analysis report voice sample content",
  },
  enable_privacy_mode: {
    message: "Enable privacy mode",
    description: "Tooltip for the privacy mode toggle",
  },
  disable_privacy_mode: {
    message: "Disable privacy mode",
    description: "Tooltip for the privacy mode toggle",
  },
  local_file_filter_display_name: {
    message: "Local files",
    description: "label for local file filter on SERP and typeahead",
  },
  compose_step_index: {
    message: "Step {{stepIndex}}:",
    description: "Shows the current step index in a multi-step Compose form",
  },
  compose_content_type_question: {
    message: "What would you like to write?",
    description:
      "Prompt asking the type of content user wants to draft in Compose assistant",
  },
  compose_sources_question: {
    message:
      "Great! Describe what you would like to write or add a source below to get started.",
    description:
      "Prompt asking the user to add content sources in Compose assistant",
  },
  compose_add_source_action: {
    message: "Add source",
    description: "Action to add a source content in Compose assistant",
  },
  compose_added_sources_label: {
    message: "Sources",
    description: "Label for added sources in Compose assistant",
  },
  compose_search_results_title: {
    message: "Results",
    description: "Title for search results in Compose assistant",
  },
  compose_recommendations_title: {
    message: "Recommended",
    description: "Title for recommendations in Compose assistant",
  },
  compose_add_sources_count_one: {
    message: "{{count}} source",
    description: "Number of sources added in chat",
  },
  compose_add_sources_count_few: {
    message: "{{count}} sources",
    description: "Number of sources added in chat",
  },
  compose_add_sources_count_many: {
    message: "{{count}} sources",
    description: "Number of sources added in chat",
  },
  compose_add_sources_count_other: {
    message: "{{count}} sources",
    description: "Number of sources added in chat",
  },
  done: {
    message: "Done",
    description: "Button text to finish a task",
  },
  compose_assistant_message_generic: {
    message: "What can I do for you?",
    description: "Generic message from the Compose assistant",
  },
  compose_assistant_message_partial_match: {
    message: "What would you like to write about?",
    description:
      "Used to determine if text area should autofocus when sources are added",
  },
  assist_multidocs_router_message: {
    message: "What would you like to know about these documents?",
    description:
      "Message from assistant asking what user wants to know about a set of documents",
  },
  compose_assistant_message_transient_sources: {
    message:
      "I can help you with information from the {{title}}. How can I help?",
    description:
      "Message from assistant asking if user wishes to ask about a source it just read",
  },
  compose_assistant_message_transient_source_generic_title: {
    message: "Current Page",
    description: "Title for generic transient source",
  },
  compose_assistant_draft_generated: {
    message: "Draft generated",
    description: "Compose chat message reply when draft is generated",
  },
  compose_assistant_message_with_content_type: {
    message: "What would you like to write about in this {{contentType}}?",
    description:
      "Message from the Compose assistant asking what user wants to write",
  },
  compose_open_draft: {
    message: "Open draft",
    description: "Button text to open a draft in the Compose assistant",
  },
  assistant_card_title_chat_with_dash: {
    message: "Ask a question",
    description: "Title for the Chat assistant card",
  },
  assistant_card_description_chat_with_dash: {
    message: "Ask questions and get insights from your content instantly.",
    description: "Description for the Chat with Dash assistant card",
  },
  assistant_card_title_request_capabilities: {
    message: "Request capabilities",
    description: "Title for the Request Capabilities assistant card",
  },
  assistant_card_description_request_capabilities: {
    message: "Suggest new tools or features to improve your experience.",
    description: "Description for the Request Capabilities assistant card",
  },
  assistant_card_title_write: {
    message: "Write something",
    description: "Title for the Write assistant card",
  },
  assistant_card_description_write: {
    message: "Draft content with professional templates and tailored insights.",
    description: "Description for the Write assistant card",
  },
  assist_request_capabilities_feedback_title: {
    message: "[Assistant] Request new capability",
    description: "Default title for the Request Capabilities feedback form",
  },
  assistant_card_title_create_ai_tool: {
    message: "Create AI tool",
    description: "Title for the Create AI tool assistant card",
  },
  assistant_card_description_create_ai_tool: {
    message: "Create a custom AI tool and publish it to your team.",
    description: "Description for the Create AI tool assistant card",
  },
  assistant_initial_generic_prompt_message: {
    message: "What would you like to know?",
    description: "Initial prompt message for the assistant chat",
  },
  assistant_progress_message_searching_dash: {
    message: "Searching Dash",
    description: "Message displayed when the assistant is searching Dash",
  },
  assistant_progress_message_analyzing_content: {
    message:
      "Considering {{totalCount}} results ({{doneCount}}/{{totalCount}})",
    description: "Message displayed when the assistant is analyzing content",
  },
  assistant_message_searched_dash: {
    message: "Searched Dash",
    description: "Message displayed when the assistant is done searching Dash",
  },
  assistant_message_reading: {
    message: "Reading",
    description: "Message displayed when the assistant is reading a source",
  },
  assistant_chat_view_toggle: {
    message: "Switch to Chat View",
    description: "Aria label for switching to chat in mobile layout",
  },
  assistant_editor_view_toggle: {
    message: "Switch to Editor View",
    description: "Aria label for switching to editor in mobile layout",
  },
  assistant_message_analyzing_content: {
    message: "Considering {{totalCount}} results",
    description: "Message displayed when the assistant is analyzing content",
  },
  assistant_message_analyzed_content: {
    message: "Considered {{totalCount}} results",
    description:
      "Message displayed when the assistant is done analyzing content",
  },
  assistant_message_searching: {
    message: "Searching",
    description: "Message displayed when the assistant is done searching Dash",
  },
  assistant_message_searched: {
    message: "Searched",
    description: "Message displayed when the assistant is done searching",
  },
  assistant_progress_message_summarizing_findings: {
    message: "Summarizing findings",
    description: "Message displayed when the assistant is summarizing findings",
  },
  coming_soon_label: {
    message: "Coming soon",
    description: "Badge label for features that are coming soon",
  },
  greeting_with_name_morning: {
    message: "Good morning, {{name}}",
    description: "Initial morning message for start page",
  },
  greeting_with_name_afternoon: {
    message: "Good afternoon, {{name}}",
    description: "Initial afternoon message for start page",
  },
  greeting_with_name_evening: {
    message: "Good evening, {{name}}",
    description: "Initial evening message for start page",
  },
  assistant_empty_chat_subtitle: {
    message: "What would you like to do?",
    description: "Initial submessage on assistant start page",
  },
  assistant_empty_chat_promotion_suggestion: {
    message: "What can I do with Dash?",
    description:
      "Prompt suggestion for users to explore what they can do with Dash",
  },
  promotion_write_marketing_blog_post: {
    message: "Write a marketing blog post",
    description: "Template chip text for marketing blog post writing",
  },
  promotion_write_sales_outreach_email: {
    message: "Write a sales outreach email",
    description: "Template chip text for sales outreach email writing",
  },
  promotion_write_status_report: {
    message: "Write a status report",
    description: "Template chip text for status report writing",
  },
  assistant_ai_tool_title: {
    message: "AI Tools",
    description: "Title for the AI Tools section on the assistant start page",
  },
  assistant_ai_tool_tool_type_header: {
    message: "Tool type",
    description:
      "Header for the Tool type section in the AI tool creation flow",
  },
  assistant_ai_tool_behavior_header: {
    message: "Behavior",
    description: "Name of the behavior configuration step in the workflow",
  },
  assistant_ai_tool_workflow_header: {
    message: "Workflow",
    description: "Name of the workflow configuration step",
  },
  assistant_ai_tool_knowledge_header: {
    message: "Knowledge",
    description: "Name of the knowledge configuration step",
  },
  assistant_ai_tool_publish_header: {
    message: "Preview & publish",
    description: "Name of the preview and publish configuration step",
  },
  assistant_ai_tool_next_button: {
    message: "Next",
    description:
      "Button text to go to the next step in the AI tool creation flow",
  },
  assistant_ai_tool_back_button: {
    message: "Back",
    description:
      "Button text to go back to the previous step in the AI tool creation flow",
  },
  assistant_ai_tool_cancel_button: {
    message: "Cancel",
    description: "Button text to cancel the AI tool creation flow",
  },
  assistant_ai_tool_publish_button: {
    message: "Publish",
    description: "Button text to publish the AI tool",
  },
  assistant_ai_tool_preview_button: {
    message: "Preview",
    description: "Button text to preview the AI tool",
  },
  assistant_ai_tool_type_label: {
    message: "Type",
    description: "Label for the Tool type input in the AI tool creation flow",
  },
  assistant_ai_tool_type_label_description: {
    message: "Select the type of tool you want to use",
    description:
      "Description for the Tool type input in the AI tool creation flow",
  },
  assistant_ai_tool_type_chat_label: {
    message: "Chat",
    description: "Label for the Chat tool type in the AI tool creation flow",
  },
  assistant_ai_tool_type_chat_label_description: {
    message: "You set the prompt to guide Dash‘s behavior",
    description:
      "Description for the Chat tool type in the AI tool creation flow",
  },
  assistant_ai_tool_type_write_label: {
    message: "Write",
    description: "Label for the Write tool type in the AI tool creation flow",
  },
  assistant_ai_tool_type_write_label_description: {
    message: "Dash generates a document based on the conversation",
    description:
      "Description for the Write tool type in the AI tool creation flow",
  },
  assistant_ai_tool_type_analysis_label: {
    message: "Data Analysis",
    description:
      "Label for the Data Analysis tool type in the AI tool creation flow",
  },
  assistant_ai_tool_type_analysis_label_description: {
    message: "Dash analyzes a set of data with views, charts, and more",
    description:
      "Description for the Data Analysis tool type in the AI tool creation flow",
  },
  assistant_ai_tool_base_model: {
    message: "Base model",
    description: "Label for the base model selection input",
  },
  assistant_ai_tool_system_prompt: {
    message: "Prompt",
    description: "Label for the prompt input field",
  },
  assistant_ai_tool_system_prompt_description: {
    message: "Enter a custom prompt for the tool",
    description: "Description for the prompt input field",
  },
  assistant_ai_tool_system_prompt_placeholder: {
    message: "Try something descriptive",
    description: "Placeholder text for the prompt input field",
  },
  assistant_ai_tool_dash_search: {
    message: "Dash search",
    description: "Label for the Dash search toggle",
  },
  assistant_ai_tool_dash_search_description: {
    message: "Enable Dash to search across its knowledge base",
    description: "Description for the Dash search toggle",
  },
  assistant_ai_tool_suggestions: {
    message: "Follow up suggestions",
    description: "Label for the follow up suggestions toggle",
  },
  assistant_ai_tool_suggestions_description: {
    message: "Enable follow up suggestions from the user",
    description: "Description for the follow up suggestions toggle",
  },
  assistant_ai_tool_step_name: {
    message: "Step {{stepIndex}}",
    description: "Label for the workflow step",
  },
  assistant_ai_tool_chat_step_1_description: {
    message: "The user responds via the chat.",
    description: "Description for the first workflow step",
  },
  assistant_ai_tool_user_prompt: {
    message: "Prompt",
    description: "Label for the user prompt input",
  },
  assistant_ai_tool_user_prompt_placeholder: {
    message: "What would you like to know?",
    description: "Placeholder for the user prompt input",
  },
  assistant_ai_tool_prompt_type: {
    message: "Prompt type",
    description: "Label for the prompt type selection",
  },
  assistant_ai_tool_prompt_type_open: {
    message: "Open ended",
    description: "Label for the open ended prompt type",
  },
  assistant_ai_tool_prompt_type_template: {
    message: "Template selection",
    description: "Label for the template selection prompt type",
  },
  assistant_ai_tool_prompt_type_tone: {
    message: "Tone selection",
    description: "Label for the tone selection prompt type",
  },
  assistant_ai_tool_prompt_type_search: {
    message: "Dash search/upload",
    description: "Label for the Dash search/upload prompt type",
  },
  assistant_ai_tool_sources: {
    message: "Add sources",
    description: "Label for the sources selection input",
  },
  assistant_ai_tool_added_sources_subtitle: {
    message:
      "Your tool will draw on these sources during interactions with users.",
    description:
      "Subtitle for the sources selection input in the AI tool creation flow",
  },
  assistant_ai_tool_custom_sources: {
    message: "Custom sources",
    description: "Label for the custom sources selection input",
  },
  assistant_ai_tool_custom_sources_description: {
    message: "Allow users to add their own sources.",
    description: "Description for the custom sources selection input",
  },
  assistant_ai_tool_name: {
    message: "Name",
    description: "Label for the tool name input",
  },
  assistant_ai_tool_name_description: {
    message: "The name of the tool",
    description: "Description for the tool name input",
  },
  assistant_ai_tool_name_placeholder: {
    message: "Try something descriptive",
    description: "Placeholder for the tool name input",
  },
  assistant_ai_tool_icon: {
    message: "Icon",
    description: "Label for the icon selection input",
  },
  assistant_ai_tool_theme: {
    message: "Theme",
    description: "Label for the theme selection input",
  },
  assistant_ai_tool_editing_agent: {
    message: "Editing {{agentName}}",
    description: "Label for the editing agent input",
  },
  assistant_ai_tool_description: {
    message: "Description",
    description: "Label for the tool description input",
  },
  assistant_ai_tool_description_description: {
    message: "A description of the tool",
    description: "Description for the tool description input",
  },
  assistant_ai_tool_description_placeholder: {
    message: "Try something descriptive",
    description: "Placeholder for the tool description input",
  },
  assistant_ai_tool_publish_label: {
    message: "Publish",
    description: "Label for the publish settings",
  },
  assistant_ai_tool_publish_description: {
    message: "Set who can access this tool",
    description: "Description for the publish settings",
  },
  assistant_ai_tool_publish_private: {
    message: "Only me",
    description: "Label for private publish option",
  },
  assistant_ai_tool_publish_company: {
    message: "Entire company",
    description: "Label for company-wide publish option",
  },
  assistant_ai_tool_publish_company_description: {
    message: "Everyone at your company will be able to use this tool",
    description: "Description for company-wide publish option",
  },

  published_content_title: {
    message: "Published content",
    description: "Button text for published content maintained by Admins",
  },
  publish_button_text: {
    message: "Publish",
    description: "Button text to publish content by Admins",
  },
  published_content_subtitle: {
    message:
      "Content published will be pinned to their start page under “Stacks“. You are limited to 20 items.",
    description: "Button text to publish content by Admins",
  },
  publish_content_modal_subtitle: {
    message:
      "Search to choose a stack to publish to your entire team on Dash. You can only publish stacks that you created.",
    description: "Text on publish content modal for Admins",
  },
  published_content_tab_title_stacks: {
    message: "Stacks",
    description: "Tab title for stacks on published content page",
  },
  published_content_tab_title_verifications: {
    message: "Verified content",
    description: "Tab title for verifications on published content page",
  },
  add_a_stack: {
    message: "Add a stack",
    description: "Text on publish content modal to add a stack to publish",
  },
  publish_error_message_no_stack_selected: {
    message: "A stack must be selected to continue.",
    description:
      "Error message when publish button is clicked without selecting a stack.",
  },
  company_stack_team_permission_description: {
    message: "Anyone at {{team}} can view",
    description: "Description for company stack team permission.",
  },
  content: {
    message: "Content",
    description: "Published Content table column header",
  },
  publisher: {
    message: "Publisher",
    description: "Published Content table column header",
  },
  unpublish: {
    message: "Unpublish",
    description: "Button text on published content admin page",
  },
  permissions: {
    message: "Permissions",
    description: "Title on permissions dropdown",
  },
  unpublish_stack_confirm_title: {
    message: "Unpublish this stack?",
    description: "Title on confirmation modal when unpublishing stack",
  },
  unpublish_stack_confirm_subtitle: {
    message:
      "Remove the stack from the “Stacks“ tab on your employees’ start page. The stack will still exist.",
    description: "Subtitle on confirmation modal when unpublishing stack",
  },
  unpublish_stack_failure: {
    message: "Failed to unpublish {{stackName}}",
    description: "Snackbar message if stack unpublish failed",
  },
  unpublish_stack_inprogress: {
    message: "Unpublishing {{stackName}} ...",
    description: "Snackbar message when unpublishing is in progress",
  },
  unpublish_stack_success: {
    message: "{{stackName}} unpublished successfully",
    description: "Snackbar message once a stack is unpublished successfully",
  },
  publish_stack_failure: {
    message: "Failed to publish {{stackName}}",
    description: "Snackbar message if stack publish failed",
  },
  publish_stack_inprogress: {
    message: "Publishing {{stackName}} ...",
    description: "Snackbar message when publishing is in progress",
  },
  publish_stack_success: {
    message: "{{stackName}} published successfully",
    description: "Snackbar message once a stack is published successfully",
  },
  published_content_empty_state_text: {
    message:
      "No published content yet. Click on +Publish to get started on your first one.",
    description: "Text on the published content empty state",
  },
  publish_button_disable_text: {
    message: "You have reached max limit of {{count}} items.",
    description: "Tooltip text on disabled publish button.",
  },
  date: {
    message: "Date",
    description: "Describes date field",
  },
  see_all: {
    message: "See all",
    description: "Label text to used to prefix see all stacks",
  },
  count_stacks: {
    message: "{{count}} stacks",
    description: "Label for number of stacks to see",
  },
  company_stack_filter: {
    message: "From my company",
    description:
      "Filter chip on the stacks page to show only stacks published from my company",
  },
  desktop_onboarding_continue_btn: {
    message: "Continue",
    description: "Button text to continue the onboarding flow.",
  },
  desktop_onboarding_finish_btn: {
    message: "Finish",
    description: "Button text to Finish the onboarding flow.",
  },
  desktop_onboarding_skip_btn: {
    message: "Skip",
    description: "Button text to skip the next step in the onboarding flow.",
  },
  desktop_onboarding_step_count: {
    message: "Step {{stepNum}} of {{stepTotal}}",
    description: "step count in the onboarding flow.",
  },
  desktop_onboarding_local_files_container_label: {
    message: "Select folders",
    description: "Add local files container label",
  },
  desktop_onboarding_add_folder_btn_text: {
    message: "Add folder",
    description: "Add custom folder button text",
  },
  desktop_onboarding_add_folder_btn_subtext: {
    message: "Choose other folders to make their contents searchable in Dash",
    description: "Add custom folder button subtext",
  },
  desktop_onboarding_admin_app_title: {
    message: "Apps ready for search",
    description: "Admin apps title in desktop onboarding",
  },
  desktop_onboarding_admin_apps_subtitle: {
    message:
      "Your company has added these apps, so you can start searching in Dash right away. Manage apps anytime in Settings.",
    description: "Admin apps subtitle in desktop onboarding",
  },
  desktop_onboarding_admin_connector_label: {
    message: "Added by your company",
    description:
      "Admin apps label for each company connector in desktop onboarding",
  },
  desktop_onboarding_local_files_title: {
    message: "Allow Dash to search your local files",
    description: "Local Files title in desktop onboarding",
  },
  desktop_onboarding_local_files_subtitle: {
    message:
      "Choose the folders on your computer that you want Dash to include in your search.",
    description: "Local files subtitle in desktop onboarding",
  },
  desktop_onboarding_shortcut_title: {
    message: "Press {{formattedShortcut}} to open Dash",
    description: "Initial shortcut title desktop onboarding",
  },
  desktop_onboarding_shortcut_subtitle: {
    message:
      "Use this shortcut to open and close Dash. You can change it anytime in Settings.",
    description: "Initial shortcut subtitle desktop onboarding",
  },
  desktop_onboarding_shortcut_notes: {
    message:
      "You can also press {{formattedShortcut}} to start a quick search with Dash.",
    description: "Dual Mode copy for shortcut to open the Dash launcher",
  },
  desktop_onboarding_shortcut_success_title: {
    message: "You did it!",
    description: "Shortcut success title in desktop onboarding",
  },
  desktop_onboarding_shortcut_success_subtitle: {
    message:
      "Shortcut set! Now you can quickly open Dash whenever you need it.",
    description: "Shortcut success subtitle in desktop onboarding",
  },
  viewed_ago: {
    message: "Viewed {{timeAgoString}}",
    description: "String used to describe time passed. ex. 5 days ago",
  },
  remove_from_stack: {
    message: "Remove from stack",
    description: "Menu text to remove an item from a stack",
  },
  browser_history_branded_connector_name: {
    message: "{{brandedSiteName}} (Browser history)",
    description: "Branded connector name for browser history results",
  },
  high_five: {
    message: "Two hands giving a high five",
    description: "Alt text on a high five image",
  },
  lock: {
    message: "Lock icon",
    description: "Alt text on a lock image",
  },
  mailbox: {
    message: "Mailbox icon",
    description: "Alt text on a mailbox image",
  },
  logged_in_as: {
    message: "You’re currently logged in as",
    description:
      "Text on page notifying user which account they are logged in with",
  },
  switch_accounts: {
    message: "Switch accounts",
    description: "CTA text that takes user to log in page",
  },
  contact_support: {
    message: "Contact support",
    description: "CTA text that takes user to support page",
  },
  blocked_generic_title: {
    message: "You need access",
    description: "Title on modal shown when user is blocked from using Dash",
  },
  blocked_generic_description: {
    message:
      "You don’t have access to this content. Please log in with an account that already has access.",
    description:
      "Description on modal shown when user is blocked from using Dash",
  },
  blocked_generic_cta: {
    message: "Request access",
    description: "CTA text on modal shown when user is blocked from using Dash",
  },
  blocked_country_title: {
    message: "Dropbox Dash isn’t available in your country yet",
    description:
      "Title on modal shown when user is blocked from using Dash due to unsupported country",
  },
  blocked_country_description: {
    message:
      "We’re actively working on expanding access and will notify you when it’s ready.",
    description:
      "Description on modal shown when user is blocked from using Dash due to unsupported country",
  },
  blocked_pending_invite_title: {
    message: "You’re invited to Dash",
    description:
      "Title on modal shown when user is blocked from using Dash due to pending invite",
  },
  blocked_pending_invite_description: {
    message: "Your admin emailed you an invite to join {{teamName}} on Dash",
    description:
      "Description on modal shown when user is blocked from using Dash due to pending invite",
  },
  blocked_unverified_email_title: {
    message: "Verify your email address",
    description:
      "Title on modal shown when user is blocked from using Dash due to unverified email",
  },
  blocked_unverified_email_description: {
    message:
      "We’ve sent a verification email to <bold>{{email}}</bold>. Please check your inbox and click the link to continue.",
    description:
      "Description on modal shown when user is blocked from using Dash due to unverified email",
  },
  blocked_unverified_email_resend_button: {
    message: "Send it again",
    description: "Button text that resend verification email",
  },
  blocked_unverified_email_resend_button_sent: {
    message: "Email sent",
    description: "Button text when new verification email is sent to user",
  },
  blocked_user_no_license_title: {
    message: "Ask your admin for an invite",
    description:
      "Title on modal shown when user is blocked from using Dash due to not having a license",
  },
  blocked_user_no_license_description: {
    message: "Already accepted an invite? Switch accounts to open Dash.",
    description:
      "Description on modal shown when user is blocked from using Dash due to not having a license",
  },
  suspended_paid_subscription_title: {
    message: "The {{teamName}} Dash team is in locked state",
    description:
      "Title on modal shown when user is blocked from using Dash due to paid subscription ending",
  },
  suspended_paid_subscription_description_admin: {
    message:
      "Your Dash plan wasn’t renewed. Buy a new plan or delete your data to exit locked state.",
    description:
      "Description on modal shown when admin user is blocked from using Dash due to paid subscription ending",
  },
  suspended_paid_subscription_description_member: {
    message:
      "Your Dash plan wasn’t renewed. Ask your admin to keep Dash so your team can keep using powerful AI tools.",
    description:
      "Description on modal shown when member user is blocked from using Dash due to paid subscription ending",
  },
  suspended_paid_subscription_cta: {
    message: "Manage plan",
    description:
      "CTA text on modal shown when user is blocked from using Dash due to paid subscription ending",
  },
  suspended_trial_subscription_title: {
    message: "The {{teamName}} team’s free preview of Dash has ended",
    description:
      "Title on modal shown when user is blocked from using Dash due to trial ending",
  },
  suspended_trial_subscription_description: {
    message: "Buy a new plan or go to your Dropbox account.",
    description:
      "Description on modal shown when user is blocked from using Dash due to trial ending",
  },
  suspended_trial_subscription_primary_cta: {
    message: "View plans",
    description:
      "Primary CTA text on modal shown when user is blocked from using Dash due to trial ending",
  },
  suspended_trial_subscription_secondary_cta: {
    message: "Go to Dropbox",
    description:
      "Secondary CTA text on modal shown when user is blocked from using Dash due to trial ending",
  },
  fallback_team_name: {
    message: "your team",
    description:
      'Fallback text saying "your team" when team name is not available',
  },
  blocked_onboarding_title: {
    message: "Good news! You’re now part of a team",
    description: "Title on modal shown when user is redirected to onboarding",
  },
  blocked_onboarding_description: {
    message:
      "Your company has added you to a Dash team, but a quick setup is needed to continue. Don’t worry, all your apps and content are safe and won’t be lost.",
    description:
      "Description on modal shown when user is redirected to onboarding",
  },
  blocked_onboarding_cta: {
    message: "Complete setup",
    description:
      "CTA text on modal shown when user is redirected to onboarding",
  },
  no_recents_yet: {
    message: "No recents yet",
    description: "When no recent content is found",
  },
  for_you_label: {
    message: "For you",
    description: "For you filter for stacks",
  },
  restart_dash: {
    message: "Restart Dash",
    description: "Button text to restart Dash",
  },
  verified: {
    message: "Verified",
    description: "Text for anything verified",
  },
  verified_search_result: {
    message: "Verified search result",
    description: "Text for anything verified",
  },
  verified_search_result_blurb: {
    message: "This content has been verified as accurate and up-to-date.",
    description: "Explains what a verified search result is",
  },
  verified_search_result_learn_more: {
    message: "Learn more",
    description: "Button CTA for verified search result tooltip",
  },
  verify_content_modal_title: {
    message: "Verify content",
    description: "Title for verifying content modal",
  },
  verify_content_remove_modal_title: {
    message: "Remove verification?",
    description: "Title for removing verification content modal",
  },
  verify_content_modal_blurb: {
    message: "A checkmark shows this content is accurate and up-to-date.",
    description: "Blurb for verifying content modal",
  },
  verify_content_modal_cancel: {
    message: "Cancel",
    description: "Close CTA for verifying content modal",
  },
  verify_content_modal_done: {
    message: "Done",
    description: "Primary CTA for verifying content modal",
  },
  verify_content_modal_remove: {
    message: "Remove",
    description: "Delete CTA for verifying content modal",
  },
  verify_content_modal_preview_result: {
    message: "Preview",
    description: "Text indicating the search result is a preview",
  },
  verify_content_modal_add_query: {
    message: "What people search for",
    description: "Text for input area for adding queries",
  },
  verify_content_modal_add_query_subtitle: {
    message:
      "Add exact phrases people can use to find this, and it will appear in their top results",
    description: "Subtitle for add query input field",
  },
  verify_content_modal_add_query_placeholder: {
    message: "Type a phrase",
    description: "Placeholder for add query input field",
  },
  verify_content_modal_add_query_aria: {
    message: "Add query",
    description: "Aria label for adding query",
  },
  verify_content_modal_confirm_remove_body: {
    message:
      "The verification checkmark will be removed from <boldText>{{title}}</boldText>",
    description: "Modal body for confirming verification removal",
  },
  verify_content_as_accurate: {
    message: "Verify content as accurate and up-to-date",
    description: "Modal body for confirming verification removal",
  },
  verify_content_manage_verification: {
    message: "Manage verification",
    description: "Modal body for confirming verification removal",
  },
  verify_content_save_success: {
    message: "Content verified. Checkmark appears in less than a minute.",
    description: "Text shown after verification is saved",
  },
  verify_content_remove_success: {
    message: "Content verification removed.",
    description: "Text shown after verification is saved",
  },
  verify_content_save_failed: {
    message: "Failed to save verification. Please try again later.",
    description: "Text shown after verification is unable to save",
  },
  verify_content_remove_failed: {
    message: "Failed to remove verification. Please try again later.",
    description: "Text shown after verification is unable to be removed",
  },
  verify_content_error_duplicate_term: {
    message: "No duplicates",
    description: "Error string if search term is a duplicate",
  },
  verify_content_error_empty_term: {
    message: "Cannot be empty",
    description: "Error string if search term is whitespace",
  },
  verify_content_error_too_long_term: {
    message: "Too long",
    description: "Error string if search term is too long",
  },
  verify_content_error_max_term: {
    message: "Maximum 10 search terms",
    description: "Error string if too many search terms",
  },
  open_result_aria: {
    message: "Open result",
    description: "Aria label for opening a search result",
  },
  close_modal_aria: {
    message: "Close modal",
    description: "Aria label for closing modal",
  },
  no_stacks_from_filter: {
    message: "We couldn’t find any stacks",
    description: "No stacks found from filtered viewed",
  },
  file: {
    message: "File",
    description: "Top-level application menu label",
  },
  view: {
    message: "View",
    description: "Top-level application menu label",
  },
  aria_search_results_list: {
    message: "Search results list",
    description: "Aria label for search result list container in an overlay",
  },
  aria_emoji_button: {
    message: "Stack emoji",
    description: "Aria label for stack emoji button",
  },
  error_checking_update: {
    message: "There was an error checking for updates",
    description: "Snackbar message if update check failed",
  },
  update_available_and_download: {
    message: "Update available. Dash will quit and install",
    description:
      "Snackbar message notifying user that app will quit and download update",
  },
  folder_content_type: {
    message: "Folder",
    description:
      "File type label for folders, used when filtering search results",
  },
  document_content_type: {
    message: "Document",
    description:
      "File type label for documents, used when filtering search results",
  },
  presentation_content_type: {
    message: "Presentation",
    description:
      "File type label for presentations, used when filtering search results",
  },
  spreadsheet_content_type: {
    message: "Spreadsheet",
    description:
      "File type label for spreadsheet, used when filtering search results",
  },
  pdf_content_type: {
    message: "PDF",
    description: "File type label for PDFs, used when filtering search results",
  },
  video_content_type: {
    message: "Video",
    description:
      "File type label for videos, used when filtering search results",
  },
  multimedia_content_type: {
    message: "Multimedia",
    description:
      "File type label for multimedia, used when filtering search results",
  },
  image_content_type: {
    message: "Image",
    description:
      "File type label for images, used when filtering search results",
  },
  images: {
    message: "Images",
    description: "Tab name for sidebar.",
  },
  videos: {
    message: "Videos",
    description: "Header for video files.",
  },
  related_images: {
    message: "Related images",
    description: "Header for related images.",
  },
  related_messages: {
    message: "Related messages",
    description: "Header for related messages.",
  },
  related_emails: {
    message: "Related emails",
    description: "Header for related emails.",
  },
  media: {
    message: "Media",
    description: "Header for media files.",
  },
  about_image_search: {
    message: "About Image Search",
    description: "Info button for image search results.",
  },
  about_video_search: {
    message: "About Video Search",
    description: "Info button for video search results.",
  },
  about_media_search: {
    message: "About Media Search",
    description: "Info button for image search results.",
  },
  audio_content_type: {
    message: "Audio",
    description:
      "File type label for audio files, used when filtering search results",
  },
  email_content_type: {
    message: "Email",
    description:
      "File type label for emails, used when filtering search results",
  },
  event_content_type: {
    message: "Event",
    description:
      "File type label for events, used when filtering search results",
  },
  chat_content_type: {
    message: "Chat",
    description:
      "File type label for chat messages, used when filtering search results",
  },
  message_content_type: {
    message: "Messages",
    description:
      "File type label for messages, used when filtering search results",
  },
  who_shortcut_title_template: {
    message: "Search for <query>{{q}}</query> at Dropbox",
    description: "Shortcut title template for who search shortcut",
  },
  drl_shortcut_title_template: {
    message: "Open drl/ <query>{{q}}</query>",
    description: "Shortcut title template for drl search shortcut",
  },
  jira_shortcut_title_template: {
    message: "Search for <query>{{q}}</query> in Jira",
    description: "Shortcut title template for Jira search shortcut",
  },
  dxw_shortcut_title_template: {
    message: "Search for <query>{{q}}</query> in your Work Dropbox",
    description: "Shortcut title template for Work Dropbox search shortcut",
  },
  dxp_shortcut_title_template: {
    message: "Search for <query>{{q}}</query> in your Personal Dropbox",
    description: "Shortcut title template for Personal Dropbox search shortcut",
  },
  irond_shortcut_title_template: {
    message: "Search for <query>{{q}}</query> in the Ironclad Dashboard",
    description:
      "Shortcut title template for Ironclad Dashboard search shortcut",
  },
  ironr_shortcut_title_template: {
    message: "Search for the <query>{{q}}</query> Ironclad Record",
    description: "Shortcut title template for Ironclad Record search shortcut",
  },
  code_shortcut_title_template: {
    message: "Search for <query>{{q}}</query> in Sourcegraph",
    description: "Shortcut title template for Sourcegraph search shortcut",
  },
  sl_shortcut_title_template: {
    message: "Search for <query>{{q}}</query> in Sharedlink",
    description: "Shortcut title template for Sharedlink search shortcut",
  },
  ns_shortcut_title_template: {
    message: "Search for <query>{{q}}</query> in Namespaces",
    description: "Shortcut title template for Namespaces search shortcut",
  },
  hs_shortcut_title_template: {
    message: "Search for <query>{{q}}</query> in Highspot",
    description: "Shortcut title template for Highspot search shortcut",
  },
  cp_shortcut_title_template: {
    message:
      "Search C Priori for <query>{{q}}</query> (use + for multiple domains, e.g. abc.com+def.com)",
    description: "Shortcut title template for C Priori search shortcut",
  },
  new_any_shortcut_title_template: {
    message: "Create a new <query>{{q}}</query>",
    description: "Shortcut title template for creating a new Dropbox Paper Doc",
  },
  google_shortcut_title_template: {
    message: "Search for <query>{{q}}</query> on Google",
    description: "Shortcut title template for Google search shortcut",
  },
  bing_shortcut_title_template: {
    message: "Search for <query>{{q}}</query> on Bing",
    description: "Shortcut title template for Bing search shortcut",
  },
  name: {
    message: "Name",
    description:
      'default query shows up when user is searching for someone in the form of "Search for {{name}} at Dropbox"',
  },
  dropbox_paper_doc: {
    message: "Dropbox Paper Doc",
    description: "File type label for Dropbox Paper Docs",
  },
  google_sheet: {
    message: "Google Sheet",
    description: "File type label for Google Sheets",
  },
  google_slide: {
    message: "Google Slide",
    description: "File type label for Google Slides",
  },
  google_doc: {
    message: "Google Doc",
    description: "File type label for Google Docs",
  },
  stack: {
    message: "Stack",
    description: "File type label for stacks",
  },
  microsoft_word_document: {
    message: "Microsoft Word Document",
    description: "File type label for Microsoft Word Documents",
  },
  microsoft_excel_spreadsheet: {
    message: "Microsoft Excel Spreadsheet",
    description: "File type label for Microsoft Excel Spreadsheets",
  },
  microsoft_powerpoint_presentation: {
    message: "Microsoft PowerPoint Presentation",
    description: "File type label for Microsoft PowerPoint Presentations",
  },
  allow_dash_search_local_files: {
    message: "Allow Dash to search your local files",
    description: "Allow Dash to search your local files",
  },
  bug_feedback: {
    message: "Bug",
    description: "Label for bug report feedback",
  },
  suggestion_feedback: {
    message: "Suggestion",
    description: "Label for suggestion feedback",
  },
  other_feedback: {
    message: "Other",
    description: "Label for other feedback",
  },
  cold_start_banner_default: {
    message:
      "Dash search is powered by connected apps and the extension. Add both for the best results.",
    description:
      "Text displayed in the cold start banner when the user has not added connectors or added the extension",
  },
  cold_start_banner_with_connectors: {
    message:
      "Dash is setting things up—some results may not be visible yet. While you wait, add the extension to improve your results.",
    description:
      "Text displayed in the cold start banner when the user has added connectors or added the extension",
  },
  cold_start_banner_with_extension: {
    message:
      "Dash is setting things up—some results may not be visible yet. While you wait, add apps to improve your results.",
    description:
      "Text displayed in the cold start banner when the user has not added connectors, but has added the extension",
  },
  cold_start_banner_with_extension_and_connectors: {
    message:
      "Dash is getting to know your search preferences. Your results will keep improving as you search and explore content.",
    description:
      "Text displayed in the cold start banner when the user has added connectors and the extension",
  },
  changed_language_modal_title: {
    message: "Changed language to {{language}}",
    description: "Title for the modal displayed after changing the language",
  },
  changed_language_modal_description_web: {
    message:
      "Some parts of Dash might not reflect the new language until you refresh the page.",
    description:
      "Description for the modal displayed after changing the language",
  },
  changed_language_modal_description_desktop: {
    message:
      "Some parts of Dash might not reflect the new language until you restart the app.",
    description:
      "Description for the modal displayed after changing the language",
  },
  changed_language_modal_action_web: {
    message: "Refresh now",
    description:
      "Action button for the modal displayed after changing the language",
  },
  changed_language_modal_action_desktop: {
    message: "Restart now",
    description:
      "Action button for the modal displayed after changing the language",
  },
  changed_language_modal_action_later: {
    message: "Later",
    description:
      "Dismiss button for the modal displayed after changing the language",
  },
  filter_bar_connector_dropdown_label: {
    message: "App Filters Dropdown",
    description: "Aria label for App filters dropdown",
  },
  filter_bar_content_type_dropdown_label: {
    message: "Content Type Filters Dropdown",
    description: "Aria label for Content Type filters dropdown",
  },
  filter_bar_person_dropdown_label: {
    message: "Person Filters Dropdown",
    description: "Aria label for Person filters dropdown",
  },
  filter_bar_last_updated_dropdown_label: {
    message: "Last Updated Filters Dropdown",
    description: "Aria label for Last Updated filters dropdown",
  },
  param: {
    message: "param",
    description: "URL parameter",
  },
  connector_description_airtable: {
    message: "Find tables, bases, and views",
    description:
      "Description for app that can be connected to Dropbox Dash: airtable",
  },
  connector_description_asana: {
    message: "Find projects and tasks",
    description:
      "Description for app that can be connected to Dropbox Dash: asana",
  },
  connector_description_box: {
    message: "Search files and folders",
    description:
      "Description for app that can be connected to Dropbox Dash: box",
  },
  connector_description_clickup: {
    message: "Search teams, spaces, folders, lists, tasks and comments",
    description:
      "Description for app that can be connected to Dropbox Dash: clickup",
  },
  connector_description_confluence: {
    message: "Search spaces and pages",
    description:
      "Description for app that can be connected to Dropbox Dash: confluence",
  },
  connector_description_lucidchart: {
    message: "Search collaborators and documents",
    description:
      "Description for app that can be connected to Dropbox Dash: lucidchart",
  },
  connector_description_teams: {
    message: "Search messages, group chats, and channels",
    description:
      "Description for app that can be connected to Dropbox Dash: msTeams",
  },
  connector_description_dropbox: {
    message: "Search files, folders and Paper docs",
    description:
      "Description for app that can be connected to Dropbox Dash: dropbox",
  },
  connector_description_figma: {
    message: "Search projects and files",
    description:
      "Description for app that can be connected to Dropbox Dash: figma",
  },
  connector_description_front: {
    message: "Search customer conversations",
    description:
      "Description for app that can be connected to Dropbox Dash: front",
  },
  connector_description_github: {
    message: "Search across repos, pull requests, and issues",
    description:
      "Description for app that can be connected to Dropbox Dash: github",
  },
  connector_description_gmail: {
    message: "Search and open emails",
    description:
      "Description for app that can be connected to Dropbox Dash: gmail",
  },
  connector_description_googlecalendar: {
    message: "Find meetings and video calls",
    description:
      "Description for app that can be connected to Dropbox Dash: googleCalendar",
  },
  connector_description_googledrive: {
    message: "Search files and folders",
    description:
      "Description for app that can be connected to Dropbox Dash: googledrive",
  },
  connector_description_googleworkspace: {
    message: "Search across Calendar, G Suite, and Gmail",
    description:
      "Description for app that can be connected to Dropbox Dash: googleWorkspace",
  },
  connector_description_hubspot: {
    message: "Search contacts, emails and deals",
    description:
      "Description for app that can be connected to Dropbox Dash: hubspot",
  },
  connector_description_intercom: {
    message: "Search for customers",
    description:
      "Description for app that can be connected to Dropbox Dash: intercom",
  },
  connector_description_jira: {
    message: "Search and open issues",
    description:
      "Description for app that can be connected to Dropbox Dash: jira",
  },
  connector_description_localfiles: {
    message: "Search files across your desktop",
    description:
      "Description for app that can be connected to Dropbox Dash: localFiles",
  },
  connector_description_msoutlook: {
    message: "Find and open emails",
    description:
      "Description for app that can be connected to Dropbox Dash: msOutlook",
  },
  connector_description_notion: {
    message: "Search pages",
    description:
      "Description for app that can be connected to Dropbox Dash: notion",
  },
  connector_description_monday: {
    message: "Search docs, folders, accounts, boards, tags and teams",
    description:
      "Description for app that can be connected to Dropbox Dash: monday",
  },
  connector_description_okta: {
    message: "Search user-profiles and available apps",
    description:
      "Description for app that can be connected to Dropbox Dash: okta",
  },
  connector_description_onedrive: {
    message: "Search files and folders",
    description:
      "Description for app that can be connected to Dropbox Dash: onedrive",
  },
  connector_description_onenote: {
    message: "Search notebooks and pages",
    description:
      "Description for app that can be connected to Dropbox Dash: onenote",
  },
  connector_description_outlook: {
    message: "Find and open emails",
    description:
      "Description for app that can be connected to Dropbox Dash: outlook",
  },
  connector_description_outreach: {
    message: "Search prospects and accounts",
    description:
      "Description for app that can be connected to Dropbox Dash: outreach",
  },
  connector_description_pagerduty: {
    message: "Search incidents and on-call schedules",
    description:
      "Description for app that can be connected to Dropbox Dash: pagerduty",
  },
  connector_description_quip: {
    message: "Search documents",
    description:
      "Description for app that can be connected to Dropbox Dash: quip",
  },
  connector_description_salesforce: {
    message: "Find and open records",
    description:
      "Description for app that can be connected to Dropbox Dash: salesforce",
  },
  connector_description_servicenow: {
    message: "Search cases, incidents, articles, and comments",
    description:
      "Description for app that can be connected to Dropbox Dash: servicenow",
  },
  connector_description_sharepoint: {
    message: "Search across team sites",
    description:
      "Description for app that can be connected to Dropbox Dash: sharepoint",
  },
  connector_description_smartsheet: {
    message: "Search sheets, events, folders, and discussions",
    description:
      "Description for app that can be connected to Dropbox Dash: smartsheet",
  },
  connector_description_slack: {
    message: "Search messages, threads, and channels",
    description:
      "Description for app that can be connected to Dropbox Dash: slack",
  },
  connector_description_stackoverflow: {
    message: "Search questions, answers, articles, and comments",
    description:
      "Description for app that can be connected to Dropbox Dash: stackoverflow",
  },
  connector_description_stackoverflowteams: {
    message: "Search questions, answers, articles, and comments",
    description:
      "Description for app that can be connected to Dropbox Dash: stackoverflowTeams",
  },
  connector_description_trello: {
    message: "Search and open cards and boards",
    description:
      "Description for app that can be connected to Dropbox Dash: trello",
  },
  connector_description_wordpress: {
    message: "Search sites, posts, and comments",
    description:
      "Description for app that can be connected to Dropbox Dash: wordpress",
  },
  connector_description_workday: {
    message: "Search workers, cases, and actions",
    description:
      "Description for app that can be connected to Dropbox Dash: workday",
  },
  connector_description_zendesk: {
    message: "Search tickets, articles, and posts",
    description:
      "Description for app that can be connected to Dropbox Dash: zendesk",
  },
  connector_description_zoom: {
    message: "Search transcripts, channels, and chats",
    description:
      "Description for app that can be connected to Dropbox Dash: zoom",
  },
  connector_description_ninetynineplus: {
    message: "Search articles",
    description:
      "Description for app that can be connected to Dropbox Dash: 99plus",
  },
  connector_description_gong: {
    message: "Search calls, users, and transcripts",
    description:
      "Description for app that can be connected to Dropbox Dash: gong",
  },
  connector_description_greenhouse: {
    message: "Search job posts, candidates, and applications",
    description:
      "Description for app that can be connected to Dropbox Dash: greenhouse",
  },
  connector_description_googlemeet: {
    message: "Search transcripts and recordings",
    description:
      "Description for app that can be connected to Dropbox Dash: googlemeet",
  },
  connector_description_miro: {
    message: "Search members, boards, items and tags",
    description:
      "Description for app that can be connected to Dropbox Dash: miro",
  },
  connector_description_custom_ingest: {
    message: "Push data from an external application to Dash",
    description:
      "Description for app that can be connected to Dropbox Dash: customingest",
  },
  connector_description_gcp: {
    message: "Search Google Cloud Platform Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: gcp",
  },
  connector_description_adobe: {
    message: "Search Adobe Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: adobe",
  },
  connector_description_amazon: {
    message: "Search Amazon Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: amazon",
  },
  connector_description_docusign: {
    message: "Search Docusign Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: docusign",
  },
  connector_description_bitbucket: {
    message: "Search Bitbucket Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: bitbucket",
  },
  connector_description_gitlab: {
    message: "Search Gitlab Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: gitlab",
  },
  connector_description_tableau: {
    message: "Search Tableau Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: tableau",
  },
  connector_description_zoho_flow: {
    message: "Search Zoho Flow Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: zohoflow",
  },
  connector_description_grammarly: {
    message: "Search Grammarly Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: grammarly",
  },
  connector_description_jotform: {
    message: "Search Jotform Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: jotform",
  },
  connector_description_loom: {
    message: "Search Loom Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: loom",
  },
  connector_description_typeform: {
    message: "Search Typeform Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: typeform",
  },
  connector_description_mural: {
    message: "Search Mural Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: mural",
  },
  connector_description_bamboohr: {
    message: "Search BambooHR Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: bamboohr",
  },
  connector_description_harvest: {
    message: "Search Harvest Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: harvest",
  },
  connector_description_calendly: {
    message: "Search Calendly Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: calendly",
  },
  connector_description_fullstory: {
    message: "Search Fullstory Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: fullstory",
  },
  connector_description_freshservice: {
    message: "Search Freshservice Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: freshservice",
  },
  connector_description_datadog: {
    message: "Search Datadog Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: datadog",
  },
  connector_description_grafana: {
    message: "Search Grafana Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: grafana",
  },
  connector_description_twilio: {
    message: "Search Twilio Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: twilio",
  },
  connector_description_everhour: {
    message: "Search Everhour Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: everhour",
  },
  connector_description_invision: {
    message: "Search Invision Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: invision",
  },
  connector_description_hubstaff: {
    message: "Search Hubstaff Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: hubstaff",
  },
  connector_description_onelogin: {
    message: "Search OneLogin Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: onelogin",
  },
  connector_description_pendo: {
    message: "Search Pendo Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: pendo",
  },
  connector_description_chameleon: {
    message: "Search Chameleon Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: chameleon",
  },
  connector_description_interact: {
    message: "Search Interact Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: interact",
  },
  connector_description_looker: {
    message: "Search Looker Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: looker",
  },
  connector_description_lumapps: {
    message: "Search LumApps Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: lumapps",
  },
  connector_description_integrately: {
    message: "Search Integrately Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: integrately",
  },
  connector_description_opsgenie: {
    message: "Search Opsgenie Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: opsgenie",
  },
  connector_description_marker: {
    message: "Search Marker Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: marker",
  },
  connector_description_lattice: {
    message: "Search Lattice Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: lattice",
  },
  connector_description_seismic: {
    message: "Search Seismic Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: seismic",
  },
  connector_description_ringcentral: {
    message: "Search RingCentral Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: ringcentral",
  },
  connector_description_aha: {
    message: "Search Aha Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: aha",
  },
  connector_description_benchling: {
    message: "Search Benchling Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: benchling",
  },
  connector_description_bugsnag: {
    message: "Search Bugsnag Webpages",
    description:
      "Description for app that can be connected to Dropbox Dash: bugsnag",
  },
  connector_description_chrome: {
    message: "Search tabs and bookmarks",
    description: "Description for a Dash browser extension for Chrome",
  },
  connector_description_firefox: {
    message: "Search tabs and bookmarks",
    description: "Description for a Dash browser extension for Firefox",
  },
  connector_description_safari: {
    message: "Search tabs and bookmarks",
    description: "Description for a Dash browser extension for Safari",
  },
  connector_description_edge: {
    message: "Search tabs and bookmarks",
    description: "Description for a Dash browser extension for Edge",
  },
  failed_to_update_emoji: {
    message: "Failed to update emoji. ",
    description:
      "Snackbar message when there is an error while updating emoji for a stack",
  },
  stack_emoji_picker_custom_logo: {
    message: "Custom logo",
    description: "Label for custom logo in stack emoji picker",
  },
  failed_to_update_logo: {
    message: "Failed to update logo.",
    description:
      "Snackbar message when there is an error while updating logo for a stack",
  },
  failed_to_update_banner: {
    message: "Failed to update banner.",
    description:
      "Snackbar message when there is an error while updating banner for a stack",
  },
  stack_banner_edit_button: {
    message: "Edit cover",
    description: "Label for edit cover button in stack banner",
  },
  stack_banner_upload_button: {
    message: "Upload cover image",
    description: "Label for upload cover image button in stack banner",
  },
  generic_error_message: {
    message: "Uh-oh! Something went wrong.",
    description: "Generic error message when the app crashes.",
  },
  reload_window_button: {
    message: "Reload window",
    description: "Button to reload the current view",
  },
  google_docs: {
    message: "Google Docs",
    description: "App name for Google Docs",
  },
  google_slides: {
    message: "Google Slides",
    description: "App name for Google Slides",
  },
  google_sheets: {
    message: "Google Sheets",
    description: "App name for Google Sheets",
  },
  compose_editor_move_column_left: {
    message: "Move column left",
    description: "Label for moving a table column left",
  },
  compose_editor_move_column_right: {
    message: "Move column right",
    description: "Label for moving a table column right",
  },
  compose_editor_move_row_up: {
    message: "Move row up",
    description: "Label for moving a table row up",
  },
  compose_editor_move_row_down: {
    message: "Move row down",
    description: "Label for moving a table row down",
  },
  automatic_locale: {
    message: "Automatic (follows account settings)",
    description: "Label for app locale option that follows account settings",
  },
  stacks_add_to_section: {
    message: "Add to section",
    description:
      "Label for a menu where user can add a stack item directly to a section in a stack",
  },
  next_page: {
    message: "Next page",
    description: "Label for button to navigate to the next page of a document",
  },
  previous_page: {
    message: "Previous page",
    description:
      "Label for button to navigate to the previous page of a document",
  },
  team_invite_suggested_people: {
    message: "Suggested people",
    description: "Label for typeahead overlay",
  },
  team_invite_add_email_or_name: {
    message: "Enter email or name",
    description: "Placeholder text for invite form input",
  },
  team_invite_member: {
    message: "Member",
    description: "Member role option on admin team invite",
  },
  team_invite_add_another: {
    message: "Add email",
    description: "Button that adds another user to the team invite list",
  },
  team_invite_of_x_licenses: {
    message: "{{licensesUsed}} of {{licenseCount}} licenses used",
    description:
      "Text to let the user know how many licenses they have assigned out of their existing license count",
  },
  team_invite_co_admin: {
    message: "Co-admin",
    description: "Co-admin role option on admin team invite",
  },
  team_invite_individuals_title: {
    message: "Individuals",
    description:
      "Title text for invite form component that allows users to invite individuals to their team",
  },
  team_invite_admin_over_quota_license_limit_message: {
    message: "Remove a member in admin console to free up a license.",
    description: "Text describing the action to take to free up a license",
  },
  team_invite_user_over_quota_license_limit_message: {
    message:
      "Your admin can remove members in admin console to free up licenses.",
    description: "Text describing the action to take to free up a license",
  },
  team_invite_manage_licenses: {
    message: "Manage licenses",
    description: "Text for the button to manage licenses",
  },
  team_invite_over_quota_license_limit_with_count_one: {
    message: "{{count}} license used",
    description: "Text for the button to manage licenses",
  },
  team_invite_over_quota_license_limit_with_count_other: {
    message: "All {{count}} licenses used",
    description: "Text for the button to manage licenses",
  },
  team_invite_over_quota_member_limit: {
    message: "Dropbox team member limit reached",
    description: "Text for the button to manage licenses",
  },
  team_invite_admin_over_quota_member_limit_message: {
    message: "Purchase more licenses to invite people to Dash.",
    description:
      "Text describing the action to take to free up a license when member limit is reached",
  },
  team_invite_user_over_quota_member_limit_message: {
    message:
      "Your admin can remove members in admin console to free up licenses.",
    description: "Text describing the action to take to free up a member seats",
  },
  team_invite_buy_licenses: {
    message: "Buy licenses",
    description: "Text for the button to buy licenses",
  },
  team_invite_image_alt_text: {
    message: "Paper airplane letting you know you are over quota",
    description: "Alt text for the paper airplane image",
  },
  trial_ending_notification_search: {
    message: "Nice! Keep searching without limits",
    description: "Title trial ending notification after searching",
  },
  trial_ending_notification_chat: {
    message: "Nice! Keep chatting without limits",
    description: "Title trial ending notification after using chat",
  },
  trial_ending_notification_stacks: {
    message: "Nice! Keep organizing without limits",
    description: "Title trial ending notification after creating a stack",
  },
  trial_ending_notification_connector: {
    message: "Nice! Keep connecting without limits",
    description: "Title trial ending notification after adding a new connector",
  },
  trial_ending_days_remaining_subtitle_one: {
    message: "As a heads up, you have {{count}} day left to use Dash",
    description:
      "Trial ending subtitle telling user how many days they have left on trial",
  },
  trial_ending_days_remaining_subtitle_other: {
    message: "As a heads up, you have {{count}} days left to use Dash",
    description:
      "Trial ending subtitle telling user how many days they have left on trial",
  },
  trial_ending_view_plans: {
    message: "View plans",
    description: "Trial ending CTA to take admins to view dash plans",
  },
  self_serve_company_info_title: {
    message: "What’s the name of your organization?",
    description: "Title for the company info self serve onboarding step",
  },
  self_serve_add_logo_or_image: {
    message: "Add logo or image",
    description: "Label for drag and drop logo/image for company",
  },
  self_serve_invite_whole_team: {
    message: "Invite your whole team",
    description: "Label Invite whole team checkbox container",
  },
  self_serve_image_alt_text: {
    message: "Uploaded company logo",
    description: "Alt text for the company logo",
  },
  self_serve_organization: {
    message: "Organization",
    description: "Form field label for the organization name",
  },
  self_serve_enter_organization_name: {
    message: "Enter organization name",
    description: "Form field placeholder for the organization name",
  },
  self_serve_company_info_description: {
    message: "Use a name that’s recognizable for members. Change it anytime.",
    description: "Description for the company info self serve onboarding step",
  },
  self_serve_profiling_title: {
    message: "Tell us about your work",
    description: "Title for the profiling self serve onboarding step",
  },
  self_serve_profiling_description: {
    message: "We’ll use this to recommend ways to save time.",
    description: "Description for the profiling self serve onboarding step",
  },
  self_serve_jtbd_title: {
    message: "How do you want to save time?",
    description: "Title for the jobs to be done self serve onboarding step",
  },
  self_serve_jtbd_description: {
    message: "Pick all the ways, and we’ll add tutorials to show you how.",
    description:
      "Description for the jobs to be done self serve onboarding step",
  },
  self_serve_jtbd_search_answer_title: {
    message: "Find things fast",
    description: "Title for the search jobs to be done option",
  },
  self_serve_jtbd_search_answer_description: {
    message: "Was it in a file? Maybe an email? Search across all your apps.",
    description: "Description for the search jobs to be done option",
  },
  self_serve_jtbd_answers_answer_title: {
    message: "Summarize files",
    description: "Title for the answers jobs to be done option",
  },
  self_serve_jtbd_answers_answer_description: {
    message: "Know what matters faster with summaries and related insights.",
    description: "Description for the answers jobs to be done option",
  },
  self_serve_jtbd_ai_tools_answer_title: {
    message: "Write better",
    description: "Title for the ai tools jobs to be done option",
  },
  self_serve_jtbd_ai_tools_answer_description: {
    message: "Tone and style options help you create emails and documents.",
    description: "Description for the ai tools jobs to be done option",
  },
  self_serve_connectors_title: {
    message: "Add your apps",
    description: "Title for the connectors self serve onboarding step",
  },
  self_serve_connectors_description: {
    message:
      "Add your apps to search them all at once. <policyLink>Learn about our privacy measures and AI</policyLink>.",
    description: "Description for the connectors self serve onboarding step",
  },
  self_serve_connectors_legal_note_line_1: {
    message:
      "You’ll be able to search up to 30 TB of total content. That’s 6 million photos or 15 billion text documents.",
    description: "Legal note for the connectors self serve onboarding step",
  },
  self_serve_connectors_legal_note_line_2: {
    message:
      "If an admin or member is inactive for 90 days, any apps they added will be removed.",
    description:
      "Line 2 of the Legal note for the connectors self serve onboarding step",
  },
  show_all_apps: {
    message: "Show all apps",
    description:
      "Button text for Show all apps button, which opens a modal to show all available apps",
  },
  self_serve_team_invite_title: {
    message: "Invite people to join your team",
    description: "Title for the team invite self serve onboarding step",
  },
  self_serve_large_team_title: {
    message: "Great, Dash is perfect for large teams",
    description: "Title for the large teams self serve onboarding step",
  },
  self_serve_large_team_description: {
    message: "A sales representative can get you set up.",
    description: "Description for the large teams self serve onboarding step",
  },
  self_serve_error_page_title: {
    message: "Something went wrong on our end",
    description: "Title for the error page in the self serve onboarding flow",
  },
  self_serve_error_page_description: {
    message: "We weren’t able to start your subscription",
    description:
      "Subheader for the error page in the self serve onboarding flow",
  },
  self_serve_contact_sales: {
    message: "Contact sales",
    description: "Button text to direct the user to the sales contact page",
  },
  self_serve_download_upsell_title: {
    message: "Bring Dash to desktop",
    description: "Title for the download upsell self serve onboarding step",
  },
  self_serve_download_upsell_description: {
    message:
      "Launch a Dash search from your dock, menu bar, or keyboard shortcut.",
    description:
      "Description for the download upsell self serve onboarding step",
  },
  self_serve_skip: {
    message: "Skip",
    description: "Text on the button to skip an onboarding step",
  },
  self_serve_download_later: {
    message: "Maybe later",
    description: "Text on the download upsell skip download button",
  },
  self_serve_download: {
    message: "Download",
    description: "Text on the download upsell download button",
  },
  self_serve_profiling_company_size_question: {
    message: "How big is the company you work at?",
    description: "Profiling question to determine size of company.",
  },
  self_serve_profiling_just_me: {
    message: "Just me",
    description: "Profiling question answer for when answer is just me.",
  },
  self_serve_profiling_number_range: {
    message: "{{start}}-{{end}}",
    description: "Profiling question answer for numerical range.",
  },
  self_serve_profiling_number_range_over_1000: {
    message: "Over 1000",
    description: "Profiling question answer for numerical range over 1000.",
  },
  self_serve_profiling_industry_question: {
    message: "What industry do you work in?",
    description: "Profiling question to determine users industry.",
  },
  self_serve_profiling_kind_of_work_question: {
    message: "What kind of work do you do?",
    description: "Profiling question to determine users line of work.",
  },
  onboarding_survey_answer_yes: {
    message: "Yes",
    description: "Affirmative response to if the user is the IT Admin",
  },
  self_serve_profiling_it_admin_answer_no: {
    message: "No, I’ll invite an admin",
    description: "Negative response to if the user is the IT Admin",
  },
  self_serve_profiling_it_admin_question: {
    message: "Will you manage Dash and content access?",
    description: "Profiling question to determine if user is an it admin.",
  },
  self_serve_profiling_manage_access_question: {
    message: "Will you manage Dash and content access?",
    description:
      "Profiling question to determine if user will manage access to content",
  },
  self_serve_profiling_manage_access_no: {
    message: "No",
    description:
      "Negative response to asking user if they will manage Dash content",
  },
  self_serve_profiling_other_answer: {
    message: "Other",
    description: "Other as title as answer to title profiling question",
  },
  self_serve_profiling_title_jobs_to_be_done_question: {
    message: "Last question—how do you want to save time?",
    description:
      "Jobs to be done question within team member self serve onboarding",
  },
  self_serve_profiling_jtbd_find_things_fast: {
    message: "Find things fast",
    description:
      "Answer to team member jobs to be done when user wants to find things fast",
  },
  self_serve_profiling_jtbd_summarize_files: {
    message: "Summarize files",
    description:
      "Answer to team member jobs to be done when user wants to summarize things",
  },
  self_serve_profiling_jtbd_write_better: {
    message: "Write better",
    description:
      "Answer to team member jobs to be done when user wants to write better",
  },
  self_serve_profiling_jtbd_not_sure_yet: {
    message: "Not sure yet",
    description:
      "Answer to team member jobs to be done when user is just checking things out",
  },
  self_serve_profiling_kind_of_work_answer_creative: {
    message: "Creative",
    description:
      "Option for the kind of work within the profiling questions of self-serve onboarding",
  },
  self_serve_profiling_kind_of_work_answer_engineering_product_design: {
    message: "Engineering, Product, Design",
    description:
      "Option for the kind of work within the profiling questions of self-serve onboarding",
  },
  self_serve_profiling_kind_of_work_answer_financial_or_strategic_advisor: {
    message: "Financial or Strategic Advisor",
    description:
      "Option for the kind of work within the profiling questions of self-serve onboarding",
  },
  self_serve_profiling_kind_of_work_answer_human_resources: {
    message: "Human Resources",
    description:
      "Option for the kind of work within the profiling questions of self-serve onboarding",
  },
  self_serve_profiling_kind_of_work_answer_information_technology: {
    message: "Information Technology",
    description:
      "Option for the kind of work within the profiling questions of self-serve onboarding",
  },
  self_serve_profiling_kind_of_work_answer_marketing: {
    message: "Marketing",
    description:
      "Option for the kind of work within the profiling questions of self-serve onboarding",
  },
  self_serve_profiling_kind_of_work_answer_operations: {
    message: "Operations",
    description:
      "Option for the kind of work within the profiling questions of self-serve onboarding",
  },
  self_serve_profiling_kind_of_work_answer_sales: {
    message: "Sales",
    description:
      "Option for the kind of work within the profiling questions of self-serve onboarding",
  },
  self_serve_profiling_industry_answer_architecture_engineering_construction: {
    message: "Architecture, Engineering, or Construction",
    description:
      "Option for the industry within the profiling questions of self-serve onboarding",
  },
  self_serve_profiling_industry_answer_capital_markets: {
    message: "Capital Markets",
    description:
      "Option for the industry within the profiling questions of self-serve onboarding",
  },
  self_serve_profiling_industry_answer_education: {
    message: "Education",
    description:
      "Option for the industry within the profiling questions of self-serve onboarding",
  },
  self_serve_profiling_industry_answer_financial_services: {
    message: "Financial Services",
    description:
      "Option for the industry within the profiling questions of self-serve onboarding",
  },
  self_serve_profiling_industry_answer_government: {
    message: "Government",
    description:
      "Option for the industry within the profiling questions of self-serve onboarding",
  },
  self_serve_profiling_industry_answer_healthcare: {
    message: "Healthcare",
    description:
      "Option for the industry within the profiling questions of self-serve onboarding",
  },
  self_serve_profiling_industry_answer_manufacturing: {
    message: "Manufacturing",
    description:
      "Option for the industry within the profiling questions of self-serve onboarding",
  },
  self_serve_profiling_industry_answer_media_or_sports: {
    message: "Media or Sports",
    description:
      "Option for the industry within the profiling questions of self-serve onboarding",
  },
  self_serve_profiling_industry_answer_professional_services: {
    message: "Professional Services",
    description:
      "Option for the industry within the profiling questions of self-serve onboarding",
  },
  self_serve_profiling_industry_answer_technology: {
    message: "Technology",
    description:
      "Option for the industry within the profiling questions of self-serve onboarding",
  },
  result_assigned_to: {
    message: "Assigned to <tag>{{name}}</tag>",
    description: "Shown next to assignee metadata on search results",
  },
  stack_item_added_by: {
    message: "Added by {{name}}",
    description: "Indicates who added a stack item to a stack",
  },
  verifications_table_header_created_by: {
    message: "Verified by",
    description:
      "Table header for last verified by column in verifications table",
  },
  verifications_table_header_updated_by: {
    message: "Last updated by",
    description:
      "Table header for last verified at column in verifications table",
  },
  verifications_table_header_title: {
    message: "Verified content",
    description: "Table header for title column in verifications table",
  },
  verifications_table_empty_state: {
    message: "No verified content yet. Content you verify shows here.",
    description: "Empty state for verifications table",
  },
  verifications_table_title: {
    message:
      "Content listed here is marked as a reliable source in search results.",
    description: "Button text to publish content by Admins",
  },
  verifications_table_error: {
    message: "Unfortunately, we ran into an error fetching verifications.",
    description: "Error message for verifications table",
  },
  verifications_error_retry: {
    message: "Retry",
    description: "Button text to retry fetching verifications",
  },
  verifications_load_more: {
    message: "Load more",
    description: "Button text to load more verifications",
  },
  spelling_suggestion_showing_results_for: {
    message: "Showing results for ",
    description: "Text for showing results for a spelling suggestion",
  },
  spelling_suggestion_search_instead_for: {
    message: "Search instead for ",
    description: "Text for searching instead for a spelling suggestion",
  },
  spelling_suggestion_showing_results_for_label: {
    message: "Confirm corrected spelling",
    description: "Text for confirming corrected spelling",
  },
  spelling_suggestion_search_instead_for_label: {
    message: "Search for original spelling",
    description: "Text for searching for original spelling",
  },
  verification_delete_label: {
    message: "Delete verification",
    description: "Aria label for delete verification button",
  },
  verification_edit_label: {
    message: "Edit verification",
    description: "Aria label for edit verification button",
  },
  quick_links_title: {
    message: "Quick links",
    description: "Title for the quick links section",
  },
  quick_links_add_more: {
    message: "Add more",
    description: "Title for the quick links add more button",
  },
  quick_links_menu_title: {
    message: "Quick link menu",
    description: "Individual quick link menu item title",
  },
  drag_handle_usage_instructions: {
    message:
      "Press space bar to start a drag.\nWhen dragging you can use the arrow keys to move the item around and escape to cancel.\nSome screen readers may require you to be in focus mode or to use your pass through key",
    description: "Instructions for drag handle",
  },
  unsaved_changes_modal_title: {
    message: "Discard unsaved changes?",
    description: "Title for the unsaved changes modal",
  },
  unsaved_changes_modal_body: {
    message: "You have unsaved changes. Are you sure you want to continue?",
    description: "Body for the unsaved changes modal",
  },
  unsaved_changes_modal_keep_editing: {
    message: "Keep editing",
    description: "Button to keep editing in the unsaved changes modal",
  },
  unsaved_changes_modal_discard_changes: {
    message: "Discard changes",
    description: "Button to discard changes in the unsaved changes modal",
  },
  drag_tooltip_title: {
    message: "Drag to reorder",
    description: "Tooltip above an icon to indicate that you can drag a stack",
  },
  stack_item_comment_placeholder: {
    message: "Write something...",
    description:
      "Placeholder text in an input box where a user can enter a comment to leave on an item in a Stack",
  },
  stack_item_author_placeholder: {
    message: "You",
    description:
      "Shown on an in-progress comment to indicate that the author is the current user a.k.a 'You'",
  },
  stack_item_time_placeholder: {
    message: "Just now",
    description:
      "Shown on an in-progress comment to indicate that the comment was just made",
  },
  stack_item_comment_post: {
    message: "Post",
    description: "Text on a button that posts a comment to a Stack Item",
  },
  stack_item_comment_show_more: {
    message: "Show more",
    description:
      "Text on a button that, when clicked, shows the remaining content of a truncated comment",
  },
  stack_item_comment_show_less: {
    message: "Show less",
    description:
      "Text on a button that, when clicked, truncates a comment to a certain length",
  },
  open_file: {
    message: "Open file",
    description: "Title for open file button",
  },
  add_comment_tooltip: {
    message: "Add a comment",
    description:
      "Tooltip title for a button when clicked, show the add a comment input",
  },
  add_comment_disabled_tooltip: {
    message: "Only editors of a stack can comment",
    description:
      "Tooltip title for a comment button is disabled because user does not have write permission to a stack",
  },
  gmail_connect_title: {
    message: "Next, check any boxes",
    description: "Title to inform users to check all boxes on the next page",
  },
  gmail_connect_subtitle: {
    message: "To add Gmail, any boxes shown need to be checked.",
    description:
      "Subtitle to inform users to check all boxes on the next page in order to connect to Gmail.",
  },
  stack_comments_failed_to_load: {
    message: "Couldn‘t load comments.",
    description:
      "Error shown in a snackbar when comments cannot be fetched for a stack",
  },
  stack_comments_failed_to_add: {
    message: "Couldn‘t add comment. Try again later.",
    description:
      "Error shown in a snackbar when a comment cannot be added to a stack",
  },
  stack_comments_failed_to_delete: {
    message: "Couldn‘t delete comment. Try again later.",
    description:
      "Error shown in a snackbar when a comment cannot be deleted from a stack",
  },
  stack_comments_failed_to_update: {
    message: "Couldn‘t update comment. Try again later.",
    description:
      "Error shown in a snackbar when a comment cannot be updated in a stack",
  },
  stack_comments_failed_duplicate_comment: {
    message: "Can’t add more than one comment.",
    description:
      "Error shown in a snackbar when a user tries to add a comment to a stack item that already has one",
  },
  stack_comments_add_comment_success: {
    message: "Comment added.",
    description:
      "Message shown in a snackbar when a user successfully adds a comment",
  },
  stack_comments_delete_comment_success: {
    message: "Comment deleted.",
    description:
      "Message shown in a snackbar when a user successfully deletes a comment",
  },
  stack_comments_edit_comment_success: {
    message: "Comment updated.",
    description:
      "Message shown in a snackbar when a user succcessfully edits a comment",
  },
  stack_comments_prompt_title: {
    message: "Care to comment?",
    description:
      "Title of a tooltip shown to a user prompting them to try commenting after adding a new item to a stack",
  },
  stack_comments_prompt_body: {
    message: "Give more context by adding a comment.",
    description:
      "Body of a tooltip shown to a user prompting them to try commenting after adding a new item to a stack",
  },
  confirm_delete_comment_title: {
    message: "Delete this comment?",
    description:
      "Modal title text asking the user if they are sure they want to delete the comment",
  },
  confirm_delete_comment_body: {
    message:
      "Deleting this comment will delete it for everyone who can view this stack.",
    description:
      "Modal body confirmation detail text asking the user if they are sure they want to delete the comment",
  },
  confirm_delete_stack_item_with_comment_title: {
    message: "Delete this item?",
    description:
      "Modal title text asking the user if they are sure they want to delete a stack item with a comment",
  },
  confirm_delete_stack_item_with_comment_body: {
    message:
      "Deleting this stack item will also remove any comments associated with it.",
    description:
      "Modal body confirmation detail text asking the user if they want to delete a stack item with a comment",
  },
  omnibox_search_prompt_title: {
    message: "Type ‘ds‘ to search in Dash",
    description: "Title for the omnibox search prompt",
  },
  omnibox_search_prompt_subtitle: {
    message:
      "For a shortcut to Dash, type ‘ds‘ and your keywords in the search bar.",
    description: "Subtitle for the omnibox search prompt",
  },
  seconds_ago: {
    message: "seconds ago",
    description:
      "Generic time descriptor used when an event occurred less than a minute ago",
  },
  publish_content_modal_updated_subtitle: {
    message:
      "Search to choose a stack to publish to your entire team on Dash. You can only publish stacks for which you have edit permissions.",
    description: "Text on publish content modal for Admins",
  },
  not_available: {
    message: "Not available",
    description: "Text for profile detail not available on User profile page",
  },
  same_timezone_as_yours: {
    message: "Same as you",
    description: "Timezone description on User profile page",
  },
  timezone_ahead: {
    message: "ahead of you",
    description: "Timezone description on User profile page",
  },
  timezone_behind: {
    message: "behind you",
    description: "Timezone description on User profile page",
  },
  current_time_info: {
    message: "{{countHours}} {{hours}} {{aheadOrBehind}}",
    description: "Time description on User profile page",
  },
  profile_current_time: {
    message: "Current time",
    description: "Time description on User profile page",
  },
  less_month: {
    message: "Less than a month",
    description: "Time description on User profile page",
  },
  year_one: {
    message: "{{count}} year",
    description: "Time description on User profile page",
  },
  year_other: {
    message: "{{count}} years",
    description: "Time description on User profile page",
  },
  month_one: {
    message: "{{count}} month",
    description: "Time description on User profile page",
  },
  month_other: {
    message: "{{count}} months",
    description: "Time description on User profile page",
  },
  years_and_one_month: {
    message: "{{yearsCount}} years, {{monthsCount}} month",
    description: "Time description on User profile page",
  },
  years_and_months: {
    message: "{{yearsCount}} years, {{monthsCount}} months",
    description: "Time description on User profile page",
  },
  hour: {
    message: "hour",
    description: "Time description on User profile page",
  },
  hours: {
    message: "hours",
    description: "Time description on User profile page",
  },
  profile_contact: {
    message: "Say hey",
    description: "Contact label on User profile page",
  },
  profile_pto: {
    message: "Out of office",
    description: "Out of office label on User profile page",
  },
  location: {
    message: "Location",
    description: "Location label on User profile page",
  },
  detailed_location: {
    message: "Detailed location",
    description: "Detailed location label on Edit User profile page",
  },
  tenure: {
    message: "Tenure",
    description: "Tenure label on User profile page",
  },
  tenure_short: {
    message: "{{formattedTenure}} tenure",
    description: "Tenure label for User profile card on SERP",
  },
  first_started: {
    message: "First started",
    description: "Tenure description on User profile page",
  },
  started: {
    message: "Started",
    description: "Tenure description on User profile page",
  },
  tenure_percentile: {
    message: "Longer than {{percentile}}% of people",
    description: "Tenure description on User profile page",
  },
  birthday: {
    message: "Birthday",
    description: "Birthday label on User profile page",
  },
  currently_on_leave: {
    message: "On leave",
    description: "Currently on leave label on User profile page",
  },
  primary_contact: {
    message: "Primary contact",
    description: "Primary Contact label on Team profile page",
  },
  teams_title: {
    message: "Teams",
    description: "Teams label on Team profile page",
  },
  members_title: {
    message: "Members",
    description: "Team members label on Team profile page",
  },
  no_members: {
    message: "No members on this team yet.",
    description: "No team members description on Team profile page",
  },
  organization_title: {
    message: "Organization",
    description: "Organization label in Org Chart on profile page",
  },
  add_apps_modal_title: {
    message: "Add apps, find anything",
    description: "Title for the add apps modal",
  },
  add_apps_modal_description: {
    message:
      "The more apps you add, the better your search results. Group related content from different apps to share it, too!",
    description: "Text for the add apps modal",
  },
  add_apps_modal_skip: {
    message: "Skip",
    description: "Text for button to skip the add apps modal",
  },
  add_apps_tooltip_title: {
    message: "Add apps anytime",
    description: "Title for the post-add apps tooltip",
  },
  add_apps_tooltip_subtitle: {
    message: "Get better search results.",
    description: "Subtitle for the post-add apps tooltip",
  },
  add_apps_upsell_banner_title: {
    message: "Want better answers?",
    description:
      "Title for the add apps upsell banner in chat window enticing users to click the add apps button",
  },
  add_apps_upsell_banner_subtitle: {
    message: "Add apps to pull answers from more content in Dash.",
    description:
      "Subtitle for the add apps upsell banner in chat window enticing users to click the add apps button",
  },
  join_team_cta: {
    message: "Accept invite",
    description: "Text for CTA that redirects to the team join page",
  },
  extension_success_page_banner: {
    message: "Extension added",
    description: "Success message on banner after adding the extension",
  },
  extension_success_side_panel_content_title: {
    message: "Open Dash on any page",
    description: "Title for content about the extension side panel",
  },
  extension_success_side_panel_content_description: {
    message: "Summarize or draft something based on the page.",
    description: "Description for content about the extension side panel",
  },
  extension_success_side_panel_content_cta: {
    message: "Show me",
    description: "Success message on banner after adding the extension",
  },
  extension_success_side_panel_img_alt: {
    message: "Browser side panel",
    description: "Alt text for side panel image",
  },
  extension_success_ask_content_title: {
    message: "Ask only once",
    description: "Title for content about the Ask feature",
  },
  extension_success_ask_content_description: {
    message:
      "Ask Dash to do something, then save that prompt to use again and again.",
    description: "Description for content about the Ask feature",
  },
  extension_success_ask_img_alt: {
    message: "Predefined prompts",
    description: "Alt text for predefined prompts in the Ask feature",
  },
  extension_success_stacks_content_title: {
    message: "Pull everything together",
    description: "Title for content about the Stacks feature",
  },
  extension_success_stacks_content_description: {
    message:
      "Create a stack of related items: files, links, fun team event photos. Share it if you want, too.",
    description: "Description for content about the Stacks feature",
  },
  extension_success_stacks_img_alt: {
    message: "Stacks",
    description: "Alt text for Dash Stacks feature image",
  },
  extension_success_new_tab_content_title: {
    message: "Transform your new tab",
    description: "Title for content about the extension new tab feature",
  },
  extension_success_new_tab_content_description: {
    message:
      "Find anything, open recent files, and join calendar events from your browser.",
    description: "Description for content about the extension new tab feature",
  },
  extension_success_new_tab_img_alt: {
    message: "New tab experience",
    description: "Alt text for the extension new tab experience",
  },
  extension_success_search_content_title: {
    message: "Search your history",
    description:
      "Title for content about using the Search feature for browser history",
  },
  extension_success_search_content_description: {
    message: "157 tabs open? Search your own history to find what you need.",
    description:
      "Description for content about using the Search feature for browser history",
  },
  extension_success_search_img_alt: {
    message: "Search your browser history",
    description: "Alt text for searching your browser history",
  },
  setup_module_title: {
    message: "Be a Dash Pro",
    description: "Title for the setup module on the home page",
  },
  setup_module_hide: {
    message: "Hide from home",
    description: "Text for button to hide a module from the home page",
  },
  setup_module_hide_get_started: {
    message:
      "Video hidden. Get more tutorials anytime from the <buttonLink>Help Center</buttonLink>",
    description:
      "Snackbar message when hiding the video module from the home page",
  },
  setup_module_hide_apps: {
    message:
      "App suggestions hidden. Add more anytime from the <buttonLink>Apps page</buttonLink>",
    description:
      "Snackbar message when hiding the apps module from the home page",
  },
  setup_module_hide_platforms: {
    message:
      "Surface suggestions hidden. Download them anytime from the <buttonLink>Navigation</buttonLink>",
    description:
      "Snackbar message when hiding the platforms module from the home page",
  },
  setup_module_extension_call_to_action: {
    message: "Add browser extension",
    description: "Call to action button text to install the browser extension",
  },
  setup_module_hide_customize: {
    message:
      "Section hidden. Manage your team anytime from the <buttonLink>Admin Console</buttonLink>",
    description:
      "Snackbar message when hiding the customize module from the home page",
  },
  setup_module_get_started_title: {
    message: "Meet Dash in 1 minute",
    description: "Title for the Get Started item on the setup module",
  },
  setup_module_get_started_content_title: {
    message: "Welcome to Dash",
    description: "Title for the Get Started video content on the setup module",
  },
  setup_module_get_started_content_description: {
    message:
      "Use AI to find what you need, ask questions, or write something great.",
    description:
      "Title for the Get Started video description on the setup module",
  },
  setup_module_get_started_content_alt: {
    message: "Get started video thumbnail",
    description: "Alt text for the Get Started video on the setup module",
  },
  setup_module_add_apps_title: {
    message: "Add apps to search",
    description: "Title for the Add Apps item on the setup module",
  },
  setup_module_all_apps_added: {
    message: "Nice! All available apps are added",
    description:
      "Title for the Add Apps item on the setup module when all apps are added",
  },
  setup_module_platforms_title: {
    message: "Use Dash anywhere",
    description:
      "Title for the Download Other Surfaces item on the setup module",
  },
  setup_module_customize_title: {
    message: "Set up your team",
    description: "Title for the Customize your team item on the setup module",
  },
  setup_module_menu_title: {
    message: "Setup module menu",
    description: "ARIA label for the setup module menu",
  },
  setup_module_app_added: {
    message:
      "{{appName}} added. Manage it anytime from the <appsLink>Apps page</appsLink>",
    description:
      "Snackbar message shown when a connector app is successfully added",
  },
  customize: {
    message: "Customize",
    description: "Label for the customize button",
  },
  custom_stack_theme: {
    message: "Custom stack theme",
    description: "Label for the custom stack color theme",
  },
  custom_stack_color: {
    message: "Custom color",
    description: "Label for the custom stack color",
  },
  hex: {
    message: "Hex:",
    description: "Label referring to the hex color selected",
  },
  invalid_hex_color: {
    message: "Not a valid HEX color",
    description: "Snackbar message when the user enters an invalid hex color",
  },
  failed_to_update_color: {
    message: "Failed to update stack color",
    description:
      "Snackbar message when there is an error while updating color for a stack",
  },
  failed_to_update_stack: {
    message: "Failed to update stack",
    description:
      "Snackbar message when there is an error while updating color for a stack",
  },
  no_permission_to_edit_stack: {
    message: "You don’t have permission to edit this stack",
    description:
      "Snackbar message when the user tries to edit a stack without permission",
  },
  thread_in_channel_prefix: {
    message: "Thread in ",
    description: "Label for a thread in a channel",
  },
  thread_in_channel: {
    message: "Thread in {{channelName}}",
    description: "Label for a thread in a channel",
  },
  dm_channel_one_person: {
    message: "You and {{person}}",
    description: "Label for a direct message channel with one person",
  },
  dm_channel_two_people: {
    message: "{{person1}} and {{person2}}",
    description: "Label for a direct message channel with two people",
  },
  dm_channel_three_people: {
    message: "{{person1}}, {{person2}} and {{person3}}",
    description: "Label for a direct message channel with three people",
  },
  dm_channel_others: {
    message: "{{count}} others",
    description:
      "Label for a direct message channel with more than three people",
  },
  dm_channel_four_or_more_people: {
    message: "{{person1}}, {{person2}}, {{count}} others",
    description: "Label for a direct message channel with four people",
  },
  view_profile: {
    message: "View profile",
    description: "Button text to view User/Team profile page",
  },
  copied_to_clipboard: {
    message: "Copied to clipboard!",
    description:
      "Snackbar message when user copies to clipboard on User profile page",
  },
  user_profile_subtitle_static_on: {
    message: "on",
    description: "Static text for user profile subtitle string on",
  },
  user_profile_contractor_label: {
    message: "Contractor",
    description: "Label for contractor on User profile page",
  },
  user_profile_button_message_string: {
    message: "Message",
    description: "Button text to message a user",
  },
  user_profile_button_schedule_string: {
    message: "Schedule",
    description: "Button text to call a user",
  },
  omnibox_section_find: {
    message: "Find",
    description: "Omnibox section id for find",
  },
  omnibox_section_recommended: {
    message: "Recommended",
    description: "Omnibox section id for recommended",
  },
  omnibox_section_recent: {
    message: "Recent",
    description: "Omnibox section id for recent",
  },
  omnibox_section_ask_dash: {
    message: "Ask Dash",
    description: "Omnibox section id for ask dash",
  },
  omnibox_section_ask: {
    message: "Ask",
    description: "Omnibox section id for ask",
  },
  omnibox_section_organize: {
    message: "Organize",
    description: "Omnibox section id for organize",
  },
  omnibox_section_create: {
    message: "Create",
    description: "Omnibox section id for create",
  },
  omnibox_section_suggested: {
    message: "Suggested",
    description: "Omnibox section id for suggested",
  },
  omnibox_section_draft: {
    message: "Draft",
    description: "Omnibox section id for draft",
  },
  omnibox_cta_people_filter: {
    message: "Filter by people",
    description: "Omnibox CTA for people filter",
  },
  omnibox_cta_create: {
    message: "Create",
    description: "Omnibox CTA for create",
  },
  omnibox_section_draft_from_template: {
    message: "Draft from template",
    description: "Omnibox section id for draft from template",
  },
  omnibox_section_draft_from_tone: {
    message: "Draft from tone",
    description: "Omnibox section id for draft from tone",
  },
  omnibox_section_draft_from_source: {
    message: "Draft from source",
    description: "Omnibox section id for draft from source",
  },
  omnibox_subtitle_ask_dash: {
    message: "Ask Dash",
    description: "Omnibox subtitle for ask dash",
  },
  omnibox_subtitle_draft_dash: {
    message: "Draft with Dash",
    description: "Omnibox subtitle for draft with dash",
  },
  omnibox_title_my_profile: {
    message: "My profile",
    description: "Omnibox title for a link to the user's profile",
  },
  omnibox_title_organize_dash: {
    message: "Create a new stack - {{name}}",
    description: "Call to action to create a stack with the current query name",
  },
  omnibox_title_organize_dash_null_state: {
    message: "Create a new stack",
    description: "Call to action to create a stack with no query name",
  },
  omnibox_people_filter_metadata: {
    message: "Filter by people",
    description: "Metadata text for people filter",
  },
  query_suggestions_summarize_file: {
    message: "Summarize a file",
    description: "Query suggestion for summarizing a file",
  },
  query_suggestions_brainstorm_ideas: {
    message: "Brainstorm an idea",
    description: "Query suggestion for summarizing meeting notes",
  },
  query_suggestions_analyze_report: {
    message: "Analyze a report",
    description: "Query suggestion for extracting insights from a report",
  },
  query_suggestions_find_related_docs: {
    message: "Find related documents",
    description: "Query suggestion for finding related documents",
  },
  query_suggestions_create_action_items: {
    message: "Create action items",
    description: "Query suggestion for extracting action items from a document",
  },
  query_suggestions_summarize_key_points: {
    message: "Summarize key points",
    description: "Query suggestion for summarizing key points from a document",
  },
  query_suggestions_brainstorm_questions: {
    message: "Brainstorm questions",
    description: "Query suggestion for brainstorming questions",
  },
  query_suggestions_analyze_insights: {
    message: "Analyze insights",
    description: "Query suggestion for extracting insights from a document",
  },
  omnibox_search_prompt_gif_alt: {
    message: "GIF showing how to search Dash from the address bar",
    description: "Alt text for the omnibox search prompt GIF",
  },
  activity: {
    message: "Activity",
    description: "Header text for showing activity feed",
  },
  today_at_time: {
    message: "Today at {{time}}",
    description: "Label for the time of day for today, ex. Today at 4:30 PM",
  },
  date_at_time: {
    message: "{{date}} at {{time}}",
    description:
      "Label for the time of day for a specific date, ex. Mar 26 at 4:30 PM",
  },
  sender_unknown: {
    message: "Unknown sender",
    description: "Label for unknown sender",
  },
  omnibox_mode_find_anything: {
    message: "Find anything...",
    description: "Placeholder text for omnibox find anything mode",
  },
  omnibox_mode_find: {
    message: "Find...",
    description: "Placeholder text for omnibox find mode",
  },
  omnibox_mode_ask: {
    message: "Ask...",
    description: "Placeholder text for omnibox ask mode",
  },
  omnibox_mode_write: {
    message: "Write...",
    description: "Placeholder text for omnibox write mode",
  },
  omnibox_mode_organize: {
    message: "Organize...",
    description: "Placeholder text for omnibox organize mode",
  },
  omnibox_chip_find: {
    message: "Find",
    description: "Chip text for Find",
  },
  omnibox_chip_ask: {
    message: "Ask",
    description: "Chip text for Ask",
  },
  omnibox_chip_write: {
    message: "Write",
    description: "Chip text for Write",
  },
  omnibox_chip_organize: {
    message: "Organize",
    description: "Chip text for Organize",
  },
  model_picker_default_model_label: {
    message: "Default",
    description: "Label for the default model in the model picker",
  },
  model_picker_button_label: {
    message: "Model",
    description: "Default label for the model picker when nothing is selected",
  },
  model_picker_source_dropbox: {
    message: "Dropbox",
    description: "Label for Dropbox model source in the model picker",
  },
  model_picker_source_openai: {
    message: "OpenAI",
    description: "Label for OpenAI model source in the model picker",
  },
  model_picker_source_groq: {
    message: "Groq",
    description: "Label for Groq model source in the model picker",
  },
  model_picker_source_aws: {
    message: "AWS",
    description: "Label for AWS model source in the model picker",
  },
  model_picker_source_google_cloud: {
    message: "Google Cloud",
    description: "Label for Google Cloud model source in the model picker",
  },
  model_picker_source_microsoft_azure: {
    message: "Microsoft Azure",
    description: "Label for Microsoft Azure model source in the model picker",
  },
  model_picker_source_default: {
    message: "Other",
    description: "Label for other/unknown model source in the model picker",
  },
  context_picker_dash_search_label: {
    message: "All content",
    description:
      "Label for the Dash search context option in the context picker",
  },
  context_picker_no_search_label: {
    message: "No search",
    description: "Label for the no search context option in the context picker",
  },
  context_picker_web_search_label: {
    message: "Web content",
    description:
      "Label for the web search context option in the context picker",
  },
  context_picker_web_search_description: {
    message:
      "Dash will search the web using <model>gpt-4o-search-preview</model>",
    description:
      "Description for the web search context option in the context picker, with a link to OpenAI docs",
  },
  context_picker_dash_search_description: {
    message: "Dash will search your company’s knowledge to answer questions.",
    description:
      "Description for the Dash search context option in the context picker",
  },
  context_picker_no_search_description: {
    message: "Dash will only use the sources in this chat to answer questions.",
    description:
      "Description for the no search context option in the context picker",
  },
  context_picker_browser_tabs_picker_label_one: {
    message: "{{count}} tab",
    description:
      "Label for context picker button indicating number of tabs already selected",
  },
  context_picker_browser_tabs_picker_label_few: {
    message: "{{count}} tabs",
    description:
      "Label for context picker button indicating number of tabs already selected",
  },
  context_picker_browser_tabs_picker_label_many: {
    message: "{{count}} tabs",
    description:
      "Label for context picker button indicating number of tabs already selected",
  },
  context_picker_browser_tabs_picker_label_other: {
    message: "{{count}} tabs",
    description:
      "Label for context picker button indicating number of tabs already selected",
  },
  context_picker_browser_tabs_recent_tabs_label: {
    message: "Recent tabs",
    description: "Label for the recent tabs segment in the context picker",
  },
  context_picker_browser_tabs_all_tabs_label: {
    message: "All tabs",
    description: "Label for the all tabs segment in the context picker",
  },
  context_picker_browser_tabs_window_label: {
    message: "Window {{index}}",
    description: "Label for the window segment in the context picker",
  },
  context_picker_browser_tabs_search_placeholder: {
    message: "Search tabs",
    description: "Placeholder text for the browser tabs search input",
  },
  model_picker_experimental_models_label: {
    message: "Experimental Models",
    description:
      "Label for the experimental models segment in the model picker",
  },
  model_picker_more_models_label_other: {
    message: "{{count}} more models",
    description: "Label for the more models segment in the model picker",
  },
  model_picker_more_models_label_one: {
    message: "{{count}} more model",
    description: "Label for the more models segment in the model picker",
  },
  filter_bar_channel_dropdown_label: {
    message: "Channel Filters Dropdown",
    description: "Aria label for Channels filter dropdown",
  },
  channel_filter_chip_placeholder: {
    message: "Channels",
    description: "Placeholder for the channel filter chip",
  },
  channel_search_no_results: {
    message: "No results found",
    description: "Text shown when there are no results for channel search",
  },
  channel_search_input_placeholder: {
    message: "Search for channels",
    description: "Placeholder text for the channel search input field",
  },
  channel_search_empty: {
    message: "Begin typing to search",
    description: "Placeholder text for the channel search input field",
  },
  enable_stack_notifications: {
    message: "Turn on notifications",
    description:
      "Text on a button that, when clicked, will enable notifications for a Stack for the current user",
  },
  disable_stack_notifications: {
    message: "Turn off notifications",
    description:
      "Text on a button that, when clicked, will disable notifications for a Stack for the current user",
  },
  enable_stack_notifications_success: {
    message: "Notifications turned on.",
    description:
      "Message shown in a snackbar when a user successfully enables notifications for a Stack",
  },
  disable_stack_notifications_success: {
    message: "Notifications turned off.",
    description:
      "Message shown in a snackbar when a user successfully disables notifications for a Stack",
  },
  enable_stack_notifications_failure: {
    message: "Couldn‘t turn on notifications. Try again.",
    description:
      "Error shown in a snackbar when a user failed to enable notifications for a Stack",
  },
  disable_stack_notifications_failure: {
    message: "Couldn‘t turn off notifications. Try again.",
    description:
      "Error shown in a snackbar when a user failed to disable notifications for a Stack",
  },
  back_to_stack: {
    message: "Back to stack",
    description:
      "Text for a button that returns the user to the Stack Detail page",
  },
  back_to_search: {
    message: "Back to search",
    description: "Text for a button that returns the user to the search page",
  },
  draft_with_document_prefix: {
    message: "Draft a document from:",
    description: "Prefix for a draft with a document cta from omnibox",
  },
  draft_from_template_prefix: {
    message: "Draft a:",
    description: "Prefix for a draft with a template cta from omnibox",
  },
  people: {
    message: "People",
    description: "Label for people",
  },
  user_profile_highlights_string: {
    message: "Highlights",
    description:
      "Label for the highlights section on the Edit User Profile page",
  },
  user_profile_about_me_string: {
    message: "About me",
    description: "Label for the about me section on the User Profile page",
  },
  user_profile_about_me_placeholder: {
    message: "<tag>Edit your profile</tag> and share more about yourself...",
    description:
      "Placeholder for the about me section on the User Profile page",
  },
  user_profile_reporting_line: {
    message: "Reporting line",
    description: "Label for the reporting line chip on the User Profile page",
  },
  user_profile_total_reports_one: {
    message: "{{count}} total report",
    description: "Label for the reports tooltip on the User Profile page",
  },
  user_profile_total_reports_other: {
    message: "{{count}} total reports",
    description: "Label for the reports tooltip on the User Profile page",
  },
  user_profile_direct_reports_one: {
    message: "{{count}} direct report",
    description: "Label for the reports tooltip on the User Profile page",
  },
  user_profile_direct_reports_other: {
    message: "{{count}} direct reports",
    description: "Label for the reports tooltip on the User Profile page",
  },
  user_profile_peer_title: {
    message: "Peers",
    description: "Label for the peer title on the User Profile page",
  },
  user_profile_direct_reports_title: {
    message: "Direct reports",
    description: "Label for the direct reports title on the User Profile paeg",
  },
  user_profile_reports_title: {
    message: "Reports",
    description: "Label for the reports title on the User Profile page",
  },
  people_index_new_arrivals_title: {
    message: "New arrivals",
    description: "Label for the new arrivals section on the People Index page",
  },
  people_index_work_anniversaries_title: {
    message: "Anniversaries",
    description: "Label for the anniversaries section on the People Index page",
  },
  people_index_birthdays_title: {
    message: "Birthdays",
    description: "Label for the birthdays section on the People Index page",
  },
  people_index_new_arrivals_empty_subtitle: {
    message: "No new arrivals (yet)",
    description:
      "Subtitle for the new arrivals section on the People Index page when there are no new arrivals",
  },
  people_index_new_arrivals_empty_description: {
    message: "Keep an eye out—new faces might join soon.",
    description:
      "Description for the new arrivals section on the People Index page when there are no new arrivals",
  },
  people_index_work_anniversaries_empty_subtitle: {
    message: "Nothing to celebrate right now",
    description:
      "Subtitle for the anniversaries section on the People Index page when there are no work anniversaries",
  },
  people_index_work_anniversaries_empty_description: {
    message: "Check back later for team member anniversaries.",
    description:
      "Description for the anniversaries section on the People Index page when there are no work anniversaries",
  },
  people_index_birthdays_empty_subtitle: {
    message: "No birthdays this week",
    description:
      "Subtitle for the birthdays section on the People Index page when there are no birthdays",
  },
  people_index_birthdays_empty_description: {
    message: "No birthdays right now—but they’re coming",
    description:
      "Description for the birthdays section on the People Index page when there are no birthdays",
  },
  user_profile_list_show_more: {
    message: "Show more",
    description:
      "Button text to show more items in a list of User Profile Cards",
  },
  user_profile_list_show_fewer: {
    message: "Show fewer",
    description:
      "Button text to show fewer items in a list of User Profile Cards",
  },
  invite_to_stack: {
    message: "Invite to stack...",
    description: "Placeholder for Stack sharing typeahead input",
  },
  stack_sources_one: {
    message: "{{count}} source",
    description: "The number of summarizable sources included in a Stack chat",
  },
  stack_sources_few: {
    message: "{{count}} sources",
    description: "The number of summarizable sources included in a Stack chat",
  },
  stack_sources_many: {
    message: "{{count}} sources",
    description: "The number of summarizable sources included in a Stack chat",
  },
  stack_sources_other: {
    message: "{{count}} sources",
    description: "The number of summarizable sources included in a Stack chat",
  },
  unavailable_stack_sources_one: {
    message: "{{count}} unavailable source",
    description: "The number of unsummarizable sources skipped in a Stack chat",
  },
  unavailable_stack_sources_few: {
    message: "{{count}} unavailable sources",
    description: "The number of unsummarizable sources skipped in a Stack chat",
  },
  unavailable_stack_sources_many: {
    message: "{{count}} unavailable sources",
    description: "The number of unsummarizable sources skipped in a Stack chat",
  },
  unavailable_stack_sources_other: {
    message: "{{count}} unavailable sources",
    description: "The number of unsummarizable sources skipped in a Stack chat",
  },
  newly_available_stack_sources_one: {
    message: "{{count}} new source",
    description:
      "The number of newly summarizable sources not included in a Stack chat",
  },
  newly_available_stack_sources_few: {
    message: "{{count}} new sources",
    description:
      "The number of newly summarizable sources not included in a Stack chat",
  },
  newly_available_stack_sources_many: {
    message: "{{count}} new sources",
    description:
      "The number of newly summarizable sources not included in a Stack chat",
  },
  newly_available_stack_sources_other: {
    message: "{{count}} new sources",
    description:
      "The number of newly summarizable sources not included in a Stack chat",
  },
  stack_unavailable_sources_disclaimer: {
    message: "These either can’t be summarized or aren’t ready for chat",
    description: "Disclaimer for unavailable sources in a Stack chat",
  },
  stack_newly_available_sources_tooltip: {
    message: "Start a new chat to use all sources",
    description:
      "Tooltip shown next to newly available sources not yet included in a Stack Chat",
  },
  stack_more_sources: {
    message: "{{count}} more sources",
    description:
      "Shown on a card informing the user there are more sources on a Stack Chat to view",
  },
  summarize_this_document: {
    message: "Summarize this",
    description: "Chat message to summarize a document",
  },
  back_to_home: {
    message: "Back to home",
    description: "Text for a button that returns the user to the home page",
  },
  new_chip: {
    message: "New",
    description: "Label used on a chip to indicate it is new",
  },
  summarize_these_documents: {
    message: "Summarize these",
    description: "Chat message to summarize a collection of documents",
  },
  reload_page_button: {
    message: "Reload page",
    description: "Button to reload the current view",
  },
  log_in_again_button: {
    message: "Log in again",
    description: "Button to log user out and have them log in again",
  },
  stack_chat_new_sources_available_one: {
    message: "{{count}} new source available.",
    description:
      "Message alerting the user that one or more new sources are available in a Stack",
  },
  stack_chat_new_sources_available_few: {
    message: "{{count}} new sources available.",
    description:
      "Message alerting the user that one or more new sources are available in a Stack",
  },
  stack_chat_new_sources_available_many: {
    message: "{{count}} new sources available.",
    description:
      "Message alerting the user that one or more new sources are available in a Stack",
  },
  stack_chat_new_sources_available_other: {
    message: "{{count}} new sources available.",
    description:
      "Message alerting the user that one or more new sources are available in a Stack",
  },
  stack_chat_start_new_chat_prompt: {
    message: "Refresh your last answer?",
    description:
      "Message shown to the user along side a new sources message encouraging the user to refresh their chat",
  },
  stack_chat_start_new_chat: {
    message: "Refresh",
    description:
      "Shown on a button that, when clicked, will create/refresh an assistant chat",
  },
  summarize_this_stack: {
    message: "Summarize this stack",
    description: "Chat message to summarize a stack",
  },
  summarize_this_stack_tooltip_one: {
    message: "Based on {{count}} item in this stack",
    description: "Tooltip on a button to summarize a stack",
  },
  summarize_this_stack_tooltip_few: {
    message: "Based on {{count}} items in this stack",
    description: "Tooltip on a button to summarize a stack",
  },
  summarize_this_stack_tooltip_many: {
    message: "Based on {{count}} items in this stack",
    description: "Tooltip on a button to summarize a stack",
  },
  summarize_this_stack_tooltip_other: {
    message: "Based on {{count}} items in this stack",
    description: "Tooltip on a button to summarize a stack",
  },
  stack_chat_assistant_prompt: {
    message: "What would you like to know?",
    description:
      "Message from the assistant to a user when visiting an empty Stack Chat",
  },
  num_channels_one: {
    message: "{{count}} channel",
    description: "The number of channel filters selected",
  },
  num_channels_few: {
    message: "{{count}} channels",
    description: "The number of channel filters selected",
  },
  num_channels_many: {
    message: "{{count}} channels",
    description: "The number of channel filters selected",
  },
  num_channels_other: {
    message: "{{count}} channels",
    description: "The number of channel filters selected",
  },
  omnibox_error: {
    message: "Oops! There was an error.",
    description: "Error message when omnibox fails to load",
  },
  omnibox_ask_query_tooltip_title: {
    message: "Have a question?",
    description: "Title for the omnibox ask query tooltip",
  },
  omnibox_ask_query_tooltip_text: {
    message: "Ask anything to start a chat from here.",
    description: "Text for the omnibox ask query tooltip",
  },
  omnibox_ask_query_tooltip_button_text: {
    message: "Got it",
    description: "Text for the omnibox ask query tooltip button",
  },
  relevant_channels: {
    message: "Relevant channels",
    description:
      "Label for recommended channels in the channel filter dropdown",
  },
  summarize_documents_one: {
    message: "Summarize this",
    description: "Chat message to summarize a single document",
  },
  summarize_documents_few: {
    message: "Summarize these",
    description: "Chat message to summarize multiple documents",
  },
  summarize_documents_many: {
    message: "Summarize these",
    description: "Chat message to summarize multiple documents",
  },
  summarize_documents_other: {
    message: "Summarize these",
    description: "Chat message to summarize multiple documents",
  },
  create_stack_from_search_results_creation_toast: {
    message: "Saving results to a stack...",
    description:
      "Toast message for saving results to a stack from search results",
  },
  create_stack_from_search_results_stack_description: {
    message:
      "A stack of the top {{resultsCount}} search results for “{{query}}”, created on {{date}}.",
    description: "Description for a stack created from search results",
  },
  create_stack_from_search_results_created_toast: {
    message: "You’ll get updates about items in this stack",
    description:
      "Toast message when stack has been created from search results",
  },
  create_stack_from_search_results_error_toast: {
    message: "Stack creation failed",
    description: "Label for stack creation failed action",
  },
  create_stack_from_search_results_create_label: {
    message: "Create stack",
    description: "Label for save results action",
  },
  create_stack_from_search_results_creating_label: {
    message: "Creating stack...",
    description: "Label for saving results action",
  },
  create_stack_from_search_results_open_stack_label: {
    message: "Open stack",
    description: "Label for open stack action",
  },
  create_stack_from_search_results_tooltip_title: {
    message: "Put results in one place",
    description:
      "Title for the tooltip shown when offering to save search results as a stack",
  },
  create_stack_from_search_results_tooltip_text: {
    message: "Gather the top {{count}} things you found.",
    description:
      "Body text for the tooltip shown when offering to save search results as a stack",
  },
  recents_filter_google_docs: {
    message: "Docs",
    description: "Filter pill for Google Docs",
  },
  recents_filter_google_sheets: {
    message: "Sheets",
    description: "Filter pill for Google Sheets",
  },
  recents_filter_google_slides: {
    message: "Slides",
    description: "Filter pill for Google Slides",
  },
  recents_filter_stacks: {
    message: "Stacks",
    description: "Filter pill for Stack",
  },
  recents_filter_dropbox_paper: {
    message: "Paper",
    description: "Filter pill for Dropbox Paper",
  },
  first_search_inline_cta: {
    message: "Press enter to try your first search",
    description: "Byline suggesting user interaction with search field",
  },
  failed_to_join_shared_stack: {
    message: "Failed to join shared stack.",
    description: "Snackbar text if a user cannot join a shared stack.",
  },
  retry: {
    message: "Retry",
    description: "Text of a button to allow users to retry.",
  },
  dropbox_dash_app_name: {
    message: "Dropbox <bold>Dash</bold>",
    description: "App name showned next to app icon.",
  },
  privacy_permissions_title: {
    message: "Privacy Permissions",
    description: "Title on privacy permission consent dialog.",
  },
  privacy_permissions_description: {
    message:
      "The Dropbox Dash extension requires the collection of personal and technical data to use the extension. Unfortunately, the extension won’t work without this data.",
    description: "Description on privacy permission consent dialog.",
  },
  privacy_permissions_personal_data: {
    message:
      "Allow collection of personal data (including browser history, page contents, and personal identifiers), which we collect to allow you to use the extension.",
    description:
      "Message describing personal data collection on privacy permission consent dialog.",
  },
  privacy_permissions_technical_data: {
    message:
      "Allow collection of technical data (including browser and operating system information), which we collect to allow you to use the extension.",
    description:
      "Message describing technical data collection on privacy permission consent dialog.",
  },
  privacy_permissions_interaction_data: {
    message:
      "Allow collection of interaction data (including event and crash data and device logs), which we collect for usage metrics, analytics, and debugging.",
    description:
      "Message describing user interaction data collection on privacy permission consent dialog.",
  },
  privacy_permissions_footer: {
    message:
      "More details about how we collect your personal data when you use the Dropbox Dash extension can be found in our <policyLink>Privacy Policy</policyLink>. By clicking <bold>Accept</bold>, you consent to the collection of data for these purposes.",
    description:
      "Footer paragraph for a modal dialog informing user of data collection privacy permissions. This paragraph includes a link to a more detailed privacy policy document. This paragraph references a button that the user can click to accept the privacy permissions.",
  },
  safari_onboarding_title: {
    message: "Almost there! Click the browser extension icon to enable it.",
    description: "Title on safari browser onboarding education page.",
  },
  safari_onboarding_education: {
    message:
      "Dash gives suggestions based on your activity. For the best experience, be sure to click <bold>Always Allow on Every Website…</bold> when asked. After enabling, click the icon again to set it up.",
    description:
      "Explain how the user can get started on using the extension in Safari.",
  },
  safari_onboarding_instruction: {
    message:
      "Otherwise, click on the icon to provide the necessary permissions consent, or sign in to your Dropbox account.",
    description:
      "Instruction on what to do next on safari browser onboarding education page.",
  },
  accept: {
    message: "Accept",
    description:
      "Label for a button to accept data collection privacy permissions.",
  },
  alpha: {
    message: "Alpha",
    description:
      "Label for the alpha version which means the product might not be fully polished yet.",
  },
  rename: {
    message: "Rename",
    description: "Aria label for button to rename a file inside sidebar",
  },
  stack_item: {
    message: "Stack item",
    description: "Generic label for a stack item.",
  },
  welcome_header: {
    message: "Welcome to {{appName}}",
    description:
      "Header text on a 'welcome' page. appName is the untranslated name of the extension",
  },
  sign_in_with_dropbox: {
    message: "Sign in with Dropbox",
    description:
      "Button label to launch an authentication flow (using Dropbox account)",
  },
  sign_out_of_dash: {
    message: "Sign out of Dash",
    description: "Button label to sign out from the Dash product.",
  },
  auth_loading: {
    message: "Looking for Dropbox account...",
    description: "Text used in a loading spinner after a user has signed in",
  },
  help: {
    message: "Help",
    description: "Text informing the user what the help icon button is for.",
  },
  saved: {
    message: "Saved.",
    description: "Button text to indicate saving action has completed.",
  },
  saving: {
    message: "Saving",
    description: "Tooltip text indicating saving in progress.",
  },
  save_to: {
    message: "Save to",
    description: "Header text to choose a folder location.",
  },
  select: {
    message: "Select",
    description:
      "Button text inside folder picker to choose a folder users want to save to",
  },
  login_failed_title: {
    message: "Login failed",
    description: "Modal title to show when login failed with an error.",
  },
  get_help_or_send_feedback: {
    message: "Get help or send feedback",
    description: "Context menu item to send feedback.",
  },
  view_logs: {
    message: "View logs",
    description: "Context menu item to view logs.",
  },
  feedback: {
    message: "Feedback",
    description: "Text for a feedback button.",
  },
  dev_overrides_warning_title: {
    message: "Dev overrides active",
    description:
      "Title for the warning message shown when developer tools or feature flag overrides are active.",
  },
  dev_overrides_warning_description: {
    message:
      "Developer tools or feature flag overrides are currently active. This may impact application behavior.",
    description: "Warning message shown when developer overrides are active.",
  },
  no_contacts_found: {
    message: "No contacts found",
    description: "Label to indicate that no contacts were found.",
  },
  no_events_found: {
    message: "No events found",
    description: "Label to indicate that no calendar events were found.",
  },
  download_logs: {
    message: "Download logs",
    description: "Context menu item to download the logs.",
  },
  deleting_account: {
    message: "Deleting your account",
    description: "Context menu item to delete your account.",
  },
  login_failed_message: {
    message:
      "We were not able to log you in. Please check your credentials and your account, and then try again.",
    description: "Modal message to show when login failed with an error.",
  },
  onboarding_help: {
    message: "Onboarding help",
    description:
      "Action label to open a new tab which shows the onboarding help page.",
  },
  just_signed_in_tab_title: {
    message: "Get started with Dash",
    description:
      "Title for the tab of the Dash onboarding open Dash extension page.",
  },
  just_signed_in_title_chrome: {
    message: "Almost there! Just one more thing...",
    description:
      "Main heading title for the Dash onboarding page that educates user on the value of Dash after login.",
  },
  just_signed_in_title_edge: {
    message: "All set! Open a new tab to start exploring Dash",
    description:
      "Main heading title for the Dash onboarding page that educates user to keep the new tab experience.",
  },
  just_signed_in_title_safari_and_firefox: {
    message: "You’re all set to search apps from your browser history",
    description:
      "Main heading title for the Dash onboarding page that educates user on the value of Dash after login.",
  },
  just_signed_in_description_chrome: {
    message:
      "Make Dash your default tab for easy, one-click search across all your apps:",
    description:
      "Description text for the Dash onboarding page that educates user to keep new tab experience in Chrome.",
  },
  just_signed_in_description_chrome_1: {
    message: "Click <bold>+</bold> to open a new tab",
    description:
      "Description text for the Dash onboarding page that educates user on the post-login next step in Chrome.",
  },
  just_signed_in_description_chrome_2: {
    message: "Click <bold>Keep it</bold> in the pop-up that appears.",
    description:
      "Description text for the Dash onboarding page that educates user on the post-login next step in Chrome.",
  },
  just_signed_in_snackbar_message: {
    message: "Dash extension successfully installed",
    description:
      "Description text for the snackbar message shown on the sign in page.",
  },
  just_signed_in_description_edge: {
    message:
      "Dash is now your default tab in Microsoft Edge, so you can quickly search across all your apps in one place.",
    description:
      "Description text for the Dash onboarding page that educates user on the new tab experience in Edge.",
  },
  just_signed_in_description_safari: {
    message:
      "<bold>Quick tip:</bold> Dash is already pinned to Safari! You can start collecting links instantly by clicking the Dash icon in your toolbar and adding items directly from any webpage.",
    description:
      "Description text for the Dash onboarding page that educates user on the post-login next step in Safari.",
  },
  just_signed_in_description_firefox: {
    message:
      "<bold>Quick tip:</bold> Pin Dash to your Firefox toolbar for quick access and to save resources from anywhere in your browser.",
    description:
      "Description text for the Dash onboarding page that educates user on the post-login next step in Firefox.",
  },
  just_signed_in_description_firefox_1: {
    message: "Click the puzzle piece extension icon",
    description:
      "Description text for the Dash onboarding page that educates user on the post-login next step in Firefox.",
  },
  just_signed_in_description_firefox_2: {
    message: "Find ‘Dropbox Dash’ in the list",
    description:
      "Description text for the Dash onboarding page that educates user on the post-login next step in Firefox.",
  },
  just_signed_in_description_firefox_3: {
    message: "Click the settings icon next to ‘Dropbox Dash’",
    description:
      "Description text for the Dash onboarding page that educates user on the post-login next step in Firefox.",
  },
  just_signed_in_description_firefox_4: {
    message: "Select ‘Pin to Toolbar’",
    description:
      "Description text for the Dash onboarding page that educates user on the post-login next step in Firefox.",
  },
  just_signed_in_gif_alt_text: {
    message: "Image of clicking “Keep it” for the Dash extension tab takeover",
    description:
      'Alt text for a gif of clicking "Keep it" for the Dash extension tab takeover',
  },
  onboarding_spinner_text: {
    message: "Connecting...",
    description: "Text message for the onboarding spinner.",
  },
  save_to_dropbox: {
    message: "Save to Dropbox",
    description: "Title text for one of the primary tabs in the sidebar.",
  },
  settings: {
    message: "Customize",
    description: "The title for the settings page",
  },
  continue: {
    message: "Continue",
    description: "Button text for continuing.",
  },
  pending: {
    message: "Pending...",
    description: "Loading text while awaiting a file upload.",
  },
  new_stack: {
    message: "New stack",
    description: "Button text for a user to create a stack.",
  },
  browse: {
    message: "Browse...",
    description: "Text for an option to choose a folder to save the file to",
  },
  link_copied: {
    message: "Link copied!",
    description:
      "Text telling users that shared link for their file has been copied",
  },
  recently: {
    message: "Recently",
    description: "Header for stacks on the start page.",
  },
  okay: {
    message: "OKAY",
    description:
      "Button text to dismiss the prompt shortcut key reminder notification",
  },
  ok: {
    message: "OK",
    description: "Button confirmation text.",
  },
  apply: {
    message: "Apply",
    description: "Button text for applying a change.",
  },
  results: {
    message: "Results of “{{query}}”",
    description:
      "Title for retrieval tab within sidebar when search result is returned.",
  },
  clear: {
    message: "Clear",
    description: "Aria label for the clear button within search bar.",
  },
  link_added_by_dash: {
    message: "Suggested by Dash",
    description:
      "Text that will be added to calendar event description that can help user distinguish between link added by Dash vs others.",
  },
  tutorial_next: {
    message: "Next ({numerator}/{denominator})",
    description:
      "Next button during a multistep tutorial with which step it is.",
  },
  tutorial_next_simple: {
    message: "Next",
    description: "Next button during a multistep tutorial.",
  },
  library: {
    message: "Library",
    description: "A view of all the user's content within stacks",
  },
  ai_tool_library_title: {
    message: "AI Tool Library",
    description: "Title for the AI Tool Library modal",
  },
  ai_tool_library_templates_tab: {
    message: "Templates",
    description: "Tab label for templates in AI Tool Library",
  },
  ai_tool_library_tones_tab: {
    message: "Tones",
    description: "Tab label for tones in AI Tool Library",
  },
  ai_tool_library_tones_coming_soon: {
    message: "Coming soon",
    description: "Message for tones tab when feature is not yet available",
  },
  ai_tool_library_use_tone: {
    message: "Use tone",
    description: "Button text to apply a tone in AI Tool Library",
  },
  ai_tool_library_edit_tone: {
    message: "Edit tone",
    description: "Button text to edit the selected tone",
  },
  ai_tool_library_search_tones: {
    message: "Search all tones",
    description: "Placeholder text for search input in tones tab",
  },
  ai_tool_library_your_tones: {
    message: "Your tones",
    description: "Filter chip for user's own tones",
  },
  ai_tool_library_company_tones: {
    message: "Company tones",
    description: "Filter chip for company tones",
  },
  ai_tool_library_search_templates: {
    message: "Search all templates",
    description: "Placeholder text for search input in templates tab",
  },
  ai_tool_library_your_templates: {
    message: "Your templates",
    description: "Filter chip for user's own templates",
  },
  ai_tool_library_company_templates: {
    message: "Company templates",
    description: "Filter chip for company templates",
  },
  ai_tool_library_template_types: {
    message: "Template types",
    description: "Filter chip for template types",
  },
  ai_tool_library_create_template: {
    message: "Create template",
    description: "Button text to create a new template",
  },
  ai_tool_library_create_tone: {
    message: "Create tone",
    description: "Button text to create a new template",
  },
  ai_tool_library_by_author: {
    message: "By {{author}}",
    description: "Template author attribution",
  },
  ai_tool_library_by_company: {
    message: "From your company",
    description: "Template author attribution",
  },
  ai_tool_library_back_to_templates: {
    message: "Back to templates",
    description: "Button text to return to templates grid view",
  },
  ai_tool_library_created_by: {
    message: "Created by {{name}}",
    description: "Label showing who created a template",
  },
  ai_tool_library_created_at: {
    message: "{{date}}",
    description: "Label showing when a template was created",
  },
  ai_tool_library_use_template: {
    message: "Use template",
    description: "Button text to use the selected template",
  },
  ai_tool_library_by_you: {
    message: "By you",
    description: "Attribution for user's own items in cards",
  },
  ai_tool_library_from_your_company: {
    message: "From your company",
    description: "Attribution for company/team items in cards",
  },
  ai_tool_library_by_dash: {
    message: "By Dash",
    description: "Attribution for Dash default items in cards",
  },
  ai_tool_library_created_by_you: {
    message: "Created by you",
    description: "Attribution for user's own items in detail view",
  },
  ai_tool_library_created_by_team_member: {
    message: "Created by a team member",
    description: "Attribution for team items in detail view",
  },
  ai_tool_library_created_by_dash: {
    message: "Created by Dash",
    description: "Attribution for Dash default items in detail view",
  },
  ai_tool_library_edit_template: {
    message: "Edit template",
    description: "Button text to edit the selected template",
  },
  ai_tool_library_template_description: {
    message: "Template Description",
    description: "Label for template description section",
  },
  ai_tool_library_template_prompt: {
    message: "Template Prompt",
    description: "Label for template prompt section",
  },
  ai_tool_library_prompts: {
    message: "Prompts",
    description: "Label for the prompts filter option in AI Tool Library",
  },
  ai_tool_library_original: {
    message: "Original",
    description: "Label for the original tab in ToneDetailView",
  },
  ai_tool_library_with_tone_applied: {
    message: "With tone applied",
    description: "Label for the tone tab in ToneDetailView",
  },
  searchbar_placeholder: {
    message: "Search stacks",
    description: "The text for placeholder of the search bar in the nextGenExp",
  },
  text_snippet: {
    message: "Text Snippet",
    description: "Text for file type when the file is a snippet",
  },
  add_a_link: {
    message: "Add a link",
    description:
      "Text prompting the user to enter a URL to add to the current stack",
  },
  add_to_stack_again: {
    message: "Add to stack again",
    description: "Button for adding to a stack again",
  },
  suggested_page_snackbar_title: {
    message: "This page seems related to <stackLink>{{stackName}}.</stackLink>",
    description: "Button for opening a stack in a new tab",
  },
  suggested_items: {
    message: "Suggested items",
    description: "Header for a list of suggested items",
  },
  suggested_stack: {
    message: "Suggested stack",
    description: "Text for suggested stack",
  },
  suggested_stack_hidden: {
    message: "Suggested stack hidden.",
    description:
      "Text to notify users that a selected suggested stack is hidden.",
  },
  less: {
    message: "Less",
    description: "Text for showing less suggested stack content items.",
  },
  my_stack: {
    message: "My stack",
    description: "Text for My stack (default stack).",
  },
  share_stack: {
    message: "Share “{{stackName}}”",
    description: "A title of a sharing modal.",
  },
  public_permission: {
    message: "Public",
    description:
      "A permission level for a stack or a stack item that everybody with the link can access.",
  },
  public_permission_description: {
    message: "Anyone with the link can access",
    description:
      "Description for a public permission setting where anyone with this link can view it.",
  },
  private_permission: {
    message: "Restricted",
    description:
      "A permission level for a stack or a stack item that indicates that only invited members can access.",
  },
  private_permission_description: {
    message: "Only people with access can open the link",
    description:
      "Description for a restricted permission setting where only specific people can access this link",
  },
  company_permission_description: {
    message: "Anyone at {{teamName}} with the link can access",
    description:
      "Description for a company-level permission setting where anyone with this link at your company can view it.",
  },
  company_permission_description_no_team_name: {
    message: "Anyone at your org with the link can access",
    description:
      "Description for a company-level permission setting where anyone with this link at your company can view it. 'org' is short for organization and refers to the user's current team or company - this message is used when we don't know the user's team nam when we don't know the user's team name.",
  },
  stack_shared: {
    message: "Stack shared.",
    description: "Snackbar text after a stack is successfully shared.",
  },
  link_sharing: {
    message: "Link sharing",
    description:
      "Header text for section containing settings about link-based sharing.",
  },
  potential_disallowed_public_share_warning: {
    message:
      "External sharing is turned off, so you can’t share with anyone outside your team.",
    description:
      "Tooltip text for a warning highlight that displays when a user manually enters an email to share a stack with while public sharing is disabled.",
  },
  added_to: {
    message: "Added to ",
    description: "Text letting the user know what stack they just saved to",
  },
  go_to_stack: {
    message: "Go to stack",
    description:
      "Text for button that user can click to view the item they just saved inside of the stack it was saved to",
  },
  duplicate_tabs: {
    message: "Duplicates",
    description: "Title for card that shows duplicate tabs.",
  },
  num_more: {
    message: "+{{count}} more...",
    description:
      "Interactive button that can be clicked to show more of the contents that are currently collapsed/hidden.",
  },
  received_feedback: {
    message: "Thanks for your feedback! Your responses help Dash improve.",
    description: "Message shown to users once they provide feedback",
  },
  copy_answer: {
    message: "Copied answer to clipboard",
    description:
      "Message shown to users once they copy an answer to the clipboard",
  },
  tabs: {
    message: "Tabs",
    description: "Button in navigation panel that takes user to tabs page",
  },
  currently_open: {
    message: "Currently open",
    description: "Section that lists all the user's open tabs",
  },
  recently_closed: {
    message: "Recently closed",
    description: "Section that lists all the user's recently closed tabs",
  },
  sidebar_clipper_tutorial_tooltip_title: {
    message: "Add a tab to a stack",
    description: "Clipper tooltip tutorial title",
  },
  sidebar_clipper_tutorial_tooltip_text: {
    message: "Tabs are added to stacks so you can keep track of them.",
    description: "Clipper tooltip tutorial text",
  },
  suggestion_tutorial_title: {
    message: "Get suggestions",
    description: "Get suggestions tutorial title",
  },
  sidebar_get_suggestion_tutorial_text: {
    message: "Dash finds and groups related links into stacks.",
    description: "Suggested stacks tutorial text.",
  },
  add_a_new_stack_tutorial_title: {
    message: "Add a new stack",
    description: "Create a new stack and start adding tabs to it.",
  },
  add_a_new_stack_tutorial_text: {
    message: "Create a new stack and start adding tabs to it.",
    description: "Create a new stack text description.",
  },
  find_stack_tutorial_title: {
    message: "Get back to your stacks",
    description: "Find stacks tutorial title",
  },
  find_stack_tutorial_text: {
    message: "Go to all your stacks.",
    description: "Find stacks tutorial text.",
  },
  one_of: {
    message: "{{numerator}} of {{denominator}}",
    description:
      "Next button during a multistep tutorial with which step it is.",
  },
  search_results_matches: {
    message: "Matches",
    description: "Heading for search result matches.",
  },
  related_stacks: {
    message: "Related stacks",
    description: "Heading for list of stacks related to the current page.",
  },
  empty_search_results: {
    message: "No matches found",
    description: "Title message for no search results found.",
  },
  empty_search_results_help_text: {
    message: "Try different keywords.",
    description: "Help text for the case where no search results are returned.",
  },
  in_this_stack: {
    message: "In this stack",
    description:
      "Used to indicated if the current page is saved in a particular stack.",
  },
  plus_n_more: {
    message: "+ {{count}} more",
    description:
      "Label for items overflowing from a list, indicating how many items are hidden",
  },
  popup_unsupported_title: {
    message: "Switch to a different tab",
    description:
      "Title for popup message to use a different tab to use the extension",
  },
  popup_unsupported_text: {
    message:
      "Dash lets you save website links to your stacks. To use Dash, click on the extension icon when browsing any tab with a standard website URL (starting with “http”).",
    description:
      "Text for popup message to use a different tab to use the extension",
  },
  popup_login_title: {
    message: "Log in to get started",
    description:
      "Title for popup message to log in to continue to set up the extension",
  },
  popup_login_text: {
    message:
      "You’re (almost) ready to go. Just log in to the extension to start using Dash.",
    description:
      "Text for popup message to log into continue to set up the extension",
  },
  popup_consent_title: {
    message: "Configure privacy permissions",
    description:
      "Title for popup message to log in to continue to set up the extension",
  },
  popup_consent_text: {
    message:
      "Before you could use Dash, we would first need your privacy consent.",
    description:
      "Text for popup message to log into continue to set up the extension",
  },
  popup_loading_title: {
    message: "Loading...",
    description:
      "Title for popup message to show while showing a loading spinner",
  },
  popup_stacks_loading_title: {
    message: "Your stacks are loading...",
    description:
      "Title for popup message to show while showing a loading spinner",
  },
  assistant_loading_title: {
    message: "Dash is loading…",
    description:
      "Title for popup message to show while showing a loading spinner",
  },
  show: {
    message: "Show",
    description: "Button label for displaying a hidden section",
  },
  hide: {
    message: "Hide",
    description: "Button label for hiding an expanded section",
  },
  get_suggestions_start_page_tooltip_text: {
    message: "Review links related to your daily activity.",
    description: "The start page get suggestions widget text.",
  },
  calendar_start_page_tooltip_text: {
    message: "Prepare for meetings and open related links.",
    description: "The start page calendar widget text.",
  },
  calendar_start_page_tooltip_title: {
    message: "Join meetings",
    description: "The start page calendar widget title text.",
  },
  activity_start_page_tooltip_title: {
    message: "Browse your tabs",
    description: "The start page activity widget title text.",
  },
  activity_start_page_tooltip_text: {
    message: "Keep track of open and closed tabs.",
    description: "The start page activity widget title text.",
  },
  floating_startpage_tooltip_text: {
    message: "Get to daily meetings and browse your activity in a single tab.",
    description: "The start page floating intro tooltip.",
  },
  floating_startpage_button_take_tour: {
    message: "Take the tour",
    description:
      "The start page floating button text for starting the tutorial.",
  },
  add_website_to_dash: {
    message: "Add website to Dash",
    description:
      "Context menu option for saving the current webpage. 'Dash' is the app's name",
  },
  add_quick_action: {
    message: "Add quick action",
    description: "Button text for adding a new AI action to the action bar",
  },
  added_to_stack: {
    message: "Added to stack.",
    description:
      "Informational message indicating that a URL was saved to an organizational tool called a 'stack'",
  },
  create_stack_modal_name_placeholder: {
    message: "Name this stack",
    description: "Placeholder for the stack name input",
  },
  stack_open_emoji_picker: {
    message: "Open stack emoji picker",
    description: "Label for the button that open the stack emoji picker",
  },
  title: {
    message: "Title",
    description: "Placeholder text for a title field.",
  },
  create_stack_suggested_items_spinner_text: {
    message: "Finding related items...",
    description:
      "Placeholder text for loading spinner while fetching related content on create stack modal",
  },
  create_stack_suggested_items_empty_text: {
    message: "Add more content to get some more suggestions",
    description:
      "Placeholder text for suggested items section when no content available",
  },
  click_to_start_adding_items: {
    message: "Click to start adding items",
    description: "Prompt to user to choose first item to add to stack",
  },
  click_to_add_another_item: {
    message: "Click to add another item",
    description: "Prompt to user to choose another item to add to stack",
  },
  open_ai_key_modal_title: {
    message: "Open AI API Key",
    description: "Modal title to enter the Open AI key.",
  },
  press_enter_to_submit: {
    message: "Press enter to submit",
    description:
      "Placeholder text for an input box that accepts the enter key to submit it",
  },
  change: {
    message: "Change",
    description:
      "Button label that allows a user to change a where a link is saved.",
  },
  stack_from_user_text: {
    message: "New stack from <bold>{{name}}</bold>",
    description: "Text showing from whom the stack comes from",
  },
  stack_items_from_user_text_one: {
    message: "<bold>{{name}}</bold> added {{count}} item",
    description: "Text showing a user adding stack items to a stack",
  },
  stack_items_from_user_text_few: {
    message: "<bold>{{name}}</bold> added {{count}} items",
    description: "Text showing a user adding stack items to a stack",
  },
  stack_items_from_user_text_many: {
    message: "<bold>{{name}}</bold> added {{count}} items",
    description: "Text showing a user adding stack items to a stack",
  },
  stack_items_from_user_text_other: {
    message: "<bold>{{name}}</bold> added {{count}} items",
    description: "Text showing a user adding stack items to a stack",
  },
  stack_items_from_multiple_users_text_one: {
    message: "{<bold>{{peopleCount}} people</bold> added {{count}} item",
    description: "Text showing multiple users adding stack items to a stack",
  },
  stack_items_from_multiple_users_text_few: {
    message: "{<bold>{{peopleCount}} people</bold> added {{count}} items",
    description: "Text showing multiple users adding stack items to a stack",
  },
  stack_items_from_multiple_users_text_many: {
    message: "{<bold>{{peopleCount}} people</bold> added {{count}} items",
    description: "Text showing multiple users adding stack items to a stack",
  },
  stack_items_from_multiple_users_text_other: {
    message: "{<bold>{{peopleCount}} people</bold> added {{count}} items",
    description: "Text showing multiple users adding stack items to a stack",
  },
  add_to_dash: {
    message: "Add to <bold>Dash</bold>",
    description: "Title for a menu that lets a user add webpages to the app.",
  },
  failed_connector_snackbar: {
    message:
      "Unable to sync with {{connectorName}}. Reconnect for updated search results.",
    description: "Snackbar message for when a single connector fails to sync.",
  },
  failed_connectors_snackbar: {
    message:
      "Unable to sync with {{numFailedConnectors}} of your apps. Reconnect for updated search results.",
    description:
      "Snackbar message for when a multiple connectors fails to sync.",
  },
  created_new_stack: {
    message: "Created new stack <bold>{{stackName}}</bold>.",
    description: "Text showing that a new stack has been created",
  },
  empty_state_cta: {
    message: "Create stacks to organize your content",
    description:
      "Call to action suggesting the user create a 'stack' to organize content they want to save",
  },
  show_me_how: {
    message: "Show me how",
    description: "Button text for showing the user a tutorial",
  },
  add_to_stack_tutorial: {
    message: "Then, click the Dash icon to add the page you’re on to a stack",
    description: "Tutorial text for adding to a stack",
  },
  pinned_text: {
    message: "Pinned",
    description: "Sidebar label text for pinned stack section",
  },
  empty_pinned_stacks_cta: {
    message: "Pin stacks in the \u00b7\u00b7\u00b7 menu or drag them here",
    description:
      "Call to action message when user has no pinned stacks, displayed in the sidebar",
  },
  pin_stack_short: {
    message: "Pin",
    description: "Menu label for pinning a stack",
  },
  unpin_stack_short: {
    message: "Unpin",
    description: "Menu label for unpinning a stack",
  },
  pin_stack_snackbar_message: {
    message: "This stack has been pinned.",
    description: "Snackbar text after pinning a stack",
  },
  unpin_stack_snackbar_message: {
    message: "This stack has been unpinned.",
    description: "Snackbar text after unpinning a stack",
  },
  tutorial_prompt_eyebrow: {
    message: "from Dropbox Dash",
    description: "Eyebrow text for the tutorial prompts within the extension.",
  },
  pin_extension_message: {
    message:
      "Need a summary or an answer? Open Dash fast, then close it when you’re done.",
    description: "Explanation for how to pin the browser extension",
  },
  pin_extension_title: {
    message: "Pin to open Dash here",
    description:
      "Header on a popup for a webpage that guides the user to pin the browser extension to the toolbar",
  },
  omnibox_prompt_title: {
    message: "Type “ds” to search in Dash",
    description:
      'Header on a popup for a webpage that guides the user to type "ds" to search in Dash',
  },
  omnibox_prompt_message: {
    message:
      "For a shortcut to Dash, type “ds” and your keywords in the search bar.",
    description: 'Explanation for how to type "ds" to search in Dash',
  },
  encourage_first_action_message: {
    message:
      "Open Dash next to anything. Summarize, write something, or ask a question.",
    description: "Tutorial message that explains what you can do with Dash.",
  },
  encourage_first_action_title: {
    message: "Dash can help, right here",
    description: "Tutorial title that explains what you can do with Dash.",
  },
  encourage_first_action_button: {
    message: "Open here",
    description: "Button text for encouraging a user to try Dash.",
  },
  create_stack_from_tabs_title: {
    message: "Create a stack",
    description: "Header text to encourage a user to share tabs",
  },
  create_stack_from_tabs_subtitle: {
    message: "Create a shareable stack from these tabs",
    description: "Subtitle text to encourage a user to share tabs",
  },
  open_stack: {
    message: "Open stack",
    description: "Button text to manage a stack after",
  },
  keep: {
    message: "Keep",
    description:
      "Button label for keeping a suggestion (versus discarding it and getting a new suggestion).",
  },
  background: {
    message: "Background",
    description: "Text label to change background.",
  },
  failed_to_fetch_ml_suggestions: {
    message: "Failed to fetch suggestions.",
    description:
      "Snackbar text if a user cannot fetch suggestions from the server.",
  },
  failed_to_create_activity: {
    message: "Failed to create new activity.",
    description: "Snackbar text if a user cannot create a new activity.",
  },
  created_by_dash: {
    message: "Created by Dash",
    description: "Subtitle text indicating that Dash created this item.",
  },
  none: {
    message: "None",
    description: "Label to indicate there is no data",
  },
  suggested_by_dash: {
    message: "Suggested by Dash",
    description: "Title for the left column in Start Page V3",
  },
  calendar_notificaiton_turned_on_snackbar: {
    message: "Calendar notifications have been turned on.",
    description: "Label for the snackbar when the notification is turned on",
  },
  calendar_notificaiton_turned_off_snackbar: {
    message: "Calendar notifications have been turned off.",
    description: "Label for the snackbar when the notification is turned off",
  },
  turn_off_newtab: {
    message: "Use Dash start page (ON)",
    description: "Disable the start page experience.",
  },
  turn_on_newtab: {
    message: "Use Dash start page (OFF)",
    description: "Enable the start page experience.",
  },
  turn_off_action_bar: {
    message: "Show action bar (ON)",
    description: "Disable the action bar experience.",
  },
  turn_on_action_bar: {
    message: "Show action bar (OFF)",
    description: "Enable the action bar experience.",
  },
  help_and_support: {
    message: "Help and support",
    description: "Menu option from context menu for getting help",
  },
  assistant_header_generic_web_page_label: {
    message: "Web Page",
    description: "Label for a generic web page",
  },
  open_dash: {
    message: "Open Dash",
    description: "Label for button to open Dash",
  },
  no_of_stack_items: {
    message: "{{count}} items",
    description: "Label showing no of items in a stack.",
  },
  reload_extension: {
    message: "Reload extension",
    description: "Button text for reloading the browser extension.",
  },
  dropbox_dash: {
    message: "Dropbox Dash",
    description: "The name of the app.",
  },
  search_results: {
    message: "Search results from Dash",
    description: "Title for the search results card",
  },
  write_suggestion: {
    message: "Need a hand? Use related files to speed things up.",
    description: "Prompt to use Assist to write new content",
  },
  write_suggestion_minimalist: {
    message: "Write with Dash",
    description: "Prompt to use Assist to write new content",
  },
  dismiss_button: {
    message: "Dismiss",
    description: "Button text for dismissing a notification",
  },
  turn_off_button: {
    message: "Turn off",
    description: "Button text for turning off suggestion prompts",
  },
  show_more_count: {
    message: "Show {count, plural, one {# more} other {# more}}",
    description: "Button text for showing more items in a list",
  },
  show_more_count_one: {
    message: "Show {{count}} more",
    description: "Button text for showing more items in a list",
  },
  show_more_count_few: {
    message: "Show {{count}} more",
    description: "Button text for showing more items in a list",
  },
  show_more_count_many: {
    message: "Show {{count}} more",
    description: "Button text for showing more items in a list",
  },
  show_more_count_other: {
    message: "Show {{count}} more",
    description: "Button text for showing more items in a list",
  },
  write_document_with_title: {
    message: "Write a document titled “{{title}}” using these sources.",
    description:
      "Button text for asking Chat to write a document with a specific title",
  },
  invalid_url: {
    message: "Not a valid URL",
    description:
      "Message shown when user tries to add an invalid URL to a stack",
  },
  site_access_error_title: {
    message: "Couldn’t access site",
    description:
      "Title for the error page when the user does not have site access permission",
  },
  site_access_error_message: {
    message:
      "To use Dash as your new tab, go to extension settings and choose <bold>On all sites</bold> under <bold>Site access</bold>.",
    description:
      "Message for the error page when the user does not have site access permission",
  },
  extension_settings_button: {
    message: "Go to settings",
    description:
      "Button text to open the extension settings page in the browser",
  },
  disable_dash_start_page: {
    message: "Turn off Dash as new tab",
    description:
      "Button text to disable the Dash start page and set the new tab page to the default",
  },
  conversation_feedback_modal_title: {
    message: "Not what you expected? Fix it here.",
    description:
      "Title for a modal where a user can provide feedback about a conversation",
  },
  conversation_feedback_modal_subtitle: {
    message: "We’ll use your input to improve future answers — fast.",
    description:
      "Subtitle for a modal where a user can provide feedback about a conversation",
  },
  conversation_feedback_modal_chips_label: {
    message: "Click on any of these to get started",
    description:
      "Label for a series of chips the user can click to prepopulate feedback",
  },
  conversation_feedback_modal_feedback_label: {
    message: "Your feedback",
    description:
      "Label for the textarea where the user can provide feedback about a conversation",
  },
  conversation_feedback_modal_required: {
    message: "(required)",
    description: "Text indicating that the feedback field is required",
  },
  conversation_feedback_modal_optional: {
    message: "(optional)",
    description: "Text indicating that the feedback field is optional",
  },
  conversation_feedback_modal_feedback_placeholder: {
    message: "What did you expect the AI to say or do?",
    description:
      "Placeholder text shown in a textarea where a user can provide feedback about a conversation",
  },
  conversation_feedback_modal_submit_button: {
    message: "Submit correction",
    description: "Button text for submitting feedback about a conversation",
  },
  conversation_feedback_incorrect_tone_chip_label: {
    message: "Didn’t sound right",
    description:
      "Text shown on a button indicating that the tone of a conversation response was incorrect",
  },
  conversation_feedback_incorrect_tone_chip_feedback: {
    message: "It didn’t sound natural or match the tone I wanted.",
    description:
      "Prepopulated feedback text for when the tone of a conversation response was incorrect",
  },
  conversation_feedback_incorrect_length_chip_label: {
    message: "Too much or too little",
    description:
      "Text shown on a button indicating that the length of a conversation response was incorrect",
  },
  conversation_feedback_incorrect_length_chip_feedback: {
    message: "It was either too long, too short, too detailed, or too basic.",
    description:
      "Prepopulated feedback text for when the length of a conversation response was incorrect",
  },
  conversation_feedback_incorrect_input_comprehension_chip_label: {
    message: "Didn’t understand what I meant",
    description:
      "Text shown on a button indicating that the AI did not understand the user's input correctly",
  },
  conversation_feedback_incorrect_input_comprehension_chip_feedback: {
    message: "It missed what I was actually trying to say or ask.",
    description:
      "Prepopulated feedback text for when the AI did not understand the user's input correctly",
  },
  conversation_feedback_unhelpful_chip_label: {
    message: "Didn’t help",
    description:
      "Text shown on a button indicating that the AI response was not helpful",
  },
  conversation_feedback_unhelpful_chip_feedback: {
    message: "It wasn’t useful or relevant to what I needed to do.",
    description:
      "Prepopulated feedback text for when the AI response was not helpful",
  },
  conversation_feedback_modal_disclaimer: {
    message:
      "Dropbox already has information about your chat session for quality purposes. We’ll review your feedback to improve Dash. Learn more in our <ppLink>Privacy Policy</ppLink>.",
    description:
      "Informational disclaimer shown on the conversation feedback modal to alert the user to the data Dropbox collects about their chat session and how it is used.",
  },
  conversation_feedback_modal_ticket_title_label: {
    message: "Jira ticket title",
    description:
      "Label for an input field on the conversation feedback modal shown only to internal users that allows them to supply a title for their feedback ticket in Jira",
  },
  conversation_feedback_modal_ticket_title_placeholder: {
    message: "Conversation User Feedback",
    description:
      "Placeholder text for the Jira ticket title input field on the conversation feedback modal",
  },
  already_in_stack: {
    message: "Already in this stack",
    description:
      "Message shown on a disabled checkmark button to indicate an item that is already in the stack",
  },
  compose_error_loading_content_inside_another_extension: {
    message:
      "Unable to read the document opened inside another browser extension.",
    description:
      "Error message for compose chat due to error loading source content",
  },
  compose_num_steps_one: {
    message: "{{count}} step",
    description: "Number of steps in workflow setup",
  },
  compose_num_steps_few: {
    message: "{{count}} steps",
    description: "Number of steps in workflow setup",
  },
  compose_num_steps_many: {
    message: "{{count}} steps",
    description: "Number of steps in workflow setup",
  },
  compose_num_steps_other: {
    message: "{{count}} steps",
    description: "Number of steps in workflow setup",
  },
  assistant_how_can_i_help: {
    message: "How can I help?",
    description: "Default message coming from the AI in the browser extension",
  },
  assistant_how_can_i_help_new_page: {
    message: "Read new page. How can I help?",
    description:
      "Default message coming from the AI in the browser extension when a new page is opened",
  },
  see_full_summary: {
    message: "See full summary",
    description: "Button text for viewing the full summary of a page",
  },
  related: {
    message: "Related",
    description: "Section title for relevant files & pages",
  },
  assistant_message_calendar_card_follow_up_prompt: {
    message: "Is there anything else I can find for you from your calendar?",
    description:
      "Prompt from the assistant message calendar card asking if the user needs more help",
  },
  documents_category: {
    message: "Documents",
    description: "Label for the documents section in the sidebar",
  },
  messages_category: {
    message: "Messages",
    description: "Label for the messages section in the sidebar",
  },
  email_category: {
    message: "Emails",
    description: "Label for the emails section in the sidebar",
  },
  see_more_count: {
    message: "See {{count}}+ more",
    description: "Button text for showing more items in a list",
  },
  top_results: {
    message: "Top results",
    description: "Label for the top results section in the chat",
  },
  see_all_chat_results: {
    message: "See all",
    description: "Button text for seeing all results in the chat",
  },
  folders_category: {
    message: "Folders",
    description: "Label for the folders section in the sidebar",
  },
  presentation_category: {
    message: "Presentations",
    description: "Label for the presentations section in the sidebar",
  },
  meeting_attendee_one: {
    message: "{{count}} attendee",
    description: "Label for a single attendee for a meeting",
  },
  meeting_attendee_few: {
    message: "{{count}} attendee",
    description: "Label for a few attendees for a meeting",
  },
  meeting_attendee_many: {
    message: "{{count}} attendees",
    description: "Label for many attendees for a meeting",
  },
  meeting_attendee_other: {
    message: "{{count}} attendees",
    description: "Label for other attendees for a meeting",
  },
  spreadsheet_category: {
    message: "Spreadsheets",
    description: "Label for the spreadsheets section in the sidebar",
  },
  pdf_category: {
    message: "PDFs",
    description: "Label for the PDFs section in the sidebar",
  },
  events_category: {
    message: "Events",
    description: "Label for the events section in the sidebar",
  },
  count_plus: {
    message: "{{count}}+",
    description:
      "Label for showing a count of items plus more not included in the count",
  },
  page_of_total: {
    message: "Page {{currentPage}} of {{totalPages}}",
    description:
      "Label for the page number and total pages in the document preview modal",
  },
  saved_in_label: {
    message: "Saved in",
    description:
      "Label for the saved in section in the sidebar of the document preview modal",
  },
  source_label: {
    message: "Source",
    description:
      "Label for the source section in the sidebar of the document preview modal",
  },
  file_size_label: {
    message: "File size",
    description:
      "Label for the file size section in the sidebar of the document preview modal",
  },
  file_size_unit_b: {
    message: "{{size}} B",
    description: "File size unit for bytes",
  },
  file_size_unit_kb: {
    message: "{{size}} KB",
    description: "File size unit for kilobytes",
  },
  file_size_unit_mb: {
    message: "{{size}} MB",
    description: "File size unit for megabytes",
  },
  file_size_unit_gb: {
    message: "{{size}} GB",
    description: "File size unit for gigabytes",
  },
  file_size_unit_tb: {
    message: "{{size}} TB",
    description: "File size unit for terabytes",
  },
  created_label: {
    message: "Created",
    description:
      "Label for the created section in the sidebar of the document preview modal",
  },
  follow_up_label: {
    message: "Follow up",
    description:
      "Label for the follow up section in the sidebar of the document preview modal",
  },
  no_preview_available: {
    message: "No preview available",
    description:
      "Message shown when there is no preview available for a document",
  },
  document_preview_label: {
    message: "Document preview",
    description:
      "Label for the document preview section in the document preview modal",
  },
  document_preview_alt: {
    message: "Document preview for {{title}}",
    description:
      "Alt text for the document preview image in the document preview modal",
  },
  chat_history: {
    message: "Chat history",
    description: "Label for button that links to Chat Recent Sessions",
  },
  summarize_this_tab: {
    message: "Summarize this tab",
    description: "Button text for summarizing the current tab content",
  },
  unknown: {
    message: "Unknown",
    description: "Label for unknown user or date",
  },
  placeholder_source: {
    message: "Unknown",
    description:
      "Placeholder text for the source section in the document preview modal when the document is not saved in a folder",
  },
  dash: {
    message: "Dash",
    description: "Title for chat iframe",
  },
  welcome_to_dash: {
    message: "Welcome to the full Dash experience",
    description: "Title on Bridge onboarding modal",
  },
  welcome_search_blurb: {
    message: "Search across all your apps",
    description: "Search related blurb on welcome modal",
  },
  welcome_ask_blurb: {
    message: "Ask questions for fast answers",
    description: "Ask related blurb on welcome modal",
  },
  welcome_write_blurb: {
    message: "Draft and deliver something great",
    description: "Assistant related blurb on welcome modal",
  },
  add_apps_modal_welcome: {
    message: "Welcome to the full Dash experience",
    description: "Welcome message for the modal that prompts users to add apps",
  },
  add_apps_modal_welcome_sub_header: {
    message:
      "Add the apps you use every day. Then use Dash to help you find, draft, and deliver work.",
    description: "Sub header for the modal that prompts users to add apps",
  },
  workflow_agent_private_source_warning: {
    message:
      "All document content in this tool will be copied and made available to anyone with access to the tool.",
    description:
      "Warning message shown when a private source is added to a workflow agent",
  },
  show_all: {
    message: "Show all",
    description: "Label button to show all items.",
  },
  open_dash_in_new_tab: {
    message: "Open Dash in a new tab",
    description: "Button text for opening Dash in a new tab",
  },
  auth_confirm_success_title: {
    message: "{{appName}} is added",
    description:
      "Title shown after a user successfully authenticates a new connector",
  },
  auth_confirm_success_message: {
    message: "Your content is syncing. We’ll email you when it’s ready.",
    description:
      "Message shown after a user successfully authenticates a new connector",
  },
  apps_syncing: {
    message: "Apps syncing",
    description: "Global nav icon label for when apps are syncing",
  },
  apps_initial_sync_tooltip: {
    message: "Your content is syncing.",
    description:
      "The message shown to the user when hovering over the apps global nav icon during sync",
  },
  unavailable_sources_banner_one: {
    message: "{{count}} file unavailable",
    description: "Message shown when some files are unavailable",
  },
  unavailable_sources_banner_other: {
    message: "{{count}} files unavailable",
    description: "Message shown when some files are unavailable",
  },
  stacks_empty_state_embed_title: {
    message: "Showcase your work the way you want to",
    description:
      "Title for the empty state of the stacks management page, when embedded in FSS",
  },
  stacks_empty_state_embed_group_related_files: {
    message:
      "<bold>Group related files</bold> into curated collections called stacks.",
    description:
      "Body for the empty state of the stacks management page, when embedded in FSS. NOTE: Try to keep bolded portion at the beginning of the message.",
  },
  stacks_empty_state_embed_personalize_the_branding: {
    message:
      "<bold>Personalize the branding</bold> with a custom name and cover image.",
    description:
      "Body for the empty state of the stacks management page, when embedded in FSS. NOTE: Try to keep bolded portion at the beginning of the message.",
  },
  stacks_empty_state_embed_share_with_anyone: {
    message:
      "<bold>Share with anyone.</bold> They can use AI-powered chat to get quick answers about anything in the stack.",
    description:
      "Body for the empty state of the stacks management page, when embedded in FSS. NOTE: Try to keep bolded portion at the beginning of the message.",
  },
  stacks_empty_state_embed_button: {
    message: "Add files",
    description:
      "Button text for the empty state of the stacks management page.",
  },
  document_preview_null_message: {
    message: "this document",
    description:
      "Message shown when there is no title available for a document",
  },
  all_stacks_embed_title_name: {
    message: "Name",
    description:
      "Row title for the name column in the all stacks list when embedded",
  },
  all_stacks_embed_title_type: {
    message: "Type",
    description:
      "Row title for the name column in the all stacks list when embedded",
  },
  all_stacks_embed_title_who_can_access: {
    message: "Who can access",
    description:
      "Row title for the name column in the all stacks list when embedded",
  },
  all_stacks_embed_title_last_opened: {
    message: "Last opened",
    description:
      "Row title for the name column in the all stacks list when embedded",
  },
  context_picker_dash_search_label_for_fss: {
    message: "All files",
    description:
      "Label for the all files search option in the context picker for FSS",
  },
  context_picker_dash_search_description_for_fss: {
    message: "All your files in Dropbox",
    description:
      "Description for the all files search option in the context picker for FSS",
  },
  something_went_wrong: {
    message: "Uhh ohh! Something went wrong.",
    description: "Title for the error fallback",
  },
  something_went_wrong_description: {
    message:
      "Something didn’t go as planned — but don’t worry, it’s likely temporary. Try refreshing the page to get back on track.",
    description: "Description for the error fallback",
  },
  refresh_page: {
    message: "Refresh page",
    description: "Button text for refreshing the page",
  },
  add_sources: {
    message: "Add sources",
    description: "Button text for adding more sources to a chat",
  },
} as const satisfies TransObjShape;
